import _objectWithoutProperties3 from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray3 from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread2 from "/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import require$$0 from "react-dom";
import require$$0$1, { forwardRef, Children, isValidElement, createElement, cloneElement, Fragment } from "react";
var devConfig = {
  LOGROCKET_KEY: "akwp12",
  LOGROCKET_APP_PROJECT: "drift-app-qa"
};
var prodConfig = {
  LOGROCKET_KEY: "akwp12",
  LOGROCKET_APP_PROJECT: "drift-app"
};
var config = window.__ENV__ === "PRODUCTION" ? prodConfig : devConfig;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

var build_umd = {
  exports: {}
};

(function (module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    return function () {
      var __webpack_modules__ = {
        "./packages/@logrocket/arson/src/index.js": function packagesLogrocketArsonSrcIndexJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.encode = encode;
          exports2.decode = decode;

          var _typeof2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js"));

          var UNDEFINED_INDEX = -1;
          var ARRAY_HOLE_INDEX = -2;
          var NAN_INDEX = -3;
          var POS_INF_INDEX = -4;
          var NEG_INF_INDEX = -5;
          var customTypes = /* @__PURE__ */Object.create(null);

          var registerType = function registerType2(typeName, handlers) {
            function check(methodName) {
              if (typeof handlers[methodName] !== "function") {
                throw new Error("second argument to ARSON.registerType(" + JSON.stringify(typeName) + ", ...) must be an object with a " + methodName + " method");
              }
            }

            check("deconstruct");
            check("reconstruct");
            customTypes[typeName] = handlers;
          };

          var toString = Object.prototype.toString;
          var dateTag = "[object Date]";
          var regExpTag = "[object RegExp]";
          var setTag = "[object Set]";
          var mapTag = "[object Map]";
          typeof Buffer === "function" && typeof Buffer.isBuffer === "function" && registerType("Buffer", {
            deconstruct: function deconstruct(buf) {
              return Buffer.isBuffer(buf) && [buf.toString("base64"), "base64"];
            },
            reconstruct: function reconstruct(args) {
              return args && Buffer.from(args[0], args[1]);
            }
          });
          registerType("Date", {
            deconstruct: function deconstruct(date) {
              return toString.call(date) === dateTag && [date.toJSON()];
            },
            reconstruct: function reconstruct(args) {
              return args && new Date(args[0]);
            }
          });
          registerType("RegExp", {
            deconstruct: function deconstruct(exp) {
              if (toString.call(exp) === regExpTag) {
                var args = [exp.source];
                var flags = "";
                if (exp.ignoreCase) flags += "i";
                if (exp.multiline) flags += "m";
                if (exp.global) flags += "g";

                if (flags) {
                  args.push(flags);
                }

                return args;
              }
            },
            reconstruct: function reconstruct(args) {
              return args && new RegExp(args[0], args[1]);
            }
          });
          typeof Set === "function" && typeof Array.from === "function" && registerType("Set", {
            deconstruct: function deconstruct(set) {
              if (toString.call(set) === setTag) {
                return Array.from(set);
              }
            },
            reconstruct: function reconstruct(values) {
              if (values) {
                values.forEach(this.add, this);
              } else {
                return /* @__PURE__ */new Set();
              }
            }
          });
          typeof Map === "function" && typeof Array.from === "function" && registerType("Map", {
            deconstruct: function deconstruct(map) {
              if (toString.call(map) === mapTag) {
                return Array.from(map);
              }
            },
            reconstruct: function reconstruct(entries) {
              if (entries) {
                entries.forEach(function (entry) {
                  this.set(entry[0], entry[1]);
                }, this);
              } else {
                return /* @__PURE__ */new Map();
              }
            }
          });

          function encode(value) {
            return JSON.stringify(toTable(value));
          }

          function toTable(value) {
            var values = [];
            var indexMap = typeof Map === "function" && /* @__PURE__ */new Map();

            function getIndex(value2) {
              switch ((0, _typeof2.default)(value2)) {
                case "undefined":
                  return UNDEFINED_INDEX;

                case "number":
                  if (isNaN(value2)) {
                    return NAN_INDEX;
                  }

                  if (!isFinite(value2)) {
                    return value2 < 0 ? NEG_INF_INDEX : POS_INF_INDEX;
                  }

              }

              var index;

              if (indexMap) {
                index = indexMap.get(value2);

                if (typeof index === "undefined") {
                  index = values.push(value2) - 1;
                  indexMap.set(value2, index);
                }
              } else {
                index = values.indexOf(value2);

                if (index < 0) {
                  index = values.push(value2) - 1;
                }
              }

              return index;
            }

            function copy(value2) {
              var result = value2;

              if (value2 && (0, _typeof2.default)(value2) === "object") {
                var keys = Object.keys(value2);

                if (isPlainObject(value2)) {
                  result = {};
                } else if (Array.isArray(value2)) {
                  result = Array(value2.length);
                  var len = value2.length;

                  if (len > keys.length) {
                    for (var i = 0; i < len; ++i) {
                      result[i] = ARRAY_HOLE_INDEX;
                    }
                  }
                } else {
                  for (var typeName in customTypes) {
                    var args = customTypes[typeName].deconstruct(value2);

                    if (args) {
                      for (var i = 0; i < args.length; ++i) {
                        args[i] = getIndex(args[i]);
                      }

                      args.unshift(typeName);
                      return args;
                    }
                  }

                  return {}.toString.call(value2);
                }

                keys.forEach(function (key) {
                  result[key] = getIndex(value2[key]);
                });
              }

              return result;
            }

            var index0 = getIndex(value);

            if (index0 < 0) {
              return index0;
            }

            for (var table = [], v = 0; v < values.length; ++v) {
              table[v] = copy(values[v]);
            }

            return table;
          }

          function isPlainObject(value) {
            var isObject = value && (0, _typeof2.default)(value) === "object";

            if (isObject) {
              var proto = Object.getPrototypeOf ? Object.getPrototypeOf(value) : value.__proto__;
              return proto === Object.prototype;
            }

            return false;
          }

          function decode(encoding) {
            return fromTable(JSON.parse(encoding));
          }

          function fromTable(table) {
            if (typeof table === "number" && table < 0) {
              return getValueWithoutCache(table);
            }

            var getValueCache = new Array(table.length);

            function getValue(index) {
              return index in getValueCache ? getValueCache[index] : getValueCache[index] = getValueWithoutCache(index);
            }

            function getValueWithoutCache(index) {
              if (index < 0) {
                if (index === UNDEFINED_INDEX) {
                  return;
                }

                if (index === ARRAY_HOLE_INDEX) {
                  return;
                }

                if (index === NAN_INDEX) {
                  return NaN;
                }

                if (index === POS_INF_INDEX) {
                  return Infinity;
                }

                if (index === NEG_INF_INDEX) {
                  return -Infinity;
                }

                throw new Error("invalid ARSON index: " + index);
              }

              var entry = table[index];

              if (entry && (0, _typeof2.default)(entry) === "object") {
                if (Array.isArray(entry)) {
                  var elem0 = entry[0];

                  if (typeof elem0 === "string" && elem0 in customTypes) {
                    var rec = customTypes[elem0].reconstruct;
                    var empty = rec();

                    if (empty) {
                      containers.push({
                        reconstruct: rec,
                        empty,
                        argIndexes: entry.slice(1)
                      });
                    }

                    return table[index] = empty || rec(entry.slice(1).map(getValue));
                  }
                }

                objects.push(entry);
              }

              return entry;
            }

            var containers = [];
            var objects = [];
            table.forEach(function (entry, i) {
              getValue(i);
            });
            containers.forEach(function (c) {
              c.args = c.argIndexes.map(getValue);
            });
            objects.forEach(function (obj) {
              Object.keys(obj).forEach(function (key) {
                var index = obj[key];

                if (typeof index !== "number") {
                  return;
                }

                if (index < 0) {
                  if (index === ARRAY_HOLE_INDEX) {
                    delete obj[key];
                    return;
                  }

                  obj[key] = getValue(index);
                } else {
                  obj[key] = table[index];
                }
              });
            });
            containers.forEach(function (c) {
              c.reconstruct.call(c.empty, c.args);
            });
            return table[0];
          }
        },
        "./packages/@logrocket/console/src/index.js": function packagesLogrocketConsoleSrcIndexJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = void 0;

          var _registerConsole = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/console/src/registerConsole.js"));

          var _default = _registerConsole.default;
          exports2["default"] = _default;
        },
        "./packages/@logrocket/console/src/registerConsole.js": function packagesLogrocketConsoleSrcRegisterConsoleJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = registerConsole;

          var _typeof2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js"));

          var _enhanceFunc = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/enhanceFunc.js"));

          var _exceptions = __webpack_require__2("./packages/@logrocket/exceptions/src/index.js");

          function registerConsole(logger) {
            var unsubFunctions = [];
            var methods = ["log", "warn", "info", "error", "debug"];
            methods.forEach(function (method) {
              unsubFunctions.push((0, _enhanceFunc.default)(console, method, function () {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                logger.addEvent("lr.core.LogEvent", function () {
                  var consoleOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                  var isEnabled = consoleOptions.isEnabled;

                  if ((0, _typeof2.default)(isEnabled) === "object" && isEnabled[method] === false || isEnabled === false) {
                    return null;
                  }

                  if (method === "error" && consoleOptions.shouldAggregateConsoleErrors) {
                    _exceptions.Capture.captureMessage(logger, args[0], args, {}, true);
                  }

                  return {
                    logLevel: method.toUpperCase(),
                    args
                  };
                });
              }));
            });
            return function () {
              unsubFunctions.forEach(function (unsubFunction) {
                return unsubFunction();
              });
            };
          }
        },
        "./packages/@logrocket/exceptions/src/Capture.js": function packagesLogrocketExceptionsSrcCaptureJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.captureMessage = captureMessage;
          exports2.captureException = captureException;

          var _typeof2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js"));

          var _TraceKit = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/TraceKit.js"));

          var _stackTraceFromError = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/exceptions/src/stackTraceFromError.js"));

          function isScalar(value) {
            return /boolean|number|string/.test((0, _typeof2.default)(value));
          }

          function scrub(data, options) {
            if (options) {
              var optionalScalars = ["level", "logger"];

              for (var _i = 0, _optionalScalars = optionalScalars; _i < _optionalScalars.length; _i++) {
                var field = _optionalScalars[_i];
                var value = options[field];

                if (isScalar(value)) {
                  data[field] = value.toString();
                }
              }

              var optionalMaps = ["tags", "extra"];

              for (var _i2 = 0, _optionalMaps = optionalMaps; _i2 < _optionalMaps.length; _i2++) {
                var _field = _optionalMaps[_i2];
                var dirty = options[_field] || {};
                var scrubbed = {};

                for (var _i3 = 0, _Object$keys = Object.keys(dirty); _i3 < _Object$keys.length; _i3++) {
                  var key = _Object$keys[_i3];
                  var _value = dirty[key];

                  if (isScalar(_value)) {
                    scrubbed[key.toString()] = _value.toString();
                  }
                }

                data[_field] = scrubbed;
              }
            }
          }

          function captureMessage(logger, message, messageArgs) {
            var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
            var isConsole = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
            var data = {
              exceptionType: isConsole ? "CONSOLE" : "MESSAGE",
              message,
              messageArgs,
              browserHref: window.location ? window.location.href : ""
            };
            scrub(data, options);
            logger.addEvent("lr.core.Exception", function () {
              return data;
            });
          }

          function captureException(logger, exception) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            var preppedTrace = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;

            var trace = preppedTrace || _TraceKit.default.computeStackTrace(exception);

            var data = {
              exceptionType: "WINDOW",
              errorType: trace.name,
              message: trace.message,
              browserHref: window.location ? window.location.href : ""
            };
            scrub(data, options);
            var addEventOptions = {
              _stackTrace: (0, _stackTraceFromError.default)(trace)
            };
            logger.addEvent("lr.core.Exception", function () {
              return data;
            }, addEventOptions);
          }
        },
        "./packages/@logrocket/exceptions/src/index.js": function packagesLogrocketExceptionsSrcIndexJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          var _typeof = __webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          Object.defineProperty(exports2, "registerExceptions", {
            enumerable: true,
            get: function get() {
              return _registerExceptions.default;
            }
          });
          exports2.Capture = void 0;

          var _registerExceptions = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/exceptions/src/registerExceptions.js"));

          var Capture = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/exceptions/src/Capture.js"));

          exports2.Capture = Capture;

          function _getRequireWildcardCache(nodeInterop) {
            if (typeof WeakMap !== "function") return null;
            var cacheBabelInterop = /* @__PURE__ */new WeakMap();
            var cacheNodeInterop = /* @__PURE__ */new WeakMap();
            return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
              return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
            })(nodeInterop);
          }

          function _interopRequireWildcard(obj, nodeInterop) {
            if (!nodeInterop && obj && obj.__esModule) {
              return obj;
            }

            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }

            var cache = _getRequireWildcardCache(nodeInterop);

            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }

            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var key in obj) {
              if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }

            newObj.default = obj;

            if (cache) {
              cache.set(obj, newObj);
            }

            return newObj;
          }
        },
        "./packages/@logrocket/exceptions/src/raven/raven.js": function packagesLogrocketExceptionsSrcRavenRavenJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = void 0;

          var _classCallCheck2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/classCallCheck.js"));

          var _createClass2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/createClass.js"));

          var _TraceKit = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/TraceKit.js"));

          var objectPrototype = Object.prototype;

          function isUndefined(what) {
            return what === void 0;
          }

          function isFunction(what) {
            return typeof what === "function";
          }

          function hasKey(object, key) {
            return objectPrototype.hasOwnProperty.call(object, key);
          }

          function fill(obj, name, replacement, track) {
            var orig = obj[name];
            obj[name] = replacement(orig);

            if (track) {
              track.push([obj, name, orig]);
            }
          }

          var _window = typeof window !== "undefined" ? window : typeof __webpack_require__2.g !== "undefined" ? __webpack_require__2.g : typeof self !== "undefined" ? self : {};

          _window.document;

          var Handler = /* @__PURE__ */function () {
            function Handler2(_ref) {
              var captureException = _ref.captureException;
              (0, _classCallCheck2.default)(this, Handler2);
              this._errorHandler = this._errorHandler.bind(this);
              this._ignoreOnError = 0;
              this._wrappedBuiltIns = [];
              this.captureException = captureException;

              _TraceKit.default.report.subscribe(this._errorHandler);

              this._instrumentTryCatch();
            }

            (0, _createClass2.default)(Handler2, [{
              key: "uninstall",
              value: function uninstall() {
                _TraceKit.default.report.unsubscribe(this._errorHandler);

                var builtin;

                while (this._wrappedBuiltIns.length) {
                  builtin = this._wrappedBuiltIns.shift();
                  var obj = builtin[0],
                      name = builtin[1],
                      orig = builtin[2];
                  obj[name] = orig;
                }
              }
            }, {
              key: "_errorHandler",
              value: function _errorHandler(report) {
                if (!this._ignoreOnError) {
                  this.captureException(report);
                }
              }
            }, {
              key: "_ignoreNextOnError",
              value: function _ignoreNextOnError() {
                var _this = this;

                this._ignoreOnError += 1;
                setTimeout(function () {
                  _this._ignoreOnError -= 1;
                });
              }
            }, {
              key: "context",
              value: function context(options, func, args) {
                if (isFunction(options)) {
                  args = func || [];
                  func = options;
                  options = void 0;
                }

                return this.wrap(options, func).apply(this, args);
              }
            }, {
              key: "wrap",
              value: function wrap(options, func, _before) {
                var self2 = this;

                if (isUndefined(func) && !isFunction(options)) {
                  return options;
                }

                if (isFunction(options)) {
                  func = options;
                  options = void 0;
                }

                if (!isFunction(func)) {
                  return func;
                }

                try {
                  if (func.__lr__) {
                    return func;
                  }

                  if (func.__lr_wrapper__) {
                    return func.__lr_wrapper__;
                  }

                  if (!Object.isExtensible(func)) {
                    return func;
                  }
                } catch (e) {
                  return func;
                }

                function wrapped() {
                  var args = [],
                      i = arguments.length,
                      deep = !options || options && options.deep !== false;

                  if (_before && isFunction(_before)) {
                    _before.apply(this, arguments);
                  }

                  while (i--) {
                    args[i] = deep ? self2.wrap(options, arguments[i]) : arguments[i];
                  }

                  try {
                    return func.apply(this, args);
                  } catch (e) {
                    self2._ignoreNextOnError();

                    self2.captureException(_TraceKit.default.computeStackTrace(e), options);
                    throw e;
                  }
                }

                for (var property in func) {
                  if (hasKey(func, property)) {
                    wrapped[property] = func[property];
                  }
                }

                wrapped.prototype = func.prototype;
                func.__lr_wrapper__ = wrapped;
                wrapped.__lr__ = true;
                wrapped.__inner__ = func;
                return wrapped;
              }
            }, {
              key: "_instrumentTryCatch",
              value: function _instrumentTryCatch() {
                var self2 = this;
                var wrappedBuiltIns = self2._wrappedBuiltIns;

                function wrapTimeFn(orig) {
                  return function (fn, t) {
                    var args = new Array(arguments.length);

                    for (var i2 = 0; i2 < args.length; ++i2) {
                      args[i2] = arguments[i2];
                    }

                    var originalCallback = args[0];

                    if (isFunction(originalCallback)) {
                      args[0] = self2.wrap(originalCallback);
                    }

                    if (orig.apply) {
                      return orig.apply(this, args);
                    } else {
                      return orig(args[0], args[1]);
                    }
                  };
                }

                function wrapEventTarget(global2) {
                  var proto = _window[global2] && _window[global2].prototype;

                  if (proto && proto.hasOwnProperty && proto.hasOwnProperty("addEventListener")) {
                    fill(proto, "addEventListener", function (orig) {
                      return function (evtName, fn, capture, secure) {
                        try {
                          if (fn && fn.handleEvent) {
                            fn.handleEvent = self2.wrap(fn.handleEvent);
                          }
                        } catch (err) {}

                        var before;
                        return orig.call(this, evtName, self2.wrap(fn, void 0, before), capture, secure);
                      };
                    }, wrappedBuiltIns);
                    fill(proto, "removeEventListener", function (orig) {
                      return function (evt, fn, capture, secure) {
                        try {
                          fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
                        } catch (e) {}

                        return orig.call(this, evt, fn, capture, secure);
                      };
                    }, wrappedBuiltIns);
                  }
                }

                fill(_window, "setTimeout", wrapTimeFn, wrappedBuiltIns);
                fill(_window, "setInterval", wrapTimeFn, wrappedBuiltIns);

                if (_window.requestAnimationFrame) {
                  fill(_window, "requestAnimationFrame", function (orig) {
                    return function (cb) {
                      return orig(self2.wrap(cb));
                    };
                  }, wrappedBuiltIns);
                }

                var eventTargets = ["EventTarget", "Window", "Node", "ApplicationCache", "AudioTrackList", "ChannelMergerNode", "CryptoOperation", "EventSource", "FileReader", "HTMLUnknownElement", "IDBDatabase", "IDBRequest", "IDBTransaction", "KeyOperation", "MediaController", "MessagePort", "ModalWindow", "Notification", "SVGElementInstance", "Screen", "TextTrack", "TextTrackCue", "TextTrackList", "WebSocket", "WebSocketWorker", "Worker", "XMLHttpRequest", "XMLHttpRequestEventTarget", "XMLHttpRequestUpload"];

                for (var i = 0; i < eventTargets.length; i++) {
                  wrapEventTarget(eventTargets[i]);
                }

                var $ = _window.jQuery || _window.$;

                if ($ && $.fn && $.fn.ready) {
                  fill($.fn, "ready", function (orig) {
                    return function (fn) {
                      return orig.call(this, self2.wrap(fn));
                    };
                  }, wrappedBuiltIns);
                }
              }
            }]);
            return Handler2;
          }();

          exports2["default"] = Handler;
        },
        "./packages/@logrocket/exceptions/src/registerExceptions.js": function packagesLogrocketExceptionsSrcRegisterExceptionsJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          var _typeof = __webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = registerCore;

          var _raven = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/exceptions/src/raven/raven.js"));

          var Capture = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/exceptions/src/Capture.js"));

          function _getRequireWildcardCache(nodeInterop) {
            if (typeof WeakMap !== "function") return null;
            var cacheBabelInterop = /* @__PURE__ */new WeakMap();
            var cacheNodeInterop = /* @__PURE__ */new WeakMap();
            return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
              return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
            })(nodeInterop);
          }

          function _interopRequireWildcard(obj, nodeInterop) {
            if (!nodeInterop && obj && obj.__esModule) {
              return obj;
            }

            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }

            var cache = _getRequireWildcardCache(nodeInterop);

            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }

            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var key in obj) {
              if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }

            newObj.default = obj;

            if (cache) {
              cache.set(obj, newObj);
            }

            return newObj;
          }

          function registerCore(logger) {
            var raven = new _raven.default({
              captureException: function captureException(errorReport) {
                Capture.captureException(logger, null, null, errorReport);
              }
            });

            var rejectionHandler = function rejectionHandler2(evt) {
              logger.addEvent("lr.core.Exception", function () {
                return {
                  exceptionType: "UNHANDLED_REJECTION",
                  message: evt.reason || "Unhandled Promise rejection"
                };
              });
            };

            window.addEventListener("unhandledrejection", rejectionHandler);
            return function () {
              window.removeEventListener("unhandledrejection", rejectionHandler);
              raven.uninstall();
            };
          }
        },
        "./packages/@logrocket/exceptions/src/stackTraceFromError.js": function packagesLogrocketExceptionsSrcStackTraceFromErrorJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = stackTraceFromError;

          function stackTraceFromError(errorReport) {
            function makeNotNull(val) {
              return val === null ? void 0 : val;
            }

            return errorReport.stack ? errorReport.stack.map(function (frame) {
              return {
                lineNumber: makeNotNull(frame.line),
                columnNumber: makeNotNull(frame.column),
                fileName: makeNotNull(frame.url),
                functionName: makeNotNull(frame.func)
              };
            }) : void 0;
          }
        },
        "./packages/@logrocket/network/src/fetchIntercept.js": function packagesLogrocketNetworkSrcFetchInterceptJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = void 0;

          var _toConsumableArray2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/toConsumableArray.js"));

          var _registerXHR = __webpack_require__2("./packages/@logrocket/network/src/registerXHR.js");

          var interceptors = [];

          function makeInterceptor(fetch, fetchId) {
            var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
              return [interceptor].concat(array);
            }, []);

            for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
              args[_key - 2] = arguments[_key];
            }

            var promise = Promise.resolve(args);
            reversedInterceptors.forEach(function (_ref) {
              var request = _ref.request,
                  requestError = _ref.requestError;

              if (request || requestError) {
                promise = promise.then(function (args2) {
                  return request.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args2)));
                }, function (args2) {
                  return requestError.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args2)));
                });
              }
            });
            promise = promise.then(function (args2) {
              (0, _registerXHR.setActive)(false);
              var res;
              var err;

              try {
                res = fetch.apply(void 0, (0, _toConsumableArray2.default)(args2));
              } catch (_err) {
                err = _err;
              }

              (0, _registerXHR.setActive)(true);

              if (err) {
                throw err;
              }

              return res;
            });
            reversedInterceptors.forEach(function (_ref2) {
              var response = _ref2.response,
                  responseError = _ref2.responseError;

              if (response || responseError) {
                promise = promise.then(function (res) {
                  return response(fetchId, res);
                }, function (err) {
                  return responseError && responseError(fetchId, err);
                });
              }
            });
            return promise;
          }

          function attach(env) {
            if (!env.fetch || !env.Promise) {
              return;
            }

            var isPolyfill = env.fetch.polyfill;

            env.fetch = function (fetch) {
              var fetchId = 0;
              return function () {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }

                return makeInterceptor.apply(void 0, [fetch, fetchId++].concat(args));
              };
            }(env.fetch);

            if (isPolyfill) {
              env.fetch.polyfill = isPolyfill;
            }
          }

          var didAttach = false;
          var _default = {
            register: function register(interceptor) {
              if (!didAttach) {
                didAttach = true;
                attach(window);
              }

              interceptors.push(interceptor);
              return function () {
                var index = interceptors.indexOf(interceptor);

                if (index >= 0) {
                  interceptors.splice(index, 1);
                }
              };
            },
            clear: function clear() {
              interceptors = [];
            }
          };
          exports2["default"] = _default;
        },
        "./packages/@logrocket/network/src/index.js": function packagesLogrocketNetworkSrcIndexJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = registerNetwork;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _typeof2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js"));

          var _registerFetch = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/network/src/registerFetch.js"));

          var _registerIonic = __webpack_require__2("./packages/@logrocket/network/src/registerIonic.ts");

          var _registerNetworkInformation = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/network/src/registerNetworkInformation.js"));

          var _registerXHR = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/network/src/registerXHR.js"));

          var _mapValues = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/mapValues.js"));

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              enumerableOnly && (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })), keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2.default)(target, key, source[key]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }

            return target;
          }

          function registerNetwork(logger) {
            var config2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
              isReactNative: false
            };
            var isReactNative = config2.isReactNative,
                shouldAugmentNPS = config2.shouldAugmentNPS,
                shouldParseXHRBlob = config2.shouldParseXHRBlob;
            var ignoredNetwork = {};

            var truncate = function truncate2(data) {
              var limit = 1024 * 1e3 * 4;
              var str = data;

              if ((0, _typeof2.default)(data) === "object" && data != null) {
                var proto = Object.getPrototypeOf(data);

                if (proto === Object.prototype || proto === null) {
                  str = JSON.stringify(data);
                }
              }

              if (str && str.length && str.length > limit && typeof str === "string") {
                var beginning = str.substring(0, 1e3);
                return "".concat(beginning, " ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference/network");
              }

              return data;
            };

            var addRequest = function addRequest2(reqId, request) {
              var method = request.method;
              logger.addEvent("lr.network.RequestEvent", function () {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                    _ref$isEnabled = _ref.isEnabled,
                    isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
                    _ref$requestSanitizer = _ref.requestSanitizer,
                    requestSanitizer = _ref$requestSanitizer === void 0 ? function (f2) {
                  return f2;
                } : _ref$requestSanitizer;

                if (!isEnabled) {
                  return null;
                }

                var sanitized = null;

                try {
                  sanitized = requestSanitizer(_objectSpread(_objectSpread({}, request), {}, {
                    reqId
                  }));
                } catch (err) {
                  console.error(err);
                }

                if (sanitized) {
                  var url = sanitized.url;

                  if (typeof document !== "undefined" && typeof document.createElement === "function") {
                    var a = document.createElement("a");
                    a.href = sanitized.url;
                    url = a.href;
                  }

                  return {
                    reqId,
                    url,
                    headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
                      return "".concat(headerValue);
                    }),
                    body: truncate(sanitized.body),
                    method,
                    referrer: sanitized.referrer || void 0,
                    mode: sanitized.mode || void 0,
                    credentials: sanitized.credentials || void 0
                  };
                }

                ignoredNetwork[reqId] = true;
                return null;
              });
            };

            var addResponse = function addResponse2(reqId, response) {
              var method = response.method,
                  status = response.status;
              logger.addEvent("lr.network.ResponseEvent", function () {
                var _ref2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                    _ref2$isEnabled = _ref2.isEnabled,
                    isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled,
                    _ref2$responseSanitiz = _ref2.responseSanitizer,
                    responseSanitizer = _ref2$responseSanitiz === void 0 ? function (f2) {
                  return f2;
                } : _ref2$responseSanitiz;

                if (!isEnabled) {
                  return null;
                } else if (ignoredNetwork[reqId]) {
                  delete ignoredNetwork[reqId];
                  return null;
                }

                var sanitized = null;

                try {
                  sanitized = responseSanitizer(_objectSpread(_objectSpread({}, response), {}, {
                    reqId
                  }));
                } catch (err) {
                  console.error(err);
                }

                if (sanitized) {
                  return {
                    reqId,
                    status: sanitized.status,
                    headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
                      return "".concat(headerValue);
                    }),
                    body: truncate(sanitized.body),
                    method
                  };
                }

                return {
                  reqId,
                  status,
                  headers: {},
                  body: null,
                  method
                };
              });
            };

            var isIgnored = function isIgnored2(reqId) {
              return logger.isDisabled || ignoredNetwork[reqId] === true;
            };

            var unsubFetch = (0, _registerFetch.default)({
              addRequest,
              addResponse,
              isIgnored
            });
            var unsubXHR = (0, _registerXHR.default)({
              addRequest,
              addResponse,
              isIgnored,
              logger,
              shouldAugmentNPS,
              shouldParseXHRBlob
            });
            var unsubIonic = (0, _registerIonic.registerIonic)({
              addRequest,
              addResponse,
              isIgnored
            });
            var unsubNetworkInformation = isReactNative ? function () {} : (0, _registerNetworkInformation.default)(logger);
            return function () {
              unsubNetworkInformation();
              unsubFetch();
              unsubXHR();
              unsubIonic();
            };
          }
        },
        "./packages/@logrocket/network/src/registerFetch.js": function packagesLogrocketNetworkSrcRegisterFetchJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = registerFetch;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _mapValues = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/mapValues.js"));

          var _fetchIntercept = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/network/src/fetchIntercept.js"));

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              enumerableOnly && (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })), keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2.default)(target, key, source[key]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }

            return target;
          }

          function makeObjectFromHeaders(headers) {
            if (headers == null || typeof headers.forEach !== "function") {
              return headers;
            }

            var result = {};
            headers.forEach(function (value, key) {
              if (result[key]) {
                result[key] = "".concat(result[key], ",").concat(value);
              } else {
                result[key] = "".concat(value);
              }
            });
            return result;
          }

          var stringifyHeaders = function stringifyHeaders2(headers) {
            return (0, _mapValues.default)(makeObjectFromHeaders(headers), function (value) {
              return "".concat(value);
            });
          };

          function pluckFetchFields() {
            var arg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            return {
              url: arg.url,
              headers: stringifyHeaders(arg.headers),
              method: arg.method && arg.method.toUpperCase(),
              referrer: arg.referrer || void 0,
              mode: arg.mode || void 0,
              credentials: arg.credentials || void 0
            };
          }

          function registerFetch(_ref) {
            var addRequest = _ref.addRequest,
                addResponse = _ref.addResponse,
                isIgnored = _ref.isIgnored;
            var LOGROCKET_FETCH_LABEL = "fetch-";
            var fetchMethodMap = {};

            var unregister = _fetchIntercept.default.register({
              request: function request(fetchId) {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = arguments[_key];
                }

                var p2;

                if (typeof Request !== "undefined" && args[0] instanceof Request) {
                  var clonedText;

                  try {
                    clonedText = args[0].clone().text();
                  } catch (err) {
                    clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
                  }

                  p2 = clonedText.then(function (body) {
                    return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                      body
                    });
                  }, function (err) {
                    return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                      body: "LogRocket fetch error: ".concat(err.message)
                    });
                  });
                } else {
                  p2 = Promise.resolve(_objectSpread(_objectSpread({}, pluckFetchFields(args[1])), {}, {
                    url: "".concat(args[0]),
                    body: (args[1] || {}).body
                  }));
                }

                return p2.then(function (req) {
                  fetchMethodMap[fetchId] = req.method;
                  addRequest("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), req);
                  return args;
                });
              },
              requestError: function requestError(fetchId, error) {
                return Promise.reject(error);
              },
              response: function response(fetchId, _response) {
                var responseClone;
                var responseTextPromise;

                if (isIgnored("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId))) {
                  return _response;
                }

                try {
                  responseClone = _response.clone();
                } catch (err) {
                  var responseHash = {
                    url: _response.url,
                    status: _response.status,
                    headers: stringifyHeaders(_response.headers),
                    body: "LogRocket fetch error: ".concat(err.message),
                    method: fetchMethodMap[fetchId]
                  };
                  delete fetchMethodMap[fetchId];
                  addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
                  return _response;
                }

                try {
                  if (window.TextDecoder && responseClone.body) {
                    var reader = responseClone.body.getReader();
                    var utf8Decoder = new window.TextDecoder("utf-8");
                    var bodyContents = "";
                    responseTextPromise = reader.read().then(function readResponseBody(_ref2) {
                      var done = _ref2.done,
                          value = _ref2.value;

                      if (done) {
                        return bodyContents;
                      }

                      var chunk = value ? utf8Decoder.decode(value, {
                        stream: true
                      }) : "";
                      bodyContents += chunk;
                      return reader.read().then(readResponseBody);
                    });
                  } else {
                    responseTextPromise = responseClone.text();
                  }
                } catch (error) {
                  responseTextPromise = Promise.resolve("LogRocket error reading body: ".concat(error.message));
                }

                responseTextPromise.catch(function (error) {
                  if (error.name === "AbortError" && error instanceof DOMException) {
                    return;
                  }

                  return "LogRocket error reading body: ".concat(error.message);
                }).then(function (data) {
                  var responseHash2 = {
                    url: _response.url,
                    status: _response.status,
                    headers: stringifyHeaders(_response.headers),
                    body: data,
                    method: fetchMethodMap[fetchId]
                  };
                  delete fetchMethodMap[fetchId];
                  addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash2);
                });
                return _response;
              },
              responseError: function responseError(fetchId, error) {
                var response = {
                  url: void 0,
                  status: 0,
                  headers: {},
                  body: "".concat(error)
                };
                addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), response);
                return Promise.reject(error);
              }
            });

            return unregister;
          }
        },
        "./packages/@logrocket/network/src/registerIonic.ts": function packagesLogrocketNetworkSrcRegisterIonicTs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.mergeHeaders = mergeHeaders;
          exports2.serializeQueryParams = serializeQueryParams;
          exports2.appendQueryParamsString = appendQueryParamsString;
          exports2.processData = processData;
          exports2.registerIonic = registerIonic;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _typeof2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js"));

          var _toConsumableArray2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/toConsumableArray.js"));

          var _utils = __webpack_require__2("./packages/@logrocket/utils/src/index.js");

          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;

                var F = function F2() {};

                return {
                  s: F,
                  n: function n2() {
                    if (i >= o.length) return {
                      done: true
                    };
                    return {
                      done: false,
                      value: o[i++]
                    };
                  },
                  e: function e(_e) {
                    throw _e;
                  },
                  f: F
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            var normalCompletion = true,
                didErr = false,
                err;
            return {
              s: function s() {
                it = it.call(o);
              },
              n: function n2() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
              },
              e: function e(_e2) {
                didErr = true;
                err = _e2;
              },
              f: function f2() {
                try {
                  if (!normalCompletion && it.return != null) it.return();
                } finally {
                  if (didErr) throw err;
                }
              }
            };
          }

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
          }

          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              enumerableOnly && (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })), keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2.default)(target, key, source[key]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }

            return target;
          }

          var VALID_HTTP_METHODS = /* @__PURE__ */new Set(["get", "put", "post", "patch", "head", "delete", "options", "upload", "download"]);
          var VALID_SERIALIZERS = /* @__PURE__ */new Set(["urlencoded", "json", "utf8"]);
          var UNSUPPORTED_SERIALIZERS = /* @__PURE__ */new Set(["raw", "multipart"]);
          var LOGROCKET_IONIC_LABEL = "ionic-";
          var UNSUPPORTED_PLATFORMS = /* @__PURE__ */new Set(["desktop", "mobileweb", "pwa"]);
          var FORM_DATA = /* @__PURE__ */new Set(["FormData"]);
          var EMPTY_SET = /* @__PURE__ */new Set();
          var STRING_SET = /* @__PURE__ */new Set(["string"]);
          var STRING_ARRAY_SET = /* @__PURE__ */new Set(["string", "array"]);
          var ALLOWED_DATA_TYPES = {
            utf8: STRING_SET,
            urlencoded: /* @__PURE__ */new Set(["object"]),
            json: /* @__PURE__ */new Set(["array", "object"]),
            raw: /* @__PURE__ */new Set(["Uint8Array", "ArrayBuffer"]),
            default: EMPTY_SET
          };

          function checkForValidStringValue(list, value, fieldName) {
            if (typeof value !== "string") {
              throw new Error("".concat(fieldName, " must be one of: ").concat((0, _toConsumableArray2.default)(list).join(", ")));
            }

            value = value.trim().toLowerCase();

            if (!list.has(value)) {
              throw new Error("".concat(fieldName, " must be one of: ").concat((0, _toConsumableArray2.default)(list).join(", ")));
            }

            return value;
          }

          function checkKeyValuePairObject(obj, allowedChildren, onInvalidValueMessage) {
            if ((0, _typeof2.default)(obj) !== "object") {
              throw new Error(onInvalidValueMessage);
            }

            for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
              var key = _Object$keys[_i];

              if (!allowedChildren.has((0, _typeof2.default)(obj[key]))) {
                throw new Error(onInvalidValueMessage);
              }
            }

            return obj;
          }

          function getMatchingHostHeaders(url, ionicHttp) {
            var _URL = new URL(url),
                host = _URL.host;

            return ionicHttp.getHeaders(host) || null;
          }

          function mergeHeaders(defaultHeaders, headers) {
            return _objectSpread(_objectSpread({}, defaultHeaders), headers);
          }

          function getMergedHeaders(url, requestHeaders, ionicHttp) {
            var globalHeaders = ionicHttp.getHeaders("*") || {};
            var hostHeaders = getMatchingHostHeaders(url, ionicHttp) || {};
            return mergeHeaders(mergeHeaders(globalHeaders, hostHeaders), requestHeaders);
          }

          function serializeValue(value, encode) {
            if (encode) {
              return encodeURIComponent(value);
            } else {
              return value;
            }
          }

          function serializeIdentifier(parentKey, key, encode) {
            if (!parentKey.length) {
              return encode ? encodeURIComponent(key) : key;
            }

            if (encode) {
              return "".concat(encodeURIComponent(parentKey), "[").concat(encodeURIComponent(key), "]");
            } else {
              return "".concat(parentKey, "[").concat(key, "]");
            }
          }

          function serializeArray(parentKey, array, encode) {
            var parts = [];

            var _iterator = _createForOfIteratorHelper(array),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var e = _step.value;

                if (Array.isArray(e)) {
                  parts.push(serializeArray("".concat(parentKey, "[]"), e, encode));
                  continue;
                } else if ((0, _typeof2.default)(e) === "object") {
                  parts.push(serializeObject("".concat(parentKey, "[]").concat(e), encode, void 0));
                  continue;
                }

                parts.push("".concat(serializeIdentifier(parentKey, "", encode), "=").concat(serializeValue(e, encode)));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return parts.join("&");
          }

          function serializeObject(parentKey, object, encode) {
            var parts = [];

            for (var key in object) {
              if (!object.hasOwnProperty(key)) {
                continue;
              }

              var identifier = parentKey.length ? "".concat(parentKey, "[").concat(key, "]") : key;

              if (Array.isArray(object[key])) {
                parts.push(serializeArray(identifier, object[key], encode));
                continue;
              } else if ((0, _typeof2.default)(object[key]) === "object" && object[key] !== null) {
                parts.push(serializeObject(identifier, object[key], encode));
                continue;
              }

              parts.push("".concat(serializeIdentifier(parentKey, key, encode), "=").concat(serializeValue(object[key], encode)));
            }

            return parts.join("&");
          }

          function serializeQueryParams(params, encode) {
            return serializeObject("", params, encode);
          }

          function appendQueryParamsString(url, params) {
            if (!url.length || !params.length) {
              return url;
            }

            var _URL2 = new URL(url),
                host = _URL2.host,
                pathname = _URL2.pathname,
                search = _URL2.search,
                hash = _URL2.hash,
                protocol = _URL2.protocol;

            return "".concat(protocol, "//").concat(host).concat(pathname).concat(search.length ? "".concat(search, "&").concat(params) : "?".concat(params)).concat(hash);
          }

          function getAllowedDataTypes(dataSerializer) {
            return ALLOWED_DATA_TYPES[dataSerializer] || ALLOWED_DATA_TYPES.default;
          }

          function getAllowedInstanceTypes(dataSerializer) {
            return dataSerializer === "multipart" ? FORM_DATA : EMPTY_SET;
          }

          function processData(data, dataSerializer) {
            var currentDataType = (0, _typeof2.default)(data);
            var allowedDataTypes = getAllowedDataTypes(dataSerializer);
            var allowedInstanceTypes = getAllowedInstanceTypes(dataSerializer);

            if (allowedInstanceTypes.size > 0) {
              var isCorrectInstanceType = false;
              allowedInstanceTypes.forEach(function (type) {
                if (__webpack_require__2.g[type] && data instanceof __webpack_require__2.g[type]) {
                  isCorrectInstanceType = true;
                }
              });

              if (!isCorrectInstanceType) {
                throw new Error("INSTANCE_TYPE_MISMATCH_DATA ".concat((0, _toConsumableArray2.default)(allowedInstanceTypes).join(", ")));
              }
            }

            if (allowedInstanceTypes.size === 0 && !allowedDataTypes.has(currentDataType)) {
              throw new Error("TYPE_MISMATCH_DATA ".concat((0, _toConsumableArray2.default)(allowedDataTypes).join(", ")));
            }

            switch (dataSerializer) {
              case "utf8":
                return data;

              default:
                return JSON.stringify(data, void 0, 2);
            }
          }

          function handleMissingOptions(options, ionicHttp) {
            options = options || {};
            var serializer;
            var data = options.data;

            try {
              serializer = checkForValidStringValue(VALID_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), "serializer / data payload type");
            } catch (_unused) {
              serializer = checkForValidStringValue(UNSUPPORTED_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), "serializer / data payload type");
              data = {};
            }

            return {
              data,
              filePath: options.filePath,
              followRedirect: options.followRedirect,
              headers: checkKeyValuePairObject(options.headers || {}, STRING_SET, "Invalid header type, must be string"),
              method: checkForValidStringValue(VALID_HTTP_METHODS, options.method || VALID_HTTP_METHODS[0], "method"),
              name: options.name,
              params: checkKeyValuePairObject(options.params || {}, STRING_ARRAY_SET, "Invalid param, must be of type string or array"),
              responseType: options.responseType,
              serializer,
              connectTimeout: options.connectTimeout,
              readTimeout: options.readTimeout,
              timeout: options.timeout
            };
          }

          var ionicIdCounter = 0;

          function registerIonic(_ref) {
            var _cordova, _cordova$plugin, _window$ionic;

            var addRequest = _ref.addRequest,
                addResponse = _ref.addResponse,
                isIgnored = _ref.isIgnored;
            var ionicHttp = (_cordova = window.cordova) === null || _cordova === void 0 ? void 0 : (_cordova$plugin = _cordova.plugin) === null || _cordova$plugin === void 0 ? void 0 : _cordova$plugin.http;
            var ionicMap = {};
            var unsubscribedFromIonic = false;

            if (typeof ionicHttp === "undefined") {
              return function () {};
            }

            var platforms = (_window$ionic = window.ionic) === null || _window$ionic === void 0 ? void 0 : _window$ionic.platforms;

            if (typeof platforms !== "undefined" && typeof platforms.some === "function" && platforms.some(function (e) {
              return UNSUPPORTED_PLATFORMS.has(e);
            })) {
              return function () {};
            }

            var originalSendRequest = ionicHttp.sendRequest;
            var handleResponse = (0, _utils.protectFunc)(function (response, isSuccess, ionicReqId) {
              if (!isIgnored("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId))) {
                try {
                  var responseHash = {
                    url: response.url || "",
                    status: response.status < 600 && response.status >= 100 ? response.status : 0,
                    headers: response.headers || {},
                    body: isSuccess ? response.data : response.error,
                    method: ionicMap[ionicReqId].toUpperCase()
                  };
                  addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), responseHash);
                } catch (err) {
                  var _responseHash = {
                    url: response.url || "",
                    status: response.status < 600 && response.status >= 100 ? response.status : 0,
                    headers: response.headers || {},
                    body: "LogRocket fetch error: ".concat(err.message),
                    method: ionicMap[ionicReqId].toUpperCase()
                  };
                  addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), _responseHash);
                }
              }
            });

            ionicHttp.sendRequest = function (url, options, success, failure) {
              var currentId = ++ionicIdCounter;

              var ourSuccessHandler = function ourSuccessHandler2(response) {
                if (!unsubscribedFromIonic) {
                  handleResponse(response, true, currentId);
                  delete ionicMap[currentId];
                }

                success(response);
              };

              var ourFailureHandler = function ourFailureHandler2(response) {
                if (!unsubscribedFromIonic) {
                  handleResponse(response, false, currentId);
                  delete ionicMap[currentId];
                }

                failure(response);
              };

              if (!unsubscribedFromIonic) {
                try {
                  var modifiedOptions = handleMissingOptions(options, ionicHttp);
                  var modifiedUrl = appendQueryParamsString(url, serializeObject("", modifiedOptions.params, true));
                  var mergedHeaders = getMergedHeaders(url, modifiedOptions.headers, ionicHttp);
                  var method = modifiedOptions.method || "get";
                  ionicMap[currentId] = method;
                  var requestHash = {
                    url: modifiedUrl,
                    method: method.toUpperCase(),
                    headers: mergedHeaders || {},
                    body: processData(modifiedOptions.data || {}, modifiedOptions.serializer)
                  };
                  addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), requestHash);
                } catch (err) {
                  var _requestHash = {
                    url,
                    method: (options.method || "get").toUpperCase(),
                    headers: {},
                    body: "LogRocket fetch error: ".concat(err.message)
                  };
                  addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), _requestHash);
                }
              }

              return originalSendRequest(url, options, ourSuccessHandler, ourFailureHandler);
            };

            return function () {
              unsubscribedFromIonic = true;
              ionicHttp.sendRequest = originalSendRequest;
              ionicMap = {};
            };
          }
        },
        "./packages/@logrocket/network/src/registerNetworkInformation.js": function packagesLogrocketNetworkSrcRegisterNetworkInformationJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = registerNetworkInformation;
          var EFFECTIVE_TYPE_VALS = {
            "slow-2g": "SLOW2G",
            "2g": "TWOG",
            "3g": "THREEG",
            "4g": "FOURG"
          };

          function registerNetworkInformation(logger) {
            var lastStatus = void 0;

            function sendNetworkInformation() {
              var newStatus = {
                online: window.navigator.onLine,
                effectiveType: "UNKOWN"
              };

              if (!window.navigator.onLine) {
                newStatus.effectiveType = "NONE";
              } else if (window.navigator.connection && window.navigator.connection.effectiveType) {
                newStatus.effectiveType = EFFECTIVE_TYPE_VALS[window.navigator.connection.effectiveType] || "UNKNOWN";
              }

              if (lastStatus && newStatus.online === lastStatus.online && newStatus.effectiveType === lastStatus.effectiveType) {
                return;
              }

              lastStatus = newStatus;
              logger.addEvent("lr.network.NetworkStatusEvent", function () {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                    _ref$isEnabled = _ref.isEnabled,
                    isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled;

                if (!isEnabled) {
                  return null;
                }

                return newStatus;
              });
            }

            setTimeout(sendNetworkInformation);

            if (window.navigator.connection && typeof window.navigator.connection.addEventListener === "function") {
              window.navigator.connection.addEventListener("change", sendNetworkInformation);
            }

            window.addEventListener("online", sendNetworkInformation);
            window.addEventListener("offline", sendNetworkInformation);
            return function () {
              window.removeEventListener("offline", sendNetworkInformation);
              window.removeEventListener("online", sendNetworkInformation);

              if (window.navigator.connection && typeof window.navigator.connection.removeEventListener === "function") {
                window.navigator.connection.removeEventListener("change", sendNetworkInformation);
              }
            };
          }
        },
        "./packages/@logrocket/network/src/registerXHR.js": function packagesLogrocketNetworkSrcRegisterXHRJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.setActive = setActive;
          exports2["default"] = registerXHR;

          var _mapValues = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/mapValues.js"));

          var _enhanceFunc = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/enhanceFunc.js"));

          var _startsWith = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/startsWith.js"));

          var _nps = __webpack_require__2("./packages/@logrocket/utils/src/constants/nps.js");

          var isActive = true;

          function setActive(shouldBeActive) {
            isActive = shouldBeActive;
          }

          var currentXHRId = 0;

          function registerXHR(_ref) {
            var addRequest = _ref.addRequest,
                addResponse = _ref.addResponse,
                isIgnored = _ref.isIgnored,
                logger = _ref.logger,
                _ref$shouldAugmentNPS = _ref.shouldAugmentNPS,
                shouldAugmentNPS = _ref$shouldAugmentNPS === void 0 ? true : _ref$shouldAugmentNPS,
                _ref$shouldParseXHRBl = _ref.shouldParseXHRBlob,
                shouldParseXHRBlob = _ref$shouldParseXHRBl === void 0 ? false : _ref$shouldParseXHRBl;
            var _XHR = XMLHttpRequest;
            var xhrMap = /* @__PURE__ */new WeakMap();
            var unsubscribedFromXhr = false;
            var LOGROCKET_XHR_LABEL = "xhr-";
            window._lrXMLHttpRequest = XMLHttpRequest;

            XMLHttpRequest = function XMLHttpRequest2(mozAnon, mozSystem) {
              var xhrObject = new _XHR(mozAnon, mozSystem);

              if (!isActive) {
                return xhrObject;
              }

              xhrMap.set(xhrObject, {
                xhrId: ++currentXHRId,
                headers: {}
              });
              var openOriginal = xhrObject.open;

              function openShim() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                try {
                  var url = args[1];

                  if (window.URL && typeof window.URL === "function" && url.search(_nps.WOOTRIC_RESPONSES_REGEX) === 0) {
                    var logrocketSessionURL = new window.URL(logger.recordingURL);
                    logrocketSessionURL.searchParams.set("nps", "wootric");
                    var urlObj = new window.URL(url);
                    var responseText = urlObj.searchParams.get("response[text]");
                    var feedback = responseText ? "".concat(responseText, "\n\n") : "";
                    urlObj.searchParams.set("response[text]", "".concat(feedback, "<").concat(logrocketSessionURL.href, "|View LogRocket session>"));
                    args[1] = urlObj.href;
                  }
                } catch (e) {}

                return openOriginal.apply(this, args);
              }

              var sendOriginal = xhrObject.send;

              function sendShim() {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = arguments[_key2];
                }

                try {
                  var currentXHR = xhrMap.get(xhrObject);

                  if (window.URL && typeof window.URL === "function" && currentXHR && currentXHR.url && currentXHR.url.search(_nps.DELIGHTED_RESPONSES_REGEX) === 0 && args.length && args[0].indexOf(_nps.DELIGHTED_FEEDBACK_PREFIX) !== -1) {
                    var recordingURL = new window.URL(logger.recordingURL);
                    recordingURL.searchParams.set("nps", "delighted");
                    var logrocketSessionURL = encodeURIComponent(recordingURL.href);
                    var data = args[0].split("&").map(function (dataString) {
                      if ((0, _startsWith.default)(dataString, _nps.DELIGHTED_FEEDBACK_PREFIX)) {
                        var isEmpty = dataString === _nps.DELIGHTED_FEEDBACK_PREFIX;
                        return "".concat(dataString).concat(isEmpty ? "" : "\n\n", "<").concat(logrocketSessionURL, "|View LogRocket session>");
                      }

                      return dataString;
                    }).join("&");
                    args[0] = data;
                  }
                } catch (e) {}

                return sendOriginal.apply(this, args);
              }

              if (shouldAugmentNPS) {
                xhrObject.open = openShim;
                xhrObject.send = sendShim;
              }

              (0, _enhanceFunc.default)(xhrObject, "open", function (method, url) {
                if (unsubscribedFromXhr) {
                  return;
                }

                var currentXHR = xhrMap.get(xhrObject);
                currentXHR.method = method;
                currentXHR.url = url;
              });
              (0, _enhanceFunc.default)(xhrObject, "send", function (data) {
                if (unsubscribedFromXhr) {
                  return;
                }

                var currentXHR = xhrMap.get(xhrObject);

                if (!currentXHR) {
                  return;
                }

                var request = {
                  url: currentXHR.url,
                  method: currentXHR.method && currentXHR.method.toUpperCase(),
                  headers: (0, _mapValues.default)(currentXHR.headers || {}, function (headerValues) {
                    return headerValues.join(", ");
                  }),
                  body: data
                };
                addRequest("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), request);
              });
              (0, _enhanceFunc.default)(xhrObject, "setRequestHeader", function (header, value) {
                if (unsubscribedFromXhr) {
                  return;
                }

                var currentXHR = xhrMap.get(xhrObject);

                if (!currentXHR) {
                  return;
                }

                currentXHR.headers = currentXHR.headers || {};
                currentXHR.headers[header] = currentXHR.headers[header] || [];
                currentXHR.headers[header].push(value);
              });
              var xhrListeners = {
                readystatechange: function readystatechange() {
                  if (unsubscribedFromXhr) {
                    return;
                  }

                  if (xhrObject.readyState === 4) {
                    var currentXHR = xhrMap.get(xhrObject);

                    if (!currentXHR) {
                      return;
                    }

                    if (isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) {
                      return;
                    }

                    var headerString = xhrObject.getAllResponseHeaders() || "";
                    var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
                      var next = previous;
                      var headerParts = current.split(": ");

                      if (headerParts.length > 0) {
                        var key = headerParts.shift();
                        var value = headerParts.join(": ");

                        if (previous[key]) {
                          next[key] += ", ".concat(value);
                        } else {
                          next[key] = value;
                        }
                      }

                      return next;
                    }, {});
                    var body;

                    try {
                      switch (xhrObject.responseType) {
                        case "json":
                          body = logger._shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                          break;

                        case "arraybuffer":
                        case "blob":
                          {
                            body = xhrObject.response;
                            break;
                          }

                        case "document":
                          {
                            body = xhrObject.responseXML;
                            break;
                          }

                        case "text":
                        case "":
                          {
                            body = xhrObject.responseText;
                            break;
                          }

                        default:
                          {
                            body = "";
                          }
                      }
                    } catch (err) {
                      body = "LogRocket: Error accessing response.";
                    }

                    var response = {
                      url: currentXHR.url,
                      status: xhrObject.status,
                      headers,
                      body,
                      method: (currentXHR.method || "").toUpperCase()
                    };

                    if (shouldParseXHRBlob && response.body instanceof Blob) {
                      var blobReader = new FileReader();
                      blobReader.readAsText(response.body);

                      blobReader.onload = function () {
                        try {
                          response.body = JSON.parse(blobReader.result);
                        } catch (_unused) {}

                        addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                      };
                    } else {
                      addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                    }
                  }
                }
              };
              Object.keys(xhrListeners).forEach(function (key) {
                xhrObject.addEventListener(key, xhrListeners[key]);
              });
              return xhrObject;
            };

            XMLHttpRequest.prototype = _XHR.prototype;
            ["UNSENT", "OPENED", "HEADERS_RECEIVED", "LOADING", "DONE"].forEach(function (variable) {
              XMLHttpRequest[variable] = _XHR[variable];
            });
            return function () {
              unsubscribedFromXhr = true;
              XMLHttpRequest = _XHR;
            };
          }
        },
        "./packages/@logrocket/now/src/index.js": function packagesLogrocketNowSrcIndexJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = void 0;
          var dateNow = Date.now.bind(Date);
          var loadTime = dateNow();

          var _default = typeof performance !== "undefined" && performance.now ? performance.now.bind(performance) : function () {
            return dateNow() - loadTime;
          };

          exports2["default"] = _default;
        },
        "./packages/@logrocket/redux/src/createEnhancer.js": function packagesLogrocketReduxSrcCreateEnhancerJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = createEnhancer;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _now = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/now/src/index.js"));

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              enumerableOnly && (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })), keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2.default)(target, key, source[key]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }

            return target;
          }

          var storeIdCounter = 0;

          function createEnhancer(logger) {
            var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                _ref$stateSanitizer = _ref.stateSanitizer,
                stateSanitizer = _ref$stateSanitizer === void 0 ? function (f2) {
              return f2;
            } : _ref$stateSanitizer,
                _ref$actionSanitizer = _ref.actionSanitizer,
                actionSanitizer = _ref$actionSanitizer === void 0 ? function (f2) {
              return f2;
            } : _ref$actionSanitizer;

            return function (createStore) {
              return function (reducer, initialState, enhancer) {
                var store = createStore(reducer, initialState, enhancer);
                var originalDispatch = store.dispatch;
                var storeId = storeIdCounter++;
                logger.addEvent("lr.redux.InitialState", function () {
                  var sanitizedState;

                  try {
                    sanitizedState = stateSanitizer(store.getState());
                  } catch (err) {
                    console.error(err.toString());
                  }

                  return {
                    state: sanitizedState,
                    storeId
                  };
                });

                var dispatch = function dispatch2(action) {
                  var start = (0, _now.default)();
                  var err;
                  var res;

                  try {
                    res = originalDispatch(action);
                  } catch (_err) {
                    err = _err;
                  } finally {
                    var duration = (0, _now.default)() - start;
                    logger.addEvent("lr.redux.ReduxAction", function () {
                      var sanitizedState = null;
                      var sanitizedAction = null;

                      try {
                        sanitizedState = stateSanitizer(store.getState());
                        sanitizedAction = actionSanitizer(action);
                      } catch (err2) {
                        console.error(err2.toString());
                      }

                      if (sanitizedState && sanitizedAction) {
                        return {
                          storeId,
                          action: sanitizedAction,
                          duration,
                          stateDelta: sanitizedState
                        };
                      }

                      return null;
                    });
                  }

                  if (err) {
                    throw err;
                  }

                  return res;
                };

                return _objectSpread(_objectSpread({}, store), {}, {
                  dispatch
                });
              };
            };
          }
        },
        "./packages/@logrocket/redux/src/createMiddleware.js": function packagesLogrocketReduxSrcCreateMiddlewareJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = createMiddleware;

          var _now = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/now/src/index.js"));

          var storeIdCounter = 0;

          function createMiddleware(logger) {
            var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                _ref$stateSanitizer = _ref.stateSanitizer,
                stateSanitizer = _ref$stateSanitizer === void 0 ? function (f2) {
              return f2;
            } : _ref$stateSanitizer,
                _ref$actionSanitizer = _ref.actionSanitizer,
                actionSanitizer = _ref$actionSanitizer === void 0 ? function (f2) {
              return f2;
            } : _ref$actionSanitizer;

            return function (store) {
              var storeId = storeIdCounter++;
              logger.addEvent("lr.redux.InitialState", function () {
                var sanitizedState;

                try {
                  sanitizedState = stateSanitizer(store.getState());
                } catch (err) {
                  console.error(err.toString());
                }

                return {
                  state: sanitizedState,
                  storeId
                };
              });
              return function (next) {
                return function (action) {
                  var start = (0, _now.default)();
                  var err;
                  var res;

                  try {
                    res = next(action);
                  } catch (_err) {
                    err = _err;
                  } finally {
                    var duration = (0, _now.default)() - start;
                    logger.addEvent("lr.redux.ReduxAction", function () {
                      var sanitizedState = null;
                      var sanitizedAction = null;

                      try {
                        sanitizedState = stateSanitizer(store.getState());
                        sanitizedAction = actionSanitizer(action);
                      } catch (err2) {
                        console.error(err2.toString());
                      }

                      if (sanitizedState && sanitizedAction) {
                        return {
                          storeId,
                          action: sanitizedAction,
                          duration,
                          stateDelta: sanitizedState
                        };
                      }

                      return null;
                    });
                  }

                  if (err) {
                    throw err;
                  }

                  return res;
                };
              };
            };
          }
        },
        "./packages/@logrocket/redux/src/index.js": function packagesLogrocketReduxSrcIndexJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          Object.defineProperty(exports2, "createEnhancer", {
            enumerable: true,
            get: function get() {
              return _createEnhancer.default;
            }
          });
          Object.defineProperty(exports2, "createMiddleware", {
            enumerable: true,
            get: function get() {
              return _createMiddleware.default;
            }
          });

          var _createEnhancer = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/redux/src/createEnhancer.js"));

          var _createMiddleware = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/redux/src/createMiddleware.js"));
        },
        "./packages/@logrocket/utils/src/TraceKit.js": function packagesLogrocketUtilsSrcTraceKitJs(__unused_webpack_module, exports2, __webpack_require__2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = void 0;
          var TraceKit = {
            collectWindowErrors: true,
            debug: false
          };

          var _window = typeof window !== "undefined" ? window : typeof __webpack_require__2.g !== "undefined" ? __webpack_require__2.g : typeof self !== "undefined" ? self : {};

          var _slice = [].slice;
          var UNKNOWN_FUNCTION = "?";
          var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;

          function getLocationHref() {
            if (typeof document === "undefined" || typeof document.location === "undefined") return "";
            return document.location.href;
          }

          TraceKit.report = function reportModuleWrapper() {
            var handlers = [],
                lastArgs = null,
                lastException = null,
                lastExceptionStack = null;

            function subscribe(handler) {
              installGlobalHandler();
              handlers.push(handler);
            }

            function unsubscribe(handler) {
              for (var i = handlers.length - 1; i >= 0; --i) {
                if (handlers[i] === handler) {
                  handlers.splice(i, 1);
                }
              }
            }

            function unsubscribeAll() {
              uninstallGlobalHandler();
              handlers = [];
            }

            function notifyHandlers(stack, isWindowError) {
              var exception = null;

              if (isWindowError && !TraceKit.collectWindowErrors) {
                return;
              }

              for (var i in handlers) {
                if (handlers.hasOwnProperty(i)) {
                  try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                  } catch (inner) {
                    exception = inner;
                  }
                }
              }

              if (exception) {
                throw exception;
              }
            }

            var _oldOnerrorHandler, _onErrorHandlerInstalled;

            function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
              var stack = null;

              if (lastExceptionStack) {
                TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                processLastException();
              } else if (ex) {
                stack = TraceKit.computeStackTrace(ex);
                notifyHandlers(stack, true);
              } else {
                var location2 = {
                  "url": url,
                  "line": lineNo,
                  "column": colNo
                };
                var name = void 0;
                var msg = message;
                var groups;

                if ({}.toString.call(message) === "[object String]") {
                  var groups = message.match(ERROR_TYPES_RE);

                  if (groups) {
                    name = groups[1];
                    msg = groups[2];
                  }
                }

                location2.func = UNKNOWN_FUNCTION;
                stack = {
                  "name": name,
                  "message": msg,
                  "url": getLocationHref(),
                  "stack": [location2]
                };
                notifyHandlers(stack, true);
              }

              if (_oldOnerrorHandler) {
                return _oldOnerrorHandler.apply(this, arguments);
              }

              return false;
            }

            function installGlobalHandler() {
              if (_onErrorHandlerInstalled) {
                return;
              }

              _oldOnerrorHandler = _window.onerror;
              _window.onerror = traceKitWindowOnError;
              _onErrorHandlerInstalled = true;
            }

            function uninstallGlobalHandler() {
              if (!_onErrorHandlerInstalled) {
                return;
              }

              _window.onerror = _oldOnerrorHandler;
              _onErrorHandlerInstalled = false;
              _oldOnerrorHandler = void 0;
            }

            function processLastException() {
              var _lastExceptionStack = lastExceptionStack,
                  _lastArgs = lastArgs;
              lastArgs = null;
              lastExceptionStack = null;
              lastException = null;
              notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
            }

            function report(ex, rethrow) {
              var args = _slice.call(arguments, 1);

              if (lastExceptionStack) {
                if (lastException === ex) {
                  return;
                } else {
                  processLastException();
                }
              }

              var stack = TraceKit.computeStackTrace(ex);
              lastExceptionStack = stack;
              lastException = ex;
              lastArgs = args;
              setTimeout(function () {
                if (lastException === ex) {
                  processLastException();
                }
              }, stack.incomplete ? 2e3 : 0);

              if (rethrow !== false) {
                throw ex;
              }
            }

            report.subscribe = subscribe;
            report.unsubscribe = unsubscribe;
            report.uninstall = unsubscribeAll;
            return report;
          }();

          TraceKit.computeStackTrace = function computeStackTraceWrapper() {
            function computeStackTraceFromStackProp(ex) {
              if (typeof ex.stack === "undefined" || !ex.stack) return;
              var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
                  gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
                  winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
                  lines = ex.stack.split("\n"),
                  stack = [],
                  parts,
                  element;
              /^(.*) is undefined$/.exec(ex.message);

              for (var i = 0, j = lines.length; i < j; ++i) {
                if (parts = chrome.exec(lines[i])) {
                  var isNative = parts[2] && parts[2].indexOf("native") !== -1;
                  element = {
                    "url": !isNative ? parts[2] : null,
                    "func": parts[1] || UNKNOWN_FUNCTION,
                    "args": isNative ? [parts[2]] : [],
                    "line": parts[3] ? +parts[3] : null,
                    "column": parts[4] ? +parts[4] : null
                  };
                } else if (parts = winjs.exec(lines[i])) {
                  element = {
                    "url": parts[2],
                    "func": parts[1] || UNKNOWN_FUNCTION,
                    "args": [],
                    "line": +parts[3],
                    "column": parts[4] ? +parts[4] : null
                  };
                } else if (parts = gecko.exec(lines[i])) {
                  element = {
                    "url": parts[3],
                    "func": parts[1] || UNKNOWN_FUNCTION,
                    "args": parts[2] ? parts[2].split(",") : [],
                    "line": parts[4] ? +parts[4] : null,
                    "column": parts[5] ? +parts[5] : null
                  };
                } else {
                  continue;
                }

                if (!element.func && element.line) {
                  element.func = UNKNOWN_FUNCTION;
                }

                stack.push(element);
              }

              if (!stack.length) {
                return null;
              }

              if (!stack[0].column && typeof ex.columnNumber !== "undefined") {
                stack[0].column = ex.columnNumber + 1;
              }

              return {
                "name": ex.name,
                "message": ex.message,
                "url": getLocationHref(),
                "stack": stack
              };
            }

            function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
              var initial = {
                "url": url,
                "line": lineNo
              };

              if (initial.url && initial.line) {
                stackInfo.incomplete = false;

                if (!initial.func) {
                  initial.func = UNKNOWN_FUNCTION;
                }

                if (stackInfo.stack.length > 0) {
                  if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                      return false;
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                      stackInfo.stack[0].line = initial.line;
                      return false;
                    }
                  }
                }

                stackInfo.stack.unshift(initial);
                stackInfo.partial = true;
                return true;
              } else {
                stackInfo.incomplete = true;
              }

              return false;
            }

            function computeStackTraceByWalkingCallerChain(ex, depth) {
              var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
                  stack = [],
                  funcs = {},
                  recursion = false,
                  parts,
                  item;

              for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
                if (curr === computeStackTrace || curr === TraceKit.report) {
                  continue;
                }

                item = {
                  "url": null,
                  "func": UNKNOWN_FUNCTION,
                  "line": null,
                  "column": null
                };

                if (curr.name) {
                  item.func = curr.name;
                } else if (parts = functionName.exec(curr.toString())) {
                  item.func = parts[1];
                }

                if (typeof item.func === "undefined") {
                  try {
                    item.func = parts.input.substring(0, parts.input.indexOf("{"));
                  } catch (e) {}
                }

                if (funcs["" + curr]) {
                  recursion = true;
                } else {
                  funcs["" + curr] = true;
                }

                stack.push(item);
              }

              if (depth) {
                stack.splice(0, depth);
              }

              var result = {
                "name": ex.name,
                "message": ex.message,
                "url": getLocationHref(),
                "stack": stack
              };
              augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
              return result;
            }

            function computeStackTrace(ex, depth) {
              var stack = null;
              depth = depth == null ? 0 : +depth;

              try {
                stack = computeStackTraceFromStackProp(ex);

                if (stack) {
                  return stack;
                }
              } catch (e) {
                if (TraceKit.debug) {
                  throw e;
                }
              }

              try {
                stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);

                if (stack) {
                  return stack;
                }
              } catch (e) {
                if (TraceKit.debug) {
                  throw e;
                }
              }

              return {
                "name": ex.name,
                "message": ex.message,
                "url": getLocationHref()
              };
            }

            computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
            computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
            return computeStackTrace;
          }();

          var _default = TraceKit;
          exports2["default"] = _default;
        },
        "./packages/@logrocket/utils/src/addListener.js": function packagesLogrocketUtilsSrcAddListenerJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = addListener;

          function addListener(type, handler) {
            var obj = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
            obj.addEventListener(type, handler, {
              capture: true,
              passive: true
            });
            return function () {
              obj.removeEventListener(type, handler, {
                capture: true,
                passive: true
              });
            };
          }
        },
        "./packages/@logrocket/utils/src/adjustOsVersion.ts": function packagesLogrocketUtilsSrcAdjustOsVersionTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.adjustOsVersion = adjustOsVersion;
          exports2.adjustOs = adjustOs;

          function adjustOsVersion(osName, osVersionStr) {
            var osVersion = osVersionStr;

            if (osVersionStr && osName.toLowerCase().replace(/\s/g, "").indexOf("macos") > -1) {
              osVersion = osVersionStr.replace("10.15.7", "10.15.7+");
            }

            return osVersion;
          }

          function adjustOs(os) {
            return adjustOsVersion(os, os);
          }
        },
        "./packages/@logrocket/utils/src/applyUrlSanitizer.js": function packagesLogrocketUtilsSrcApplyUrlSanitizerJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = applyUrlSanitizer;

          function applyUrlSanitizer(_ref) {
            var logger = _ref.logger,
                _ref$url = _ref.url,
                url = _ref$url === void 0 ? "" : _ref$url;

            var _ref2 = logger.getConfig("lr.browser") || {},
                _ref2$urlSanitizer = _ref2.urlSanitizer,
                urlSanitizer = _ref2$urlSanitizer === void 0 ? function (originalUrl) {
              return originalUrl;
            } : _ref2$urlSanitizer;

            var sanitizedValue;

            try {
              sanitizedValue = urlSanitizer(url);
            } catch (err) {
              console.error(err);
            }

            if (typeof sanitizedValue === "string") {
              return sanitizedValue;
            }

            return "";
          }
        },
        "./packages/@logrocket/utils/src/browserUtils.js": function packagesLogrocketUtilsSrcBrowserUtilsJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getNodeName = getNodeName;
          exports2.getTargetForEvent = getTargetForEvent;
          exports2.getNodePath = getNodePath;

          function getNodeName(node) {
            if (node.nodeName === "#document-fragment" && node.mode === "open") {
              return "$shadow-root";
            } else if (node.nodeName) {
              return node.nodeName.toLowerCase();
            }

            return "";
          }

          function getTargetForEvent(event) {
            if (typeof event.composedPath === "function" && event.composed) {
              return event.composedPath()[0];
            } else if (event.path) {
              return event.path[0];
            }

            return event.target;
          }

          var SELECTOR_MAX_LENGTH = 1e3;

          function getNodePath(element) {
            var activeNode = element;
            var nodePath = [];
            var nodePathLength = 0;

            while (activeNode && (activeNode.parentNode || activeNode.host)) {
              var nodeName = getNodeName(activeNode);

              if (nodeName === "body") {
                break;
              }

              var selector = {
                nodeName
              };
              var selectorLength = selector.nodeName.length;

              if (activeNode.id && activeNode.id.length > 0) {
                selector.id = activeNode.id;
                selectorLength += activeNode.id.length;
              }

              if (activeNode.classList && activeNode.classList.length > 0) {
                selector.classList = Array.prototype.slice.call(activeNode.classList, 0);
                var classNames = Array.prototype.join.call(activeNode.classList, "");

                if (classNames) {
                  selectorLength += classNames.length;
                }
              }

              if (nodePathLength + selectorLength > SELECTOR_MAX_LENGTH) {
                break;
              }

              if (activeNode.parentNode && activeNode.parentNode.children) {
                try {
                  var nthChild = 0;
                  var siblingNode = activeNode;

                  do {
                    nthChild += 1;
                    siblingNode = siblingNode.previousElementSibling;
                  } while (siblingNode);

                  selector.nthChild = nthChild;
                } catch (_) {}
              }

              nodePathLength += selectorLength;
              nodePath.push(selector);
              activeNode = activeNode.parentNode || activeNode.host;
            }

            return nodePath;
          }
        },
        "./packages/@logrocket/utils/src/constants/demo.js": function packagesLogrocketUtilsSrcConstantsDemoJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.APP_PROACTIVE_INSIGHTS = exports2.SANDBOX_SOURCE_ORG_SLUG = exports2.DEMO_APP_ID = exports2.DEMO_APP_SLUG = exports2.DEMO_ORG_SLUG = void 0;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var DEMO_ORG_SLUG = "demo-kdz7k";
          exports2.DEMO_ORG_SLUG = DEMO_ORG_SLUG;
          var DEMO_APP_SLUG = "logrocket";
          exports2.DEMO_APP_SLUG = DEMO_APP_SLUG;
          var DEMO_APP_ID = "".concat(DEMO_ORG_SLUG, "/").concat(DEMO_APP_SLUG);
          exports2.DEMO_APP_ID = DEMO_APP_ID;
          var SANDBOX_SOURCE_ORG_SLUG = "sandbox-source";
          exports2.SANDBOX_SOURCE_ORG_SLUG = SANDBOX_SOURCE_ORG_SLUG;
          var APP_PROACTIVE_INSIGHTS = (0, _defineProperty2.default)({}, DEMO_APP_ID, [{
            recordID: "1",
            tags: ["Checkout", "Lost Conversion"],
            date: "04/16/2021",
            frequency: 100,
            impact: "100",
            description: 'User attempting to checkout but "Buy Now" button is unresponsive',
            rootCause: 'Cannot read "key" of undefined',
            issueLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/issue/g49?from=issues&issueType=EXCEPTION&issueTypeOption=EXCEPTION",
            sessionLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/s/4-9db65df9-57a5-4b94-b3d7-be87886b64ab/0?fromTab=latest",
            metricLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/metrics/4/metric/25",
            ticketUrl: ""
          }, {
            recordID: "2",
            tags: ["New User", "Lost Signup"],
            date: "04/16/2021",
            frequency: 75,
            impact: "75",
            description: "User lands on blank page after login flow.",
            rootCause: "Network Failure 500 Get",
            issueLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/issue/829?from=issues&issueType=NETWORK_ERROR&issueTypeOption=NETWORK_ERROR",
            sessionLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/s/4-9db65df9-57a5-4b94-b3d7-be87886b64ab/0?fromTab=latest",
            metricLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/metrics/4/metric/25",
            ticketUrl: ""
          }, {
            recordID: "3",
            tags: ["UX", "Poor Experience"],
            date: "04/16/2021",
            frequency: 50,
            impact: "50",
            description: "User attempts to edit amount in cart but sees red error message.",
            rootCause: "TypeError: S is undefined",
            issueLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/issue/17?from=issues%2Fneeds-triage&issueOffset=10&issueType=EXCEPTION",
            sessionLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/s/4-9db65df9-57a5-4b94-b3d7-be87886b64ab/0?fromTab=latest",
            metricLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/metrics/4/metric/25",
            ticketUrl: ""
          }, {
            recordID: "4",
            tags: ["UX", "Poor Experience"],
            date: "04/16/2021",
            frequency: 25,
            impact: "25",
            description: 'Trend: User noticed rage-clicking on "Add to cart". Sluggish responsiveness but eventually works.',
            rootCause: "unclear; noticed with Rage Click filter",
            issueLink: "",
            sessionLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/s/4-9db65df9-57a5-4b94-b3d7-be87886b64ab/0?fromTab=latest",
            metricLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/metrics/4/metric/25",
            ticketUrl: ""
          }, {
            recordID: "5",
            tags: ["UX", "Poor Experience"],
            date: "04/16/2021",
            frequency: 50,
            impact: "50",
            description: 'Trend: Users seen struggling to click/accept the "we use cookies ... ok" button.',
            rootCause: "unclear; noticed with Rage Click filter",
            issueLink: "",
            sessionLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/s/4-9db65df9-57a5-4b94-b3d7-be87886b64ab/0?fromTab=latest",
            metricLink: "https://demo.logrocket.com/demo-kdz7k/logrocket/metrics/4/metric/25",
            ticketUrl: ""
          }]);
          exports2.APP_PROACTIVE_INSIGHTS = APP_PROACTIVE_INSIGHTS;
        },
        "./packages/@logrocket/utils/src/constants/issues.ts": function packagesLogrocketUtilsSrcConstantsIssuesTs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.ES_ISSUE_TYPE_BASE_FILTER = exports2.ES_ISSUE_TYPES = exports2.ISSUE_GROUP_TYPE = exports2.ISSUE_TYPE = void 0;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _ES_ISSUE_TYPE_BASE_F;

          var ISSUE_TYPE = {
            EXCEPTION: "EXCEPTION",
            NETWORK_ERROR: "NETWORK_ERROR",
            RAGE_CLICK: "RAGE_CLICK",
            DEAD_CLICK: "DEAD_CLICK",
            FRUSTRATING_NETWORK: "FRUSTRATING_NETWORK",
            ERROR_STATE: "ERROR_STATE"
          };
          exports2.ISSUE_TYPE = ISSUE_TYPE;
          var ISSUE_GROUP_TYPE = {
            ENCODED_FILTER: "ENCODED_FILTER",
            SENTRY: "SENTRY",
            TROYTOWN: "TROYTOWN"
          };
          exports2.ISSUE_GROUP_TYPE = ISSUE_GROUP_TYPE;
          var ES_ISSUE_TYPES = [ISSUE_TYPE.RAGE_CLICK, ISSUE_TYPE.DEAD_CLICK, ISSUE_TYPE.FRUSTRATING_NETWORK, ISSUE_TYPE.ERROR_STATE];
          exports2.ES_ISSUE_TYPES = ES_ISSUE_TYPES;
          var ES_ISSUE_TYPE_BASE_FILTER = (_ES_ISSUE_TYPE_BASE_F = {}, (0, _defineProperty2.default)(_ES_ISSUE_TYPE_BASE_F, ISSUE_TYPE.RAGE_CLICK, {
            rageClicked: {
              operator: "TEXT_IS",
              strings: []
            }
          }), (0, _defineProperty2.default)(_ES_ISSUE_TYPE_BASE_F, ISSUE_TYPE.DEAD_CLICK, {
            deadClicked: {
              operator: "TEXT_IS",
              strings: []
            }
          }), _ES_ISSUE_TYPE_BASE_F);
          exports2.ES_ISSUE_TYPE_BASE_FILTER = ES_ISSUE_TYPE_BASE_FILTER;
        },
        "./packages/@logrocket/utils/src/constants/logTypes.js": function packagesLogrocketUtilsSrcConstantsLogTypesJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.LOG_FILTER_TYPES = exports2.LOG_TYPES = void 0;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _LOG_FILTER_TYPES;

          var LOG_TYPES = {
            LOG: "LOG",
            WARN: "WARN",
            ERROR: "ERROR",
            DEBUG: "DEBUG",
            INFO: "INFO",
            REDUX: "REDUX",
            NAVIGATION: "NAVIGATION",
            NETWORK: "NETWORK",
            PREV_SESSION: "PREV_SESSION",
            NEXT_SESSION: "NEXT_SESSION",
            LOAD_MORE: "LOAD_MORE",
            EXCEPTION: "EXCEPTION"
          };
          exports2.LOG_TYPES = LOG_TYPES;
          var LOG_FILTER_TYPES = (_LOG_FILTER_TYPES = {}, (0, _defineProperty2.default)(_LOG_FILTER_TYPES, LOG_TYPES.LOG, {
            label: "Logs",
            filterLabel: "Log",
            types: [LOG_TYPES.LOG]
          }), (0, _defineProperty2.default)(_LOG_FILTER_TYPES, LOG_TYPES.WARN, {
            label: "Warnings",
            filterLabel: "Warning",
            types: [LOG_TYPES.WARN]
          }), (0, _defineProperty2.default)(_LOG_FILTER_TYPES, LOG_TYPES.ERROR, {
            label: "Errors",
            filterLabel: "Error",
            types: [LOG_TYPES.ERROR, LOG_TYPES.EXCEPTION]
          }), (0, _defineProperty2.default)(_LOG_FILTER_TYPES, LOG_TYPES.INFO, {
            label: "Info",
            filterLabel: "Info",
            types: [LOG_TYPES.INFO]
          }), (0, _defineProperty2.default)(_LOG_FILTER_TYPES, LOG_TYPES.DEBUG, {
            label: "Debug",
            filterLabel: "Debug",
            types: [LOG_TYPES.DEBUG]
          }), (0, _defineProperty2.default)(_LOG_FILTER_TYPES, LOG_TYPES.REDUX, {
            label: "Redux",
            types: [LOG_TYPES.REDUX]
          }), (0, _defineProperty2.default)(_LOG_FILTER_TYPES, LOG_TYPES.NAVIGATION, {
            label: "Navigation",
            types: [LOG_TYPES.NAVIGATION]
          }), _LOG_FILTER_TYPES);
          exports2.LOG_FILTER_TYPES = LOG_FILTER_TYPES;
        },
        "./packages/@logrocket/utils/src/constants/metrics.js": function packagesLogrocketUtilsSrcConstantsMetricsJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.DEFAULT_INSIGHTS_HEATMAP_FOR_URL_OPERATOR = exports2.DEFAULT_HEATMAP_FOR_URL_OPERATOR = exports2.nextSortDirection = exports2.SORT_DIRECTION = exports2.FEEDBACK_SORT_COLUMN = exports2.HEATMAP_FOR_URL_OPERATOR = exports2.METRIC_RETENTION_TYPE = exports2.METRIC_TIMESERIES_TYPE = void 0;
          var METRIC_TIMESERIES_TYPE = {
            SESSION_COUNT: "SESSION_COUNT",
            PERCENTILE: "PERCENTILE",
            CONVERSION_RATE: "CONVERSION_RATE",
            SESSION_PERCENTAGE: "SESSION_PERCENTAGE",
            ACTIVE_USERS: "ACTIVE_USERS",
            EVENT_COUNT: "EVENT_COUNT"
          };
          exports2.METRIC_TIMESERIES_TYPE = METRIC_TIMESERIES_TYPE;
          var METRIC_RETENTION_TYPE = {
            USER_PERCENTAGE: "USER_PERCENTAGE"
          };
          exports2.METRIC_RETENTION_TYPE = METRIC_RETENTION_TYPE;
          var HEATMAP_FOR_URL_OPERATOR = {
            IS: "IS",
            CONTAINS: "CONTAINS",
            LIKE: "LIKE",
            HREF_LIKE: "HREF_LIKE"
          };
          exports2.HEATMAP_FOR_URL_OPERATOR = HEATMAP_FOR_URL_OPERATOR;
          var FEEDBACK_SORT_COLUMN = {
            RATING: "RATING",
            SUBMISSION_DATE: "SUBMISSION_DATE"
          };
          exports2.FEEDBACK_SORT_COLUMN = FEEDBACK_SORT_COLUMN;
          var SORT_DIRECTION = {
            UNSET: "UNSET",
            ASC: "ASC",
            DESC: "DESC"
          };
          exports2.SORT_DIRECTION = SORT_DIRECTION;

          var nextSortDirection = function nextSortDirection2(direction) {
            var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                _ref$reverse = _ref.reverse,
                reverse = _ref$reverse === void 0 ? false : _ref$reverse;

            var UNSET = SORT_DIRECTION.UNSET,
                ASC = SORT_DIRECTION.ASC,
                DESC = SORT_DIRECTION.DESC;
            var directionOptions = [UNSET, DESC, ASC];

            if (reverse) {
              directionOptions = [UNSET, ASC, DESC];
            }

            var index = directionOptions.indexOf(direction);
            return directionOptions[(index + 1) % directionOptions.length];
          };

          exports2.nextSortDirection = nextSortDirection;
          var DEFAULT_HEATMAP_FOR_URL_OPERATOR = HEATMAP_FOR_URL_OPERATOR.IS;
          exports2.DEFAULT_HEATMAP_FOR_URL_OPERATOR = DEFAULT_HEATMAP_FOR_URL_OPERATOR;
          var DEFAULT_INSIGHTS_HEATMAP_FOR_URL_OPERATOR = HEATMAP_FOR_URL_OPERATOR.HREF_LIKE;
          exports2.DEFAULT_INSIGHTS_HEATMAP_FOR_URL_OPERATOR = DEFAULT_INSIGHTS_HEATMAP_FOR_URL_OPERATOR;
        },
        "./packages/@logrocket/utils/src/constants/mobile.ts": function packagesLogrocketUtilsSrcConstantsMobileTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.MAXIMUM_SUPPORTED_VERSION = exports2.MINIMUM_SUPPORTED_VERSION = exports2.IOS_VERSION = exports2.ANDROID_VERSION = void 0;
          var ANDROID_VERSION = "1.16.4";
          exports2.ANDROID_VERSION = ANDROID_VERSION;
          var IOS_VERSION = "1.16.4";
          exports2.IOS_VERSION = IOS_VERSION;
          var MINIMUM_SUPPORTED_VERSION = "1.0.0";
          exports2.MINIMUM_SUPPORTED_VERSION = MINIMUM_SUPPORTED_VERSION;
          var MAXIMUM_SUPPORTED_VERSION = "1.17.0";
          exports2.MAXIMUM_SUPPORTED_VERSION = MAXIMUM_SUPPORTED_VERSION;
        },
        "./packages/@logrocket/utils/src/constants/nps.js": function packagesLogrocketUtilsSrcConstantsNpsJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.DELIGHTED_FEEDBACK_PREFIX = exports2.DELIGHTED_RESPONSES_REGEX = exports2.WOOTRIC_RESPONSES_REGEX = void 0;
          var WOOTRIC_RESPONSES_REGEX = /^https:\/\/production.wootric.com\/responses/;
          exports2.WOOTRIC_RESPONSES_REGEX = WOOTRIC_RESPONSES_REGEX;
          var DELIGHTED_RESPONSES_REGEX = /^https:\/\/web.delighted.com\/e\/[a-zA-Z-]*\/c/;
          exports2.DELIGHTED_RESPONSES_REGEX = DELIGHTED_RESPONSES_REGEX;
          var DELIGHTED_FEEDBACK_PREFIX = "comment=";
          exports2.DELIGHTED_FEEDBACK_PREFIX = DELIGHTED_FEEDBACK_PREFIX;
        },
        "./packages/@logrocket/utils/src/constants/pageLoadMetrics.js": function packagesLogrocketUtilsSrcConstantsPageLoadMetricsJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.knownMetricTypes = void 0;
          var knownMetricTypes = ["cumulativeLayoutShift", "firstInputDelay", "initialPageLoadTime", "largestContentfulPaintTime", "timeToFirstByte"];
          exports2.knownMetricTypes = knownMetricTypes;
        },
        "./packages/@logrocket/utils/src/constants/replayTypes.ts": function packagesLogrocketUtilsSrcConstantsReplayTypesTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.REPLAY_TYPE = void 0;
          var REPLAY_TYPE;
          exports2.REPLAY_TYPE = REPLAY_TYPE;

          (function (REPLAY_TYPE2) {
            REPLAY_TYPE2["SKIA"] = "SKIA";
            REPLAY_TYPE2["DOM"] = "DOM";
            REPLAY_TYPE2["PDF"] = "PDF";
          })(REPLAY_TYPE || (exports2.REPLAY_TYPE = REPLAY_TYPE = {}));
        },
        "./packages/@logrocket/utils/src/constants/sdkTypes.ts": function packagesLogrocketUtilsSrcConstantsSdkTypesTs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.SESSION_TYPE_TO_DISPLAY = exports2.SDK_REPLAY_TYPE = exports2.SDK_TYPE_TO_DISPLAY = exports2.SDK_TYPE = void 0;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _replayTypes = __webpack_require__2("./packages/@logrocket/utils/src/constants/replayTypes.ts");

          var _SDK_TYPE_TO_DISPLAY, _SDK_REPLAY_TYPE;

          var SDK_TYPE;
          exports2.SDK_TYPE = SDK_TYPE;

          (function (SDK_TYPE2) {
            SDK_TYPE2["WEB"] = "web";
            SDK_TYPE2["MOBILE"] = "mobile";
            SDK_TYPE2["UNKNOWN"] = "unknown";
          })(SDK_TYPE || (exports2.SDK_TYPE = SDK_TYPE = {}));

          var SDK_TYPE_TO_DISPLAY = (_SDK_TYPE_TO_DISPLAY = {}, (0, _defineProperty2.default)(_SDK_TYPE_TO_DISPLAY, SDK_TYPE.WEB, "Web"), (0, _defineProperty2.default)(_SDK_TYPE_TO_DISPLAY, SDK_TYPE.MOBILE, "Mobile"), _SDK_TYPE_TO_DISPLAY);
          exports2.SDK_TYPE_TO_DISPLAY = SDK_TYPE_TO_DISPLAY;
          var SDK_REPLAY_TYPE = (_SDK_REPLAY_TYPE = {}, (0, _defineProperty2.default)(_SDK_REPLAY_TYPE, SDK_TYPE.WEB, _replayTypes.REPLAY_TYPE.DOM), (0, _defineProperty2.default)(_SDK_REPLAY_TYPE, SDK_TYPE.MOBILE, _replayTypes.REPLAY_TYPE.SKIA), _SDK_REPLAY_TYPE);
          exports2.SDK_REPLAY_TYPE = SDK_REPLAY_TYPE;
          var SESSION_TYPE_TO_DISPLAY = SDK_TYPE_TO_DISPLAY;
          exports2.SESSION_TYPE_TO_DISPLAY = SESSION_TYPE_TO_DISPLAY;
        },
        "./packages/@logrocket/utils/src/constants/statusCodes.ts": function packagesLogrocketUtilsSrcConstantsStatusCodesTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getStatusText = getStatusText;
          exports2.STATUS_CODES = void 0;
          var STATUS_CODES = {
            0: "",
            100: "Continue",
            101: "Switching Protocol",
            102: "Processing",
            103: "Early Hints",
            200: "OK",
            201: "Created",
            202: "Accepted",
            203: "Non-Authoritative Information",
            204: "No Content",
            205: "Reset Content",
            206: "Partial Content",
            207: "Multi-Status",
            208: "Already Reported",
            226: "IM Used",
            300: "Multiple Choices",
            301: "Moved Permanently",
            302: "Found",
            303: "See Other",
            304: "Not Modified",
            305: "Use Proxy",
            306: "unused",
            307: "Temporary Redirect",
            308: "Permanent Redirect",
            400: "Bad Request",
            401: "Unauthorized",
            402: "Payment Required",
            403: "Forbidden",
            404: "Not Found",
            405: "Method Not Allowed",
            406: "Not Acceptable",
            407: "Proxy Authentication Required",
            408: "Request Timeout",
            409: "Conflict",
            410: "Gone",
            411: "Length Required",
            412: "Precondition Failed",
            413: "Payload Too Large",
            414: "URI Too Long",
            415: "Unsupported Media Type",
            416: "Range Not Satisfiable",
            417: "Expectation Failed",
            418: "I'm a teapot",
            421: "Misdirected Request",
            422: "Unprocessable Entity",
            423: "Locked",
            424: "Failed Dependency",
            425: "Too Early",
            426: "Upgrade Required",
            428: "Precondition Required",
            429: "Too Many Requests",
            431: "Request Header Fields Too Large",
            451: "Unavailable For Legal Reasons",
            500: "Internal Server Error",
            501: "Not Implemented",
            502: "Bad Gateway",
            503: "Service Unavailable",
            504: "Gateway Timeout",
            505: "HTTP Version Not Supported",
            506: "Variant Also Negotiates",
            507: "Insufficient Storage",
            508: "Loop Detected",
            510: "Not Extended",
            511: "Network Authentication Required"
          };
          exports2.STATUS_CODES = STATUS_CODES;

          function getStatusText(statusCode) {
            return STATUS_CODES[String(statusCode)];
          }
        },
        "./packages/@logrocket/utils/src/contains.js": function packagesLogrocketUtilsSrcContainsJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = contains;

          function contains(value, search) {
            return value && search && value.indexOf(search) > -1;
          }
        },
        "./packages/@logrocket/utils/src/deepArsonify.js": function packagesLogrocketUtilsSrcDeepArsonifyJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _typeof = __webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = deepArsonify;

          var ARSON = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/arson/src/index.js"));

          function _getRequireWildcardCache(nodeInterop) {
            if (typeof WeakMap !== "function") return null;
            var cacheBabelInterop = /* @__PURE__ */new WeakMap();
            var cacheNodeInterop = /* @__PURE__ */new WeakMap();
            return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
              return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
            })(nodeInterop);
          }

          function _interopRequireWildcard(obj, nodeInterop) {
            if (!nodeInterop && obj && obj.__esModule) {
              return obj;
            }

            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }

            var cache = _getRequireWildcardCache(nodeInterop);

            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }

            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var key in obj) {
              if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }

            newObj.default = obj;

            if (cache) {
              cache.set(obj, newObj);
            }

            return newObj;
          }

          function deepArsonify(data) {
            return {
              arson: ARSON.encode(data)
            };
          }
        },
        "./packages/@logrocket/utils/src/deepDearsonify.js": function packagesLogrocketUtilsSrcDeepDearsonifyJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _typeof = __webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = deepDearsonify;

          var ARSON = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/arson/src/index.js"));

          function _getRequireWildcardCache(nodeInterop) {
            if (typeof WeakMap !== "function") return null;
            var cacheBabelInterop = /* @__PURE__ */new WeakMap();
            var cacheNodeInterop = /* @__PURE__ */new WeakMap();
            return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
              return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
            })(nodeInterop);
          }

          function _interopRequireWildcard(obj, nodeInterop) {
            if (!nodeInterop && obj && obj.__esModule) {
              return obj;
            }

            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }

            var cache = _getRequireWildcardCache(nodeInterop);

            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }

            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var key in obj) {
              if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }

            newObj.default = obj;

            if (cache) {
              cache.set(obj, newObj);
            }

            return newObj;
          }

          function deepDearsonify(data) {
            if (!data) {
              return data;
            }

            return ARSON.decode(data.arson);
          }
        },
        "./packages/@logrocket/utils/src/demo.js": function packagesLogrocketUtilsSrcDemoJs(__unused_webpack_module, exports2, __webpack_require__2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.isSandboxOrg = exports2.isDemoOrg = exports2.isDemoApp = exports2.isDemoAppOrSandbox = void 0;

          var _demo = __webpack_require__2("./packages/@logrocket/utils/src/constants/demo.js");

          var isDemoAppOrSandbox = function isDemoAppOrSandbox2(appID) {
            return appID === _demo.DEMO_APP_ID || appID.split("/")[0] === _demo.SANDBOX_SOURCE_ORG_SLUG;
          };

          exports2.isDemoAppOrSandbox = isDemoAppOrSandbox;

          var isDemoApp = function isDemoApp2(appID) {
            return appID === _demo.DEMO_APP_ID;
          };

          exports2.isDemoApp = isDemoApp;

          var isDemoOrg = function isDemoOrg2(slug) {
            if (!slug) {
              return false;
            }

            var orgSlug = slug.split("/")[0];
            return orgSlug === _demo.DEMO_ORG_SLUG || orgSlug === _demo.SANDBOX_SOURCE_ORG_SLUG;
          };

          exports2.isDemoOrg = isDemoOrg;

          var isSandboxOrg = function isSandboxOrg2(slug) {
            if (!slug) {
              return false;
            }

            var orgSlug = slug.split("/")[0];
            return orgSlug === _demo.SANDBOX_SOURCE_ORG_SLUG;
          };

          exports2.isSandboxOrg = isSandboxOrg;
        },
        "./packages/@logrocket/utils/src/endsWith.js": function packagesLogrocketUtilsSrcEndsWithJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = endsWith;

          function endsWith(value, search) {
            return value && search && value.substring(value.length - search.length) === search;
          }
        },
        "./packages/@logrocket/utils/src/enhanceFunc.js": function packagesLogrocketUtilsSrcEnhanceFuncJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = enhanceFunc;

          function enhanceFunc(obj, method, handler) {
            var original = obj[method];

            function shim() {
              var res;

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              if (original) {
                res = original.apply(this, args);
              }

              handler.apply(this, args);
              return res;
            }

            obj[method] = shim;
            return function () {
              obj[method] = original;
            };
          }
        },
        "./packages/@logrocket/utils/src/find.js": function packagesLogrocketUtilsSrcFindJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = find;

          function find(array, predicate) {
            for (var idx = 0; idx < array.length; idx++) {
              if (predicate(array[idx])) {
                return array[idx];
              }
            }
          }
        },
        "./packages/@logrocket/utils/src/findIndex.js": function packagesLogrocketUtilsSrcFindIndexJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = findIndex;

          function findIndex(array, predicate) {
            for (var idx = 0; idx < array.length; idx++) {
              if (predicate(array[idx])) {
                return idx;
              }
            }

            return -1;
          }
        },
        "./packages/@logrocket/utils/src/findKeyFrames.js": function packagesLogrocketUtilsSrcFindKeyFramesJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = findKeyFrames;

          var _sortedLastIndexBy = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/sortedLastIndexBy.js"));

          function findKeyFrames(futures, time) {
            var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {},
                _ref$sdkThrottle = _ref.sdkThrottle,
                sdkThrottle = _ref$sdkThrottle === void 0 ? 500 : _ref$sdkThrottle;

            if (!futures.length) {
              return null;
            }

            var index = (0, _sortedLastIndexBy.default)(futures, {
              time
            }, "time");
            var next = futures[index] || futures[index - 1];
            var prev = futures[index - 1] || next;
            var totalTime = Math.min(next.time - prev.time, sdkThrottle);
            var expired = Math.max(time - (next.time - totalTime), 0);
            var ratio = totalTime === 0 ? 1 : Math.min(expired / totalTime, 1);
            return {
              prev,
              next,
              ratio
            };
          }
        },
        "./packages/@logrocket/utils/src/flatten.js": function packagesLogrocketUtilsSrcFlattenJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = flatten;

          function flatten(acc, current) {
            return acc.concat(current);
          }
        },
        "./packages/@logrocket/utils/src/getCssRules.ts": function packagesLogrocketUtilsSrcGetCssRulesTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getCssRule = exports2.getCssRules = void 0;

          var getCssRules = function getCssRules2(sheetOrRule) {
            try {
              var cssRules = sheetOrRule.cssRules;

              if (!cssRules && sheetOrRule instanceof CSSStyleSheet) {
                return sheetOrRule.rules;
              }

              return cssRules;
            } catch (err) {
              return null;
            }
          };

          exports2.getCssRules = getCssRules;

          var getCssRule = function getCssRule2(sheetOrRule, ruleIndex) {
            var rules = getCssRules(sheetOrRule);

            if (!rules || ruleIndex >= rules.length) {
              return null;
            }

            return rules.item(ruleIndex);
          };

          exports2.getCssRule = getCssRule;
        },
        "./packages/@logrocket/utils/src/getGraphQLOperation.js": function packagesLogrocketUtilsSrcGetGraphQLOperationJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = getGraphQLOperation;

          function getGraphQLOperation(body) {
            if (body) {
              try {
                var parsedBody = typeof body === "string" ? JSON.parse(body) : body;
                var query = parsedBody.query.trim();
                var match = query.match(/(query|mutation) ([a-z_-]+)/i);

                if (!match) {
                  return {};
                }

                return {
                  operationType: match[1],
                  operationName: match[2]
                };
              } catch (_) {
                return {};
              }
            }

            return {};
          }
        },
        "./packages/@logrocket/utils/src/getMockDeveloperUser.js": function packagesLogrocketUtilsSrcGetMockDeveloperUserJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = getMockDeveloperUser;

          function getMockDeveloperUser() {
            return {
              permissions: {
                dashboard: {
                  metrics: true,
                  errors: true
                },
                sessionPlayback: {
                  developerPane: {
                    networkPane: {
                      requestBodiesAndHeaders: true
                    }
                  }
                }
              },
              appRoles: []
            };
          }
        },
        "./packages/@logrocket/utils/src/getNodeSelector.js": function packagesLogrocketUtilsSrcGetNodeSelectorJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = void 0;

          var _protectFunc = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/protectFunc.js"));

          var getNodeSelector = (0, _protectFunc.default)(function (node) {
            var nodeName = node.nodeName ? node.nodeName.toLowerCase() : "";
            var selector = {
              nodeName
            };

            if (node.id && node.id.length > 0) {
              selector.id = node.id;
            }

            if (node.classList && node.classList.length > 0) {
              selector.classList = Array.prototype.slice.call(node.classList, 0);
            }

            return selector;
          });
          var _default = getNodeSelector;
          exports2["default"] = _default;
        },
        "./packages/@logrocket/utils/src/hashString.js": function packagesLogrocketUtilsSrcHashStringJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.combineHashes = exports2.hashString = void 0;

          var _protectFunc = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/protectFunc.js"));

          var _sendTelemetryData = __webpack_require__2("./packages/@logrocket/utils/src/sendTelemetryData.js");

          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;

                var F = function F2() {};

                return {
                  s: F,
                  n: function n2() {
                    if (i >= o.length) return {
                      done: true
                    };
                    return {
                      done: false,
                      value: o[i++]
                    };
                  },
                  e: function e(_e) {
                    throw _e;
                  },
                  f: F
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            var normalCompletion = true,
                didErr = false,
                err;
            return {
              s: function s() {
                it = it.call(o);
              },
              n: function n2() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
              },
              e: function e(_e2) {
                didErr = true;
                err = _e2;
              },
              f: function f2() {
                try {
                  if (!normalCompletion && it.return != null) it.return();
                } finally {
                  if (didErr) throw err;
                }
              }
            };
          }

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
          }

          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          var hashString = (0, _protectFunc.default)(function (str) {
            try {
              var hash = 0;

              if (typeof str === "string" && str.length) {
                for (var i = 0; i < str.length; i++) {
                  hash = 31 * hash + str.charCodeAt(i);
                  hash |= 0;
                }
              }

              return hash;
            } catch (err) {
              (0, _sendTelemetryData.sendTelemetry)("Failed to hash string", {
                extra: {
                  str
                }
              });
              return null;
            }
          });
          exports2.hashString = hashString;

          var combineHashes = function combineHashes2(hashes) {
            var out = hashes.shift() || 0;

            var _iterator = _createForOfIteratorHelper(hashes),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var hash = _step.value;
                out ^= hash + 2654435769 + (out << 6) + (out >> 2);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return out;
          };

          exports2.combineHashes = combineHashes;
        },
        "./packages/@logrocket/utils/src/identityStatus.ts": function packagesLogrocketUtilsSrcIdentityStatusTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.parseIdentityStatus = parseIdentityStatus;
          exports2.IdentityStatus = void 0;
          var IdentityStatus;
          exports2.IdentityStatus = IdentityStatus;

          (function (IdentityStatus2) {
            IdentityStatus2[IdentityStatus2["Unknown"] = 0] = "Unknown";
            IdentityStatus2[IdentityStatus2["Anonymous"] = 1] = "Anonymous";
            IdentityStatus2[IdentityStatus2["Identified"] = 2] = "Identified";
          })(IdentityStatus || (exports2.IdentityStatus = IdentityStatus = {}));

          function parseIdentityStatus(val) {
            if (!val) {
              return IdentityStatus.Unknown;
            }

            switch (parseInt(val, 10)) {
              case IdentityStatus.Anonymous:
                return IdentityStatus.Anonymous;

              case IdentityStatus.Identified:
                return IdentityStatus.Identified;

              default:
                return IdentityStatus.Unknown;
            }
          }
        },
        "./packages/@logrocket/utils/src/index.js": function packagesLogrocketUtilsSrcIndexJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          var _typeof = __webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _exportNames = {
            enhanceFunc: true,
            shallowArsonify: true,
            shallowDearsonify: true,
            deepArsonify: true,
            deepDearsonify: true,
            addListener: true,
            protectFunc: true,
            findIndex: true,
            find: true,
            flatten: true,
            selectorMatches: true,
            parseSelectorForMatch: true,
            parseSelectorForSearch: true,
            ParsedSelector: true,
            isInvalidSelector: true,
            querySelectorWithShadowDom: true,
            sendErrorTelemetry: true,
            sendTelemetry: true,
            sanitizeValue: true,
            adjustOs: true,
            adjustOsVersion: true,
            selectorFromNodePath: true,
            startsWith: true,
            endsWith: true,
            contains: true,
            uuid: true,
            randomInt: true,
            getCssRules: true,
            getCssRule: true,
            getNodeSelector: true,
            getGraphQLOperation: true,
            isSessionEvent: true,
            isActivityEvent: true,
            parseIntFromHex: true,
            isRecordingSampled: true,
            makeRecordingID: true,
            setFromArray: true,
            setToArray: true,
            applyUrlSanitizer: true,
            getMockDeveloperUser: true,
            isDemoAppOrSandbox: true,
            isDemoOrg: true,
            isSandboxOrg: true,
            isDemoApp: true,
            LOG_FILTER_TYPES: true,
            LOG_TYPES: true,
            METRIC_TIMESERIES_TYPE: true,
            HEATMAP_FOR_URL_OPERATOR: true,
            DEFAULT_HEATMAP_FOR_URL_OPERATOR: true,
            DEFAULT_INSIGHTS_HEATMAP_FOR_URL_OPERATOR: true,
            SORT_DIRECTION: true,
            FEEDBACK_SORT_COLUMN: true,
            METRIC_RETENTION_TYPE: true,
            ISSUE_TYPE: true,
            ISSUE_GROUP_TYPE: true,
            ES_ISSUE_TYPE_BASE_FILTER: true,
            ES_ISSUE_TYPES: true,
            findKeyFrames: true,
            interpolate: true,
            interpolateMobile: true,
            removeOutdated: true,
            APP_PROACTIVE_INSIGHTS: true,
            DEMO_ORG_SLUG: true,
            DEMO_APP_SLUG: true,
            DEMO_APP_ID: true,
            SANDBOX_SOURCE_ORG_SLUG: true,
            knownMetricTypes: true,
            DELIGHTED_RESPONSES_REGEX: true,
            WOOTRIC_RESPONSES_REGEX: true,
            REPLAY_TYPE: true,
            SDK_REPLAY_TYPE: true,
            SDK_TYPE: true,
            SDK_TYPE_TO_DISPLAY: true,
            SESSION_TYPE_TO_DISPLAY: true,
            STATUS_CODES: true,
            getStatusText: true,
            parseQueryString: true,
            likeOperator: true,
            scrollMapHistogramToPercent: true,
            combineHashes: true,
            hashString: true,
            ValueOf: true,
            MakeOptional: true,
            encodeUserTraitString: true,
            parseUserTraitString: true,
            IdentityStatus: true,
            parseIdentityStatus: true,
            MobileConstants: true
          };
          Object.defineProperty(exports2, "enhanceFunc", {
            enumerable: true,
            get: function get() {
              return _enhanceFunc.default;
            }
          });
          Object.defineProperty(exports2, "shallowArsonify", {
            enumerable: true,
            get: function get() {
              return _shallowArsonify.default;
            }
          });
          Object.defineProperty(exports2, "shallowDearsonify", {
            enumerable: true,
            get: function get() {
              return _shallowDearsonify.default;
            }
          });
          Object.defineProperty(exports2, "deepArsonify", {
            enumerable: true,
            get: function get() {
              return _deepArsonify.default;
            }
          });
          Object.defineProperty(exports2, "deepDearsonify", {
            enumerable: true,
            get: function get() {
              return _deepDearsonify.default;
            }
          });
          Object.defineProperty(exports2, "addListener", {
            enumerable: true,
            get: function get() {
              return _addListener.default;
            }
          });
          Object.defineProperty(exports2, "protectFunc", {
            enumerable: true,
            get: function get() {
              return _protectFunc.default;
            }
          });
          Object.defineProperty(exports2, "findIndex", {
            enumerable: true,
            get: function get() {
              return _findIndex.default;
            }
          });
          Object.defineProperty(exports2, "find", {
            enumerable: true,
            get: function get() {
              return _find.default;
            }
          });
          Object.defineProperty(exports2, "flatten", {
            enumerable: true,
            get: function get() {
              return _flatten.default;
            }
          });
          Object.defineProperty(exports2, "selectorMatches", {
            enumerable: true,
            get: function get() {
              return _selectorMatches.default;
            }
          });
          Object.defineProperty(exports2, "parseSelectorForMatch", {
            enumerable: true,
            get: function get() {
              return _parseSelectorForMatch.default;
            }
          });
          Object.defineProperty(exports2, "parseSelectorForSearch", {
            enumerable: true,
            get: function get() {
              return _parseSelectorForSearch.default;
            }
          });
          Object.defineProperty(exports2, "ParsedSelector", {
            enumerable: true,
            get: function get() {
              return _parseSelectorForSearch.ParsedSelector;
            }
          });
          Object.defineProperty(exports2, "isInvalidSelector", {
            enumerable: true,
            get: function get() {
              return _parseSelectorForSearch.isInvalidSelector;
            }
          });
          Object.defineProperty(exports2, "querySelectorWithShadowDom", {
            enumerable: true,
            get: function get() {
              return _querySelectorWithShadowDom.default;
            }
          });
          Object.defineProperty(exports2, "sendErrorTelemetry", {
            enumerable: true,
            get: function get() {
              return _sendTelemetryData.default;
            }
          });
          Object.defineProperty(exports2, "sendTelemetry", {
            enumerable: true,
            get: function get() {
              return _sendTelemetryData.sendTelemetry;
            }
          });
          Object.defineProperty(exports2, "sanitizeValue", {
            enumerable: true,
            get: function get() {
              return _sanitizeValue.default;
            }
          });
          Object.defineProperty(exports2, "adjustOs", {
            enumerable: true,
            get: function get() {
              return _adjustOsVersion.adjustOs;
            }
          });
          Object.defineProperty(exports2, "adjustOsVersion", {
            enumerable: true,
            get: function get() {
              return _adjustOsVersion.adjustOsVersion;
            }
          });
          Object.defineProperty(exports2, "selectorFromNodePath", {
            enumerable: true,
            get: function get() {
              return _selectorFromNodePath.default;
            }
          });
          Object.defineProperty(exports2, "startsWith", {
            enumerable: true,
            get: function get() {
              return _startsWith.default;
            }
          });
          Object.defineProperty(exports2, "endsWith", {
            enumerable: true,
            get: function get() {
              return _endsWith.default;
            }
          });
          Object.defineProperty(exports2, "contains", {
            enumerable: true,
            get: function get() {
              return _contains.default;
            }
          });
          Object.defineProperty(exports2, "uuid", {
            enumerable: true,
            get: function get() {
              return _uuid.default;
            }
          });
          Object.defineProperty(exports2, "randomInt", {
            enumerable: true,
            get: function get() {
              return _randomInt.default;
            }
          });
          Object.defineProperty(exports2, "getCssRules", {
            enumerable: true,
            get: function get() {
              return _getCssRules.getCssRules;
            }
          });
          Object.defineProperty(exports2, "getCssRule", {
            enumerable: true,
            get: function get() {
              return _getCssRules.getCssRule;
            }
          });
          Object.defineProperty(exports2, "getNodeSelector", {
            enumerable: true,
            get: function get() {
              return _getNodeSelector.default;
            }
          });
          Object.defineProperty(exports2, "getGraphQLOperation", {
            enumerable: true,
            get: function get() {
              return _getGraphQLOperation.default;
            }
          });
          Object.defineProperty(exports2, "isSessionEvent", {
            enumerable: true,
            get: function get() {
              return _isSessionEvent.default;
            }
          });
          Object.defineProperty(exports2, "isActivityEvent", {
            enumerable: true,
            get: function get() {
              return _isActivityEvent.default;
            }
          });
          Object.defineProperty(exports2, "parseIntFromHex", {
            enumerable: true,
            get: function get() {
              return _parseIntFromHex.default;
            }
          });
          Object.defineProperty(exports2, "isRecordingSampled", {
            enumerable: true,
            get: function get() {
              return _isRecordingSampled.default;
            }
          });
          Object.defineProperty(exports2, "makeRecordingID", {
            enumerable: true,
            get: function get() {
              return _makeRecordingID.default;
            }
          });
          Object.defineProperty(exports2, "setFromArray", {
            enumerable: true,
            get: function get() {
              return _setFromArray.default;
            }
          });
          Object.defineProperty(exports2, "setToArray", {
            enumerable: true,
            get: function get() {
              return _setToArray.default;
            }
          });
          Object.defineProperty(exports2, "applyUrlSanitizer", {
            enumerable: true,
            get: function get() {
              return _applyUrlSanitizer.default;
            }
          });
          Object.defineProperty(exports2, "getMockDeveloperUser", {
            enumerable: true,
            get: function get() {
              return _getMockDeveloperUser.default;
            }
          });
          Object.defineProperty(exports2, "isDemoAppOrSandbox", {
            enumerable: true,
            get: function get() {
              return _demo.isDemoAppOrSandbox;
            }
          });
          Object.defineProperty(exports2, "isDemoOrg", {
            enumerable: true,
            get: function get() {
              return _demo.isDemoOrg;
            }
          });
          Object.defineProperty(exports2, "isSandboxOrg", {
            enumerable: true,
            get: function get() {
              return _demo.isSandboxOrg;
            }
          });
          Object.defineProperty(exports2, "isDemoApp", {
            enumerable: true,
            get: function get() {
              return _demo.isDemoApp;
            }
          });
          Object.defineProperty(exports2, "LOG_FILTER_TYPES", {
            enumerable: true,
            get: function get() {
              return _logTypes.LOG_FILTER_TYPES;
            }
          });
          Object.defineProperty(exports2, "LOG_TYPES", {
            enumerable: true,
            get: function get() {
              return _logTypes.LOG_TYPES;
            }
          });
          Object.defineProperty(exports2, "METRIC_TIMESERIES_TYPE", {
            enumerable: true,
            get: function get() {
              return _metrics.METRIC_TIMESERIES_TYPE;
            }
          });
          Object.defineProperty(exports2, "HEATMAP_FOR_URL_OPERATOR", {
            enumerable: true,
            get: function get() {
              return _metrics.HEATMAP_FOR_URL_OPERATOR;
            }
          });
          Object.defineProperty(exports2, "DEFAULT_HEATMAP_FOR_URL_OPERATOR", {
            enumerable: true,
            get: function get() {
              return _metrics.DEFAULT_HEATMAP_FOR_URL_OPERATOR;
            }
          });
          Object.defineProperty(exports2, "DEFAULT_INSIGHTS_HEATMAP_FOR_URL_OPERATOR", {
            enumerable: true,
            get: function get() {
              return _metrics.DEFAULT_INSIGHTS_HEATMAP_FOR_URL_OPERATOR;
            }
          });
          Object.defineProperty(exports2, "SORT_DIRECTION", {
            enumerable: true,
            get: function get() {
              return _metrics.SORT_DIRECTION;
            }
          });
          Object.defineProperty(exports2, "FEEDBACK_SORT_COLUMN", {
            enumerable: true,
            get: function get() {
              return _metrics.FEEDBACK_SORT_COLUMN;
            }
          });
          Object.defineProperty(exports2, "METRIC_RETENTION_TYPE", {
            enumerable: true,
            get: function get() {
              return _metrics.METRIC_RETENTION_TYPE;
            }
          });
          Object.defineProperty(exports2, "ISSUE_TYPE", {
            enumerable: true,
            get: function get() {
              return _issues.ISSUE_TYPE;
            }
          });
          Object.defineProperty(exports2, "ISSUE_GROUP_TYPE", {
            enumerable: true,
            get: function get() {
              return _issues.ISSUE_GROUP_TYPE;
            }
          });
          Object.defineProperty(exports2, "ES_ISSUE_TYPE_BASE_FILTER", {
            enumerable: true,
            get: function get() {
              return _issues.ES_ISSUE_TYPE_BASE_FILTER;
            }
          });
          Object.defineProperty(exports2, "ES_ISSUE_TYPES", {
            enumerable: true,
            get: function get() {
              return _issues.ES_ISSUE_TYPES;
            }
          });
          Object.defineProperty(exports2, "findKeyFrames", {
            enumerable: true,
            get: function get() {
              return _findKeyFrames.default;
            }
          });
          Object.defineProperty(exports2, "interpolate", {
            enumerable: true,
            get: function get() {
              return _interpolate.default;
            }
          });
          Object.defineProperty(exports2, "interpolateMobile", {
            enumerable: true,
            get: function get() {
              return _interpolate.interpolateMobile;
            }
          });
          Object.defineProperty(exports2, "removeOutdated", {
            enumerable: true,
            get: function get() {
              return _removeOutdated.default;
            }
          });
          Object.defineProperty(exports2, "APP_PROACTIVE_INSIGHTS", {
            enumerable: true,
            get: function get() {
              return _demo2.APP_PROACTIVE_INSIGHTS;
            }
          });
          Object.defineProperty(exports2, "DEMO_ORG_SLUG", {
            enumerable: true,
            get: function get() {
              return _demo2.DEMO_ORG_SLUG;
            }
          });
          Object.defineProperty(exports2, "DEMO_APP_SLUG", {
            enumerable: true,
            get: function get() {
              return _demo2.DEMO_APP_SLUG;
            }
          });
          Object.defineProperty(exports2, "DEMO_APP_ID", {
            enumerable: true,
            get: function get() {
              return _demo2.DEMO_APP_ID;
            }
          });
          Object.defineProperty(exports2, "SANDBOX_SOURCE_ORG_SLUG", {
            enumerable: true,
            get: function get() {
              return _demo2.SANDBOX_SOURCE_ORG_SLUG;
            }
          });
          Object.defineProperty(exports2, "knownMetricTypes", {
            enumerable: true,
            get: function get() {
              return _pageLoadMetrics.knownMetricTypes;
            }
          });
          Object.defineProperty(exports2, "DELIGHTED_RESPONSES_REGEX", {
            enumerable: true,
            get: function get() {
              return _nps.DELIGHTED_RESPONSES_REGEX;
            }
          });
          Object.defineProperty(exports2, "WOOTRIC_RESPONSES_REGEX", {
            enumerable: true,
            get: function get() {
              return _nps.WOOTRIC_RESPONSES_REGEX;
            }
          });
          Object.defineProperty(exports2, "REPLAY_TYPE", {
            enumerable: true,
            get: function get() {
              return _replayTypes.REPLAY_TYPE;
            }
          });
          Object.defineProperty(exports2, "SDK_REPLAY_TYPE", {
            enumerable: true,
            get: function get() {
              return _sdkTypes.SDK_REPLAY_TYPE;
            }
          });
          Object.defineProperty(exports2, "SDK_TYPE", {
            enumerable: true,
            get: function get() {
              return _sdkTypes.SDK_TYPE;
            }
          });
          Object.defineProperty(exports2, "SDK_TYPE_TO_DISPLAY", {
            enumerable: true,
            get: function get() {
              return _sdkTypes.SDK_TYPE_TO_DISPLAY;
            }
          });
          Object.defineProperty(exports2, "SESSION_TYPE_TO_DISPLAY", {
            enumerable: true,
            get: function get() {
              return _sdkTypes.SESSION_TYPE_TO_DISPLAY;
            }
          });
          Object.defineProperty(exports2, "STATUS_CODES", {
            enumerable: true,
            get: function get() {
              return _statusCodes.STATUS_CODES;
            }
          });
          Object.defineProperty(exports2, "getStatusText", {
            enumerable: true,
            get: function get() {
              return _statusCodes.getStatusText;
            }
          });
          Object.defineProperty(exports2, "parseQueryString", {
            enumerable: true,
            get: function get() {
              return _parseQueryString.parseQueryString;
            }
          });
          Object.defineProperty(exports2, "likeOperator", {
            enumerable: true,
            get: function get() {
              return _likeOperator.likeOperator;
            }
          });
          Object.defineProperty(exports2, "scrollMapHistogramToPercent", {
            enumerable: true,
            get: function get() {
              return _scrollMapHistogramToPercent.default;
            }
          });
          Object.defineProperty(exports2, "combineHashes", {
            enumerable: true,
            get: function get() {
              return _hashString.combineHashes;
            }
          });
          Object.defineProperty(exports2, "hashString", {
            enumerable: true,
            get: function get() {
              return _hashString.hashString;
            }
          });
          Object.defineProperty(exports2, "ValueOf", {
            enumerable: true,
            get: function get() {
              return _types.ValueOf;
            }
          });
          Object.defineProperty(exports2, "MakeOptional", {
            enumerable: true,
            get: function get() {
              return _types.MakeOptional;
            }
          });
          Object.defineProperty(exports2, "encodeUserTraitString", {
            enumerable: true,
            get: function get() {
              return _userTraitStrings.encodeUserTraitString;
            }
          });
          Object.defineProperty(exports2, "parseUserTraitString", {
            enumerable: true,
            get: function get() {
              return _userTraitStrings.parseUserTraitString;
            }
          });
          Object.defineProperty(exports2, "IdentityStatus", {
            enumerable: true,
            get: function get() {
              return _identityStatus.IdentityStatus;
            }
          });
          Object.defineProperty(exports2, "parseIdentityStatus", {
            enumerable: true,
            get: function get() {
              return _identityStatus.parseIdentityStatus;
            }
          });
          exports2.MobileConstants = void 0;

          var _enhanceFunc = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/enhanceFunc.js"));

          var _shallowArsonify = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/shallowArsonify.js"));

          var _shallowDearsonify = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/shallowDearsonify.js"));

          var _deepArsonify = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/deepArsonify.js"));

          var _deepDearsonify = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/deepDearsonify.js"));

          var _addListener = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/addListener.js"));

          var _protectFunc = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/protectFunc.js"));

          var _findIndex = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/findIndex.js"));

          var _find = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/find.js"));

          var _flatten = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/flatten.js"));

          var _selectorMatches = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/selectorMatches.js"));

          var _parseSelectorForMatch = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/parseSelectorForMatch.js"));

          var _parseSelectorForSearch = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/utils/src/parseSelectorForSearch.ts"));

          var _querySelectorWithShadowDom = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/querySelectorWithShadowDom.js"));

          var _sendTelemetryData = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/utils/src/sendTelemetryData.js"));

          var _sanitizeValue = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/sanitizeValue.js"));

          var _adjustOsVersion = __webpack_require__2("./packages/@logrocket/utils/src/adjustOsVersion.ts");

          var _selectorFromNodePath = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/selectorFromNodePath.js"));

          var _startsWith = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/startsWith.js"));

          var _endsWith = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/endsWith.js"));

          var _contains = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/contains.js"));

          var _uuid = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/uuid.js"));

          var _randomInt = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/randomInt.js"));

          var _getCssRules = __webpack_require__2("./packages/@logrocket/utils/src/getCssRules.ts");

          var _getNodeSelector = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/getNodeSelector.js"));

          var _getGraphQLOperation = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/getGraphQLOperation.js"));

          var _isSessionEvent = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/isSessionEvent.js"));

          var _isActivityEvent = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/isActivityEvent.js"));

          var _parseIntFromHex = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/parseIntFromHex.js"));

          var _isRecordingSampled = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/isRecordingSampled.js"));

          var _makeRecordingID = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/makeRecordingID.js"));

          var _setFromArray = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/setFromArray.js"));

          var _setToArray = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/setToArray.js"));

          var _applyUrlSanitizer = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/applyUrlSanitizer.js"));

          var _getMockDeveloperUser = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/getMockDeveloperUser.js"));

          var _demo = __webpack_require__2("./packages/@logrocket/utils/src/demo.js");

          var _logTypes = __webpack_require__2("./packages/@logrocket/utils/src/constants/logTypes.js");

          var _metrics = __webpack_require__2("./packages/@logrocket/utils/src/constants/metrics.js");

          var _issues = __webpack_require__2("./packages/@logrocket/utils/src/constants/issues.ts");

          var _findKeyFrames = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/findKeyFrames.js"));

          var _interpolate = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/utils/src/interpolate.js"));

          var _removeOutdated = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/removeOutdated.js"));

          var _demo2 = __webpack_require__2("./packages/@logrocket/utils/src/constants/demo.js");

          var _pageLoadMetrics = __webpack_require__2("./packages/@logrocket/utils/src/constants/pageLoadMetrics.js");

          var _nps = __webpack_require__2("./packages/@logrocket/utils/src/constants/nps.js");

          var _replayTypes = __webpack_require__2("./packages/@logrocket/utils/src/constants/replayTypes.ts");

          var _sdkTypes = __webpack_require__2("./packages/@logrocket/utils/src/constants/sdkTypes.ts");

          var _statusCodes = __webpack_require__2("./packages/@logrocket/utils/src/constants/statusCodes.ts");

          var _parseQueryString = __webpack_require__2("./packages/@logrocket/utils/src/parseQueryString.js");

          var _likeOperator = __webpack_require__2("./packages/@logrocket/utils/src/likeOperator.js");

          var _scrollMapHistogramToPercent = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/scrollMapHistogramToPercent.js"));

          var _hashString = __webpack_require__2("./packages/@logrocket/utils/src/hashString.js");

          var _types = __webpack_require__2("./packages/@logrocket/utils/src/types.ts");

          var _userTraitStrings = __webpack_require__2("./packages/@logrocket/utils/src/userTraitStrings.ts");

          var _identityStatus = __webpack_require__2("./packages/@logrocket/utils/src/identityStatus.ts");

          var _MobileConstants = _interopRequireWildcard(__webpack_require__2("./packages/@logrocket/utils/src/constants/mobile.ts"));

          exports2.MobileConstants = _MobileConstants;

          var _browserUtils = __webpack_require__2("./packages/@logrocket/utils/src/browserUtils.js");

          Object.keys(_browserUtils).forEach(function (key) {
            if (key === "default" || key === "__esModule") return;
            if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
            if (key in exports2 && exports2[key] === _browserUtils[key]) return;
            Object.defineProperty(exports2, key, {
              enumerable: true,
              get: function get() {
                return _browserUtils[key];
              }
            });
          });

          var _isValidAppID = __webpack_require__2("./packages/@logrocket/utils/src/isValidAppID.ts");

          Object.keys(_isValidAppID).forEach(function (key) {
            if (key === "default" || key === "__esModule") return;
            if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
            if (key in exports2 && exports2[key] === _isValidAppID[key]) return;
            Object.defineProperty(exports2, key, {
              enumerable: true,
              get: function get() {
                return _isValidAppID[key];
              }
            });
          });

          var _requireValue = __webpack_require__2("./packages/@logrocket/utils/src/requireValue.ts");

          Object.keys(_requireValue).forEach(function (key) {
            if (key === "default" || key === "__esModule") return;
            if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
            if (key in exports2 && exports2[key] === _requireValue[key]) return;
            Object.defineProperty(exports2, key, {
              enumerable: true,
              get: function get() {
                return _requireValue[key];
              }
            });
          });

          function _getRequireWildcardCache(nodeInterop) {
            if (typeof WeakMap !== "function") return null;
            var cacheBabelInterop = /* @__PURE__ */new WeakMap();
            var cacheNodeInterop = /* @__PURE__ */new WeakMap();
            return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
              return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
            })(nodeInterop);
          }

          function _interopRequireWildcard(obj, nodeInterop) {
            if (!nodeInterop && obj && obj.__esModule) {
              return obj;
            }

            if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
              return {
                default: obj
              };
            }

            var cache = _getRequireWildcardCache(nodeInterop);

            if (cache && cache.has(obj)) {
              return cache.get(obj);
            }

            var newObj = {};
            var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

            for (var key in obj) {
              if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

                if (desc && (desc.get || desc.set)) {
                  Object.defineProperty(newObj, key, desc);
                } else {
                  newObj[key] = obj[key];
                }
              }
            }

            newObj.default = obj;

            if (cache) {
              cache.set(obj, newObj);
            }

            return newObj;
          }
        },
        "./packages/@logrocket/utils/src/interpolate.js": function packagesLogrocketUtilsSrcInterpolateJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = interpolate;
          exports2.interpolateMobile = interpolateMobile;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;

                var F = function F2() {};

                return {
                  s: F,
                  n: function n2() {
                    if (i >= o.length) return {
                      done: true
                    };
                    return {
                      done: false,
                      value: o[i++]
                    };
                  },
                  e: function e(_e) {
                    throw _e;
                  },
                  f: F
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            var normalCompletion = true,
                didErr = false,
                err;
            return {
              s: function s() {
                it = it.call(o);
              },
              n: function n2() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
              },
              e: function e(_e2) {
                didErr = true;
                err = _e2;
              },
              f: function f2() {
                try {
                  if (!normalCompletion && it.return != null) it.return();
                } finally {
                  if (didErr) throw err;
                }
              }
            };
          }

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
          }

          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              enumerableOnly && (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })), keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2.default)(target, key, source[key]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }

            return target;
          }

          function interpolate(keyFrames, props) {
            if (!keyFrames) {
              return {};
            }

            var prev = keyFrames.prev,
                next = keyFrames.next,
                ratio = keyFrames.ratio;

            var mid = _objectSpread({}, next);

            var _iterator = _createForOfIteratorHelper(props),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var p2 = _step.value;
                mid[p2] = prev[p2] + (next[p2] - prev[p2]) * ratio;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return mid;
          }

          function interpolateMobile(keyFrames, props, time) {
            if (!keyFrames) {
              return {};
            }

            var prev = keyFrames.prev,
                next = keyFrames.next;

            if (next.type === "MOVE") {
              return interpolate(keyFrames, props);
            }

            if (prev === next && Math.abs(time - next.time) > 500) {
              return null;
            }

            return next;
          }
        },
        "./packages/@logrocket/utils/src/isActivityEvent.js": function packagesLogrocketUtilsSrcIsActivityEventJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = isActivityEvent;

          function isActivityEvent(type) {
            var activityTypes = ["lr.browser.MouseEvent", "lr.browser.ScrollEvent", "lr.browser.InputEvent", "lr.browser.InputChangeEvent", "lr.android.TouchEvent", "lr.android.InputChangeEvent", "lr.ios.TouchEvent", "lr.ios.InputChangeEvent"];
            return activityTypes.indexOf(type) > -1;
          }
        },
        "./packages/@logrocket/utils/src/isRecordingSampled.js": function packagesLogrocketUtilsSrcIsRecordingSampledJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = isRecordingSampled;

          var _parseIntFromHex = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/parseIntFromHex.js"));

          var SAMPLE_BUCKETS = 1e4;

          function isRecordingSampled(recordingID, samplePercent) {
            if (samplePercent <= 0) {
              return false;
            }

            var maxBucket = Math.floor(samplePercent * SAMPLE_BUCKETS);
            var num = (0, _parseIntFromHex.default)(recordingID);
            var bucket = num % SAMPLE_BUCKETS;
            return bucket <= maxBucket;
          }
        },
        "./packages/@logrocket/utils/src/isSessionEvent.js": function packagesLogrocketUtilsSrcIsSessionEventJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = isSessionEvent;
          var SESSION_EVENT_WHITELIST = ["lr.browser.NavigationEvent", "lr.browser.InputChangeEvent", "lr.browser.InputEvent"];

          function isSessionEvent(event) {
            return SESSION_EVENT_WHITELIST.indexOf(event.type) > -1 || event.data.eventType === "CLICK";
          }
        },
        "./packages/@logrocket/utils/src/isValidAppID.ts": function packagesLogrocketUtilsSrcIsValidAppIDTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.isValidAppID = isValidAppID;
          var APP_ID_PATTERN = /^[a-z0-9_-]+\/[a-z0-9_-]+$/;

          function isValidAppID(appID) {
            return typeof appID === "string" && APP_ID_PATTERN.test(appID);
          }
        },
        "./packages/@logrocket/utils/src/likeOperator.js": function packagesLogrocketUtilsSrcLikeOperatorJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.likeOperator = likeOperator;

          function likeOperator(value, pattern) {
            var escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            var escapedRegexString = escaped.replace(/\\\*/g, ".*").replace(/\\\?/g, ".");
            var regex = new RegExp("^".concat(escapedRegexString, "$"));
            return regex.test(value);
          }
        },
        "./packages/@logrocket/utils/src/logError.js": function packagesLogrocketUtilsSrcLogErrorJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = void 0;
          var canBind = typeof console !== "undefined" && console.error && console.error.bind;
          var logError = canBind ? console.error.bind(console) : function () {};
          var _default = logError;
          exports2["default"] = _default;
        },
        "./packages/@logrocket/utils/src/makeRecordingID.js": function packagesLogrocketUtilsSrcMakeRecordingIDJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = makeRecordingID;

          var _uuid = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/uuid.js"));

          function makeRecordingID() {
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                _ref$prefix = _ref.prefix,
                prefix = _ref$prefix === void 0 ? 5 : _ref$prefix;

            return "".concat(prefix, "-").concat((0, _uuid.default)());
          }
        },
        "./packages/@logrocket/utils/src/mapValues.js": function packagesLogrocketUtilsSrcMapValuesJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = mapValues;

          function mapValues(obj, f2) {
            if (obj == null) {
              return {};
            }

            var res = {};
            Object.keys(obj).forEach(function (key) {
              res[key] = f2(obj[key]);
            });
            return res;
          }
        },
        "./packages/@logrocket/utils/src/parseIntFromHex.js": function packagesLogrocketUtilsSrcParseIntFromHexJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = parseIntFromHex;

          function parseIntFromHex(string) {
            var hex = string.replace(/[^0-9a-f]/g, "");
            return parseInt("0x".concat(hex), 16) || 0;
          }
        },
        "./packages/@logrocket/utils/src/parseQueryString.js": function packagesLogrocketUtilsSrcParseQueryStringJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.parseQueryString = void 0;

          var _slicedToArray2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/slicedToArray.js"));

          var parseSearchParams = function parseSearchParams2(queryString) {
            var params = {};
            var fragments = queryString.split("&");
            fragments.forEach(function (fragment) {
              var _fragment$split$map$m = fragment.split("=").map(function (s) {
                return s.replace(/\+/g, " ");
              }).map(decodeURIComponent),
                  _fragment$split$map$m2 = (0, _slicedToArray2.default)(_fragment$split$map$m, 2),
                  key = _fragment$split$map$m2[0],
                  value = _fragment$split$map$m2[1];

              params[key] = value;
            });
            return params;
          };

          var parseQueryString = function parseQueryString2(href) {
            var queryDelimiterIndex = href.indexOf("?");

            if (queryDelimiterIndex === -1) {
              return {};
            }

            var queryString = href.substring(queryDelimiterIndex + 1);
            return parseSearchParams(queryString);
          };

          exports2.parseQueryString = parseQueryString;
        },
        "./packages/@logrocket/utils/src/parseSelectorForMatch.js": function packagesLogrocketUtilsSrcParseSelectorForMatchJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = parseSelectorForMatch;

          var _toConsumableArray2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/toConsumableArray.js"));

          var _slicedToArray2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/slicedToArray.js"));

          var _startsWith = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/startsWith.js"));

          var nthChildDelim = "~";
          var nthChildPrefix = ":nth-child(";

          function parseSelectorForMatch(selectorString) {
            var parsedStr = selectorString.replace(/\s*>\s*|:nth-child\(([1-9][0-9]*|odd|even)\)|\s+/gi, function (match) {
              if (match.indexOf(">") > -1) {
                return " >";
              }

              if (match.trim().length === 0) {
                return " ";
              }

              return "".concat(nthChildDelim).concat(match.slice(nthChildPrefix.length));
            });
            return parsedStr.split(/\s+/).map(function (nodeString) {
              var nodeObject = {};
              var cleanNodeString = nodeString;

              if (cleanNodeString.charAt(0) === ">") {
                nodeObject.directDesc = true;
                cleanNodeString = cleanNodeString.slice(1);
              }

              cleanNodeString = cleanNodeString.replace(/^([a-z0-9-_]+)/ig, function (match) {
                nodeObject.nodeName = match;
                return "";
              });

              if (cleanNodeString.charAt(0) === nthChildDelim) {
                var _cleanNodeString$slic = cleanNodeString.slice(1).split(")"),
                    _cleanNodeString$slic2 = (0, _slicedToArray2.default)(_cleanNodeString$slic, 2),
                    childID = _cleanNodeString$slic2[0],
                    rest = _cleanNodeString$slic2[1];

                nodeObject.nthChild = childID;
                cleanNodeString = rest;
              }

              cleanNodeString.replace(/\.|#/gi, function (match) {
                return " ".concat(match);
              }).trim().split(" ").forEach(function (nodePart) {
                if ((0, _startsWith.default)(nodePart, ".")) {
                  var className = nodePart.slice(1);
                  nodeObject.classList = nodeObject.classList ? [].concat((0, _toConsumableArray2.default)(nodeObject.classList), [className]) : [className];
                } else if ((0, _startsWith.default)(nodePart, "#")) {
                  nodeObject.id = nodePart.slice(1);
                }
              });
              return nodeObject;
            });
          }
        },
        "./packages/@logrocket/utils/src/parseSelectorForSearch.ts": function packagesLogrocketUtilsSrcParseSelectorForSearchTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = parseSelectorForSearch;
          exports2.isInvalidSelector = void 0;

          function parseSelector(str) {
            var nodeName = str.match(/^([a-z0-9-_]+)/ig);
            var nthChildPseudoClassList = str.match(/:(nth-child[a-z0-9-_()]+)/ig);
            var id = str.match(/#(([a-z0-9-_)]|(:(?!nth-child\()))+)/ig);
            var classList = str.match(/(\.([a-z0-9-_/]|(:(?!nth-child\()))+)/ig);
            var result = {};

            if (nodeName) {
              result.nodeName = nodeName[0];
            }

            if (nthChildPseudoClassList) {
              result.pseudoClassList = nthChildPseudoClassList.map(function (i) {
                return i.substr(1);
              });
            }

            if (id) {
              result.id = id[0].substr(1);
            }

            if (classList) {
              result.classList = classList.map(function (i) {
                return i.substr(1);
              });
            }

            return result;
          }

          function parseSelectorForSearch(string) {
            return string.replace(/\s?>\s?/g, " ").split(/\s+/g).map(parseSelector).map(function (obj) {
              if (obj.classList) {
                obj.classList.sort();
              }

              return obj;
            });
          }

          var isInvalidSelector = function isInvalidSelector2(selector) {
            return !selector.id && !selector.classList && !selector.nodeName && !selector.pseudoClassList;
          };

          exports2.isInvalidSelector = isInvalidSelector;
        },
        "./packages/@logrocket/utils/src/protectFunc.js": function packagesLogrocketUtilsSrcProtectFuncJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = protectFunc;

          var _sendTelemetryData = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/sendTelemetryData.js"));

          var _logError = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/logError.js"));

          function protectFunc(f2) {
            var onFail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function () {};
            return function () {
              var result;

              try {
                result = f2.apply(void 0, arguments);
              } catch (err) {
                if (typeof window !== "undefined" && window._lrdebug) {
                  throw err;
                }

                var payload = onFail(err);
                (0, _logError.default)("LogRocket", err);
                (0, _sendTelemetryData.default)(err, payload);
              }

              return result;
            };
          }
        },
        "./packages/@logrocket/utils/src/querySelectorWithShadowDom.js": function packagesLogrocketUtilsSrcQuerySelectorWithShadowDomJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = querySelectorWithShadowDom;
          exports2.caseInsensitiveQuerySelector = void 0;

          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;

                var F = function F2() {};

                return {
                  s: F,
                  n: function n2() {
                    if (i >= o.length) return {
                      done: true
                    };
                    return {
                      done: false,
                      value: o[i++]
                    };
                  },
                  e: function e(_e) {
                    throw _e;
                  },
                  f: F
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            var normalCompletion = true,
                didErr = false,
                err;
            return {
              s: function s() {
                it = it.call(o);
              },
              n: function n2() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
              },
              e: function e(_e2) {
                didErr = true;
                err = _e2;
              },
              f: function f2() {
                try {
                  if (!normalCompletion && it.return != null) it.return();
                } finally {
                  if (didErr) throw err;
                }
              }
            };
          }

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
          }

          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          var getMatchingChildren = function getMatchingChildren2(_ref) {
            var root = _ref.root,
                selectorList = _ref.selectorList,
                directDesc = _ref.directDesc;
            var selectorParts = selectorList[0].split(/(?=\.)|(?=#)/);
            var elementSelector = selectorParts.shift();
            var id = "";
            var classes = [];
            selectorParts.forEach(function (part) {
              if (part[0] === "#") {
                id = part.toLowerCase().substring(1).trim();
              }

              if (part[0] === ".") {
                classes.push(part.toLowerCase().substring(1).trim());
              }
            });
            var matchingElements;

            if (directDesc) {
              matchingElements = [root.querySelector(":scope > ".concat(elementSelector))];
            } else {
              matchingElements = root.querySelectorAll(elementSelector);
            }

            var matches = [];

            var _iterator = _createForOfIteratorHelper(matchingElements),
                _step;

            try {
              var _loop = function _loop2() {
                var currentMatch = _step.value;

                if (!currentMatch || id !== currentMatch.id.toLowerCase()) {
                  return "continue";
                }

                var currentClasses = Array.from(currentMatch.classList.values()).map(function (c) {
                  return c.toLowerCase();
                }).filter(function (s) {
                  return s !== "" && s[0] !== ":";
                });

                if (!classes.every(function (v) {
                  return currentClasses.indexOf(v) > -1;
                })) {
                  return "continue";
                }

                matches.push(currentMatch);
              };

              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _ret = _loop();

                if (_ret === "continue") continue;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return matches;
          };

          var caseInsensitiveQuerySelector = function caseInsensitiveQuerySelector2(root, selector) {
            if (!selector.length) {
              return null;
            }

            var rootElement;

            if (root.host) {
              rootElement = root;
            } else {
              rootElement = root.querySelector("body");
            }

            if (!rootElement) {
              return null;
            }

            var queue = [{
              matches: [rootElement],
              selectorList: selector.split(" > "),
              directDesc: false
            }];

            while (queue.length) {
              var _queue$shift = queue.shift(),
                  matches = _queue$shift.matches,
                  selectorList = _queue$shift.selectorList,
                  directDesc = _queue$shift.directDesc;

              var _iterator2 = _createForOfIteratorHelper(matches),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var matchedElement = _step2.value;
                  var currentMatches = getMatchingChildren({
                    root: matchedElement,
                    selectorList,
                    directDesc
                  });

                  if (currentMatches.length && selectorList.length === 1) {
                    return currentMatches[0];
                  }

                  if (currentMatches.length) {
                    queue.push({
                      matches: currentMatches,
                      selectorList: selectorList.slice(1),
                      directDesc: true
                    });
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }

            return null;
          };

          exports2.caseInsensitiveQuerySelector = caseInsensitiveQuerySelector;

          function querySelectorWithShadowDom(element, fullSelector) {
            if (fullSelector.startsWith("$shadow-root >")) {
              throw new Error("Malformed selector '".concat(fullSelector, "': should not start with $shadow-root"));
            }

            if (fullSelector.endsWith("> $shadow-root")) {
              fullSelector = fullSelector.slice(0, fullSelector.length - "> $shadow-root".length);
            }

            var currentRoot = element;
            var currentNode;
            var selectors = fullSelector.split("> $shadow-root >");

            for (var i = 0; i < selectors.length; i++) {
              currentNode = caseInsensitiveQuerySelector(currentRoot, selectors[i]);

              if (currentNode && i < selectors.length - 1) {
                if (currentNode.shadowRoot) {
                  currentRoot = currentNode.shadowRoot;
                } else {
                  throw new Error("Missing shadowRoot for selector '".concat(fullSelector, "' at depth ").concat(i));
                }
              }
            }

            return {
              root: currentRoot,
              node: currentNode
            };
          }
        },
        "./packages/@logrocket/utils/src/randomInt.js": function packagesLogrocketUtilsSrcRandomIntJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = randomInt;

          function randomInt(min, max) {
            var minInt = Math.ceil(min);
            var maxInt = Math.floor(max);
            return Math.floor(Math.random() * (maxInt - minInt)) + minInt;
          }
        },
        "./packages/@logrocket/utils/src/removeOutdated.js": function packagesLogrocketUtilsSrcRemoveOutdatedJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = removeOutdated;

          var _sortedLastIndexBy = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/sortedLastIndexBy.js"));

          var KEEP = 5e3;

          function removeOutdated(state, action) {
            if (state.length === 0) {
              return state;
            }

            var index = (0, _sortedLastIndexBy.default)(state, {
              time: action.time - KEEP
            }, "time") - 1;
            var first = state[index];

            if (first && action.time - first.time > KEEP && index > 0) {
              return state.slice(index);
            }

            return state;
          }
        },
        "./packages/@logrocket/utils/src/requireValue.ts": function packagesLogrocketUtilsSrcRequireValueTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.requireValue = void 0;

          var requireValue = function requireValue2(value) {
            if (typeof value === "undefined") {
              throw new Error("Value must not be undefined.");
            }

            return value;
          };

          exports2.requireValue = requireValue;
        },
        "./packages/@logrocket/utils/src/sanitizeValue.js": function packagesLogrocketUtilsSrcSanitizeValueJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = sanitizeValue;

          var _replaceWithLipsum = function _replaceWithLipsum2(content) {
            var lipsum = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ";
            var repeatLength = Math.ceil(content.length / lipsum.length);
            var replacementContent = "";

            while (repeatLength > 0) {
              replacementContent += lipsum;
              repeatLength--;
            }

            return replacementContent.slice(0, content.length);
          };

          function sanitizeValue(valueToClean, taintType) {
            var value = String(valueToClean);

            if (String(taintType).toLowerCase() === "lipsum") {
              return _replaceWithLipsum(value);
            }

            return "";
          }
        },
        "./packages/@logrocket/utils/src/scrollMapHistogramToPercent.js": function packagesLogrocketUtilsSrcScrollMapHistogramToPercentJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = scrollMapHistogramToPercent;

          function scrollMapHistogramToPercent(buckets, scrollHeight) {
            var scrollMap = [];
            var currentSessionCount = buckets.reduce(function (acc, d) {
              return acc + d.count;
            }, 0);
            var cursor = 0;

            for (var p2 = 1; p2 <= 100; p2++) {
              var containerPosition = scrollHeight * (p2 * 0.01);

              if (cursor >= buckets.length) {
                scrollMap.push(0);
              } else {
                scrollMap.push(currentSessionCount);

                if (containerPosition > buckets[cursor].maxScroll) {
                  currentSessionCount -= buckets[cursor].count;
                  cursor++;
                }
              }
            }

            return scrollMap;
          }
        },
        "./packages/@logrocket/utils/src/selectorFromNodePath.js": function packagesLogrocketUtilsSrcSelectorFromNodePathJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = selectorFromNodePath;

          var _toConsumableArray2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/toConsumableArray.js"));

          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;

                var F = function F2() {};

                return {
                  s: F,
                  n: function n2() {
                    if (i >= o.length) return {
                      done: true
                    };
                    return {
                      done: false,
                      value: o[i++]
                    };
                  },
                  e: function e(_e) {
                    throw _e;
                  },
                  f: F
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            var normalCompletion = true,
                didErr = false,
                err;
            return {
              s: function s() {
                it = it.call(o);
              },
              n: function n2() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
              },
              e: function e(_e2) {
                didErr = true;
                err = _e2;
              },
              f: function f2() {
                try {
                  if (!normalCompletion && it.return != null) it.return();
                } finally {
                  if (didErr) throw err;
                }
              }
            };
          }

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
          }

          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          function selectorFromNodePath() {
            var nodePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
            var selectors = [];

            var _iterator = _createForOfIteratorHelper((0, _toConsumableArray2.default)(nodePath).reverse()),
                _step;

            try {
              var _loop = function _loop2() {
                var path = _step.value;
                var nodeName = path.nodeName,
                    id = path.id,
                    nthChild = path.nthChild;
                var classList = path.classList;
                var selectorParts = [];
                var pseudoClassList = [];
                nthChild && pseudoClassList.push("nth-child(".concat(nthChild, ")"));

                if (nodeName) {
                  selectorParts.push(nodeName);
                  pseudoClassList.sort().map(function (pseudoClass) {
                    return selectorParts.push(":".concat(pseudoClass));
                  });
                }

                if (id) {
                  selectorParts.push("#".concat(id));
                }

                if (classList && classList.length) {
                  classList = classList.map(function (value) {
                    return value.toLowerCase();
                  }).sort();
                  selectorParts = [].concat((0, _toConsumableArray2.default)(selectorParts), (0, _toConsumableArray2.default)(classList.map(function (className) {
                    return ".".concat(className);
                  })));
                }

                if (selectorParts.length) {
                  selectors.push(selectorParts.join(" "));
                }
              };

              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return selectors.join(" > ");
          }
        },
        "./packages/@logrocket/utils/src/selectorMatches.js": function packagesLogrocketUtilsSrcSelectorMatchesJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = selectorMatches;

          var _toConsumableArray2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/toConsumableArray.js"));

          var _typeof2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js"));

          var _findIndex = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/findIndex.js"));

          function _createForOfIteratorHelper(o, allowArrayLike) {
            var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

            if (!it) {
              if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                if (it) o = it;
                var i = 0;

                var F = function F2() {};

                return {
                  s: F,
                  n: function n2() {
                    if (i >= o.length) return {
                      done: true
                    };
                    return {
                      done: false,
                      value: o[i++]
                    };
                  },
                  e: function e(_e) {
                    throw _e;
                  },
                  f: F
                };
              }

              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }

            var normalCompletion = true,
                didErr = false,
                err;
            return {
              s: function s() {
                it = it.call(o);
              },
              n: function n2() {
                var step = it.next();
                normalCompletion = step.done;
                return step;
              },
              e: function e(_e2) {
                didErr = true;
                err = _e2;
              },
              f: function f2() {
                try {
                  if (!normalCompletion && it.return != null) it.return();
                } finally {
                  if (didErr) throw err;
                }
              }
            };
          }

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return _arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
          }

          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          function nodesMatch(nodeA, nodeB) {
            if (!(nodeA && nodeB)) {
              return false;
            }

            if (nodeA.id && nodeA.id !== nodeB.id) {
              return false;
            }

            if (nodeA.nodeName && nodeA.nodeName !== nodeB.nodeName) {
              return false;
            }

            if (nodeA.classList && (!nodeB.classList || nodeA.classList.map(function (classNameA) {
              return classNameA.toLowerCase();
            }).some(function (classNameA) {
              return nodeB.classList.map(function (classNameB) {
                return classNameB.toLowerCase();
              }).indexOf(classNameA) === -1;
            }))) {
              return false;
            }

            if (nodeA.nthChild) {
              var parsed = parseInt(nodeA.nthChild, 10);

              if (isNaN(parsed)) {
                return Math.abs(nodeB.nthChild % 2) === (nodeA.nthChild === "odd" ? 1 : 0);
              }

              return parsed === nodeB.nthChild;
            }

            return true;
          }

          function selectorMatches(nodePath, parsedSelector) {
            var topDownNodePath = nodePath.slice(0).reverse();
            var matchIndex;

            var _iterator = _createForOfIteratorHelper(parsedSelector),
                _step;

            try {
              var _loop = function _loop2() {
                var selectorNode = _step.value;

                if (selectorNode.directDesc) {
                  if (nodesMatch.apply(void 0, [selectorNode].concat((0, _toConsumableArray2.default)(topDownNodePath.splice(0, 1))))) {
                    return "continue";
                  } else {
                    return {
                      v: false
                    };
                  }
                }

                matchIndex = (0, _findIndex.default)(topDownNodePath, function (pathNode) {
                  return nodesMatch(selectorNode, pathNode);
                });

                if (matchIndex === -1) {
                  return {
                    v: false
                  };
                }

                topDownNodePath.splice(0, matchIndex + 1);
              };

              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _ret = _loop();

                if (_ret === "continue") continue;
                if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return true;
          }
        },
        "./packages/@logrocket/utils/src/sendTelemetryData.js": function packagesLogrocketUtilsSrcSendTelemetryDataJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.sendTelemetry = sendTelemetry;
          exports2["default"] = sendErrorTelemetry;

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _logError = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/logError.js"));

          var _TraceKit = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/utils/src/TraceKit.js"));

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              enumerableOnly && (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })), keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2.default)(target, key, source[key]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }

            return target;
          }

          var SCRIPT_VERSION = "732968640ac67eadc13d5238fac111fe51554d08";

          function _sendToSentry(data) {
            var XHR = window._lrXMLHttpRequest || XMLHttpRequest;

            try {
              var req = new XHR();
              var message = data.message;
              var url = "https://e.logrocket.com/api/3/store/?sentry_version=7&sentry_client=http%2F3.8.0&sentry_key=b64162b4187a4c5caae8a68a7e291793";
              req.open("POST", url);
              req.send(JSON.stringify(_objectSpread({
                message,
                logger: "javascript",
                platform: "javascript",
                request: {
                  headers: {
                    "User-Agent": typeof navigator !== "undefined" && navigator.userAgent
                  },
                  url: typeof location !== "undefined" && location.href
                },
                release: SCRIPT_VERSION,
                environment: "test"
              }, data)));
            } catch (err) {
              (0, _logError.default)("Failed to send", err);
            }
          }

          function sendTelemetry(message, more) {
            if (typeof window !== "undefined" && window._lrdebug) {
              return void (0, _logError.default)(message);
            }

            if (more && more.extra && more.extra.appID && typeof more.extra.appID.indexOf === "function" && more.extra.appID.indexOf("au2drp/") === 0 && Math.random() >= 0.25) {
              return;
            }

            _sendToSentry(_objectSpread({
              message
            }, more));
          }

          function sendErrorTelemetry(err, payload) {
            try {
              var message = err.message;
              var stringPayload;

              try {
                stringPayload = JSON.stringify(payload).slice(0, 1e3);
              } catch (err2) {
                try {
                  stringPayload = "Could not stringify payload: ".concat(Object.prototype.toString.call(payload));
                } catch (err3) {}
              }

              var stack;

              try {
                stack = _TraceKit.default.computeStackTrace(err).stack.map(function (frame) {
                  return {
                    filename: frame.url,
                    lineno: frame.line,
                    colno: frame.column,
                    function: frame.func || "?"
                  };
                });
              } catch (err2) {}

              _sendToSentry({
                message,
                extra: {
                  stringPayload
                },
                exception: {
                  values: [{
                    type: err.type,
                    value: message,
                    stacktrace: {
                      frames: stack
                    }
                  }]
                }
              });
            } catch (err2) {
              (0, _logError.default)("Failed to send", err2);
            }
          }
        },
        "./packages/@logrocket/utils/src/setFromArray.js": function packagesLogrocketUtilsSrcSetFromArrayJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = setFromArray;

          function setFromArray(array) {
            var set = /* @__PURE__ */new Set();
            array.forEach(function (el) {
              return set.add(el);
            });
            return set;
          }
        },
        "./packages/@logrocket/utils/src/setToArray.js": function packagesLogrocketUtilsSrcSetToArrayJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = setToArray;

          function setToArray(set) {
            var array = [];
            set.forEach(function (el) {
              return array.push(el);
            });
            return array;
          }
        },
        "./packages/@logrocket/utils/src/shallowArsonify.js": function packagesLogrocketUtilsSrcShallowArsonifyJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = shallowArsonify;

          function shallowArsonify(value) {
            var type = {}.toString.call(value);

            switch (type) {
              case "[object Undefined]":
                {
                  return {
                    undefined: {}
                  };
                }

              case "[object Null]":
                {
                  return {
                    null: {}
                  };
                }

              case "[object Boolean]":
                {
                  return {
                    boolean: {
                      bool: value
                    }
                  };
                }

              case "[object Number]":
                {
                  return {
                    number: {
                      double: value
                    }
                  };
                }

              case "[object String]":
                {
                  return {
                    string: {
                      string: value
                    }
                  };
                }

              case "[object Object]":
                {
                  return {
                    object: {
                      map: value
                    }
                  };
                }

              case "[object Array]":
                {
                  return {
                    array: {
                      map: value
                    }
                  };
                }

              case "[object Date]":
                {
                  return {
                    date: {
                      double: value.getTime()
                    }
                  };
                }

              case "[object Error]":
                {
                  return {
                    string: {
                      string: "".concat(value.name, ": ").concat(value.message)
                    }
                  };
                }

              default:
                {
                  return {
                    unsupported: {
                      type
                    }
                  };
                }
            }
          }
        },
        "./packages/@logrocket/utils/src/shallowDearsonify.js": function packagesLogrocketUtilsSrcShallowDearsonifyJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = shallowDearsonify;

          function shallowDearsonify(value) {
            var type = value.type || Object.keys(value)[0];

            switch (type) {
              case "undefined":
                {
                  return void 0;
                }

              case "null":
                {
                  return null;
                }

              case "boolean":
                {
                  return value.boolean.bool;
                }

              case "number":
                {
                  return value.number.double;
                }

              case "string":
                {
                  return value.string.string;
                }

              case "object":
                {
                  return value.object.map;
                }

              case "array":
                {
                  return Object.keys(value.array.map).reduce(function (array, key) {
                    array[key] = value.array.map[key];
                    return array;
                  }, []);
                }

              case "date":
                {
                  return new Date(value.date.double);
                }

              case "unsupported":
                {
                  return value.unsupported.type;
                }

              default:
                {
                  throw new TypeError("Unexpected value in shallowDearsonify: ".concat(value));
                }
            }
          }
        },
        "./packages/@logrocket/utils/src/startsWith.js": function packagesLogrocketUtilsSrcStartsWithJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = startsWith;

          function startsWith(value, search) {
            var pos = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            return value && search && value.substring(pos, pos + search.length) === search;
          }
        },
        "./packages/@logrocket/utils/src/types.ts": function packagesLogrocketUtilsSrcTypesTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
        },
        "./packages/@logrocket/utils/src/userTraitStrings.ts": function packagesLogrocketUtilsSrcUserTraitStringsTs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.parseUserTraitString = exports2.encodeUserTraitString = void 0;
          var USER_TRAIT_DELIMITER = ":";
          var delimiterReplace = String.fromCharCode(26);

          var encodeUserTraitString = function encodeUserTraitString2() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return args.map(function (str) {
              return str.replace(new RegExp(USER_TRAIT_DELIMITER, "g"), delimiterReplace);
            }).join(USER_TRAIT_DELIMITER);
          };

          exports2.encodeUserTraitString = encodeUserTraitString;

          var parseUserTraitString = function parseUserTraitString2(string) {
            var nonEmptyStr = string || USER_TRAIT_DELIMITER;
            return nonEmptyStr.split(USER_TRAIT_DELIMITER).map(function (str) {
              return str.replace(new RegExp(delimiterReplace, "g"), USER_TRAIT_DELIMITER);
            });
          };

          exports2.parseUserTraitString = parseUserTraitString;
        },
        "./packages/@logrocket/utils/src/uuid.js": function packagesLogrocketUtilsSrcUuidJs(__unused_webpack_module, exports2) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = uuid;

          function uuid(a) {
            return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
          }
        },
        "./packages/logrocket/src/LogRocket.js": function packagesLogrocketSrcLogRocketJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = exports2.MAX_QUEUE_SIZE = void 0;

          var _classCallCheck2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/classCallCheck.js"));

          var _createClass2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/createClass.js"));

          var _defineProperty2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/defineProperty.js"));

          var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));

          var _network = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/network/src/index.js"));

          var _exceptions = __webpack_require__2("./packages/@logrocket/exceptions/src/index.js");

          var _console = _interopRequireDefault(__webpack_require__2("./packages/@logrocket/console/src/index.js"));

          var _redux = __webpack_require__2("./packages/@logrocket/redux/src/index.js");

          function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(object);
              enumerableOnly && (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })), keys.push.apply(keys, symbols);
            }

            return keys;
          }

          function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i] != null ? arguments[i] : {};
              i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
                (0, _defineProperty2.default)(target, key, source[key]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }

            return target;
          }

          var MAX_QUEUE_SIZE = 1e3;
          exports2.MAX_QUEUE_SIZE = MAX_QUEUE_SIZE;

          var considerIngestServerOption = function considerIngestServerOption2() {
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                ingestServer = _ref.ingestServer,
                options = (0, _objectWithoutProperties2.default)(_ref, ["ingestServer"]);

            if (ingestServer) {
              return _objectSpread({
                serverURL: "".concat(ingestServer, "/i"),
                statsURL: "".concat(ingestServer, "/s")
              }, options);
            }

            return options;
          };

          var LogRocket2 = /* @__PURE__ */function () {
            function LogRocket3() {
              var _this = this;

              (0, _classCallCheck2.default)(this, LogRocket3);
              this._buffer = [];
              ["log", "info", "warn", "error", "debug"].forEach(function (method) {
                _this[method] = function () {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  _this.addEvent("lr.core.LogEvent", function () {
                    var consoleOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};

                    if (method === "error" && consoleOptions.shouldAggregateConsoleErrors) {
                      _exceptions.Capture.captureMessage(_this, args[0], args, {}, true);
                    }

                    return {
                      logLevel: method.toUpperCase(),
                      args
                    };
                  }, {
                    shouldCaptureStackTrace: true
                  });
                };
              });
              this._isInitialized = false;
              this._installed = [];
              window._lr_surl_cb = this.getSessionURL.bind(this);
            }

            (0, _createClass2.default)(LogRocket3, [{
              key: "addEvent",
              value: function addEvent(type, getMessage) {
                var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var time = Date.now();

                this._run(function (logger) {
                  logger.addEvent(type, getMessage, _objectSpread(_objectSpread({}, opts), {}, {
                    timeOverride: time
                  }));
                });
              }
            }, {
              key: "onLogger",
              value: function onLogger(logger) {
                this._logger = logger;

                while (this._buffer.length > 0) {
                  var f2 = this._buffer.shift();

                  f2(this._logger);
                }
              }
            }, {
              key: "_run",
              value: function _run(f2) {
                if (this._isDisabled) {
                  return;
                }

                if (this._logger) {
                  f2(this._logger);
                } else {
                  if (this._buffer.length >= MAX_QUEUE_SIZE) {
                    this._isDisabled = true;
                    console.warn("LogRocket: script did not load. Check that you have a valid network connection.");
                    this.uninstall();
                    return;
                  }

                  this._buffer.push(f2.bind(this));
                }
              }
            }, {
              key: "init",
              value: function init(appID) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};

                if (!this._isInitialized) {
                  var _opts$shouldAugmentNP = opts.shouldAugmentNPS,
                      shouldAugmentNPS = _opts$shouldAugmentNP === void 0 ? true : _opts$shouldAugmentNP,
                      _opts$shouldParseXHRB = opts.shouldParseXHRBlob,
                      shouldParseXHRBlob = _opts$shouldParseXHRB === void 0 ? false : _opts$shouldParseXHRB,
                      _opts$shouldDetectExc = opts.shouldDetectExceptions,
                      shouldDetectExceptions = _opts$shouldDetectExc === void 0 ? true : _opts$shouldDetectExc;

                  if (shouldDetectExceptions) {
                    this._installed.push((0, _exceptions.registerExceptions)(this));
                  }

                  this._installed.push((0, _network.default)(this, {
                    shouldAugmentNPS: !!shouldAugmentNPS,
                    shouldParseXHRBlob: !!shouldParseXHRBlob
                  }));

                  this._installed.push((0, _console.default)(this));

                  this._isInitialized = true;

                  this._run(function (logger) {
                    logger.init(appID, considerIngestServerOption(opts));
                  });
                }
              }
            }, {
              key: "start",
              value: function start() {
                this._run(function (logger) {
                  logger.start();
                });
              }
            }, {
              key: "uninstall",
              value: function uninstall() {
                this._installed.forEach(function (f2) {
                  return f2();
                });

                this._buffer = [];

                this._run(function (logger) {
                  logger.uninstall();
                });
              }
            }, {
              key: "identify",
              value: function identify(id, opts) {
                this._run(function (logger) {
                  logger.identify(id, opts);
                });
              }
            }, {
              key: "startNewSession",
              value: function startNewSession() {
                this._run(function (logger) {
                  logger.startNewSession();
                });
              }
            }, {
              key: "track",
              value: function track(customEventName, eventProperties) {
                this._run(function (logger) {
                  logger.track(customEventName, eventProperties);
                });
              }
            }, {
              key: "getSessionURL",
              value: function getSessionURL(cb) {
                if (typeof cb !== "function") {
                  throw new Error("LogRocket: must pass callback to getSessionURL()");
                }

                this._run(function (logger) {
                  if (logger.getSessionURL) {
                    logger.getSessionURL(cb);
                  } else {
                    cb(logger.recordingURL);
                  }
                });
              }
            }, {
              key: "getVersion",
              value: function getVersion(cb) {
                this._run(function (logger) {
                  cb(logger.version);
                });
              }
            }, {
              key: "captureMessage",
              value: function captureMessage(message) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};

                _exceptions.Capture.captureMessage(this, message, [message], options);
              }
            }, {
              key: "captureException",
              value: function captureException(exception) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};

                _exceptions.Capture.captureException(this, exception, options);
              }
            }, {
              key: "version",
              get: function get() {
                return this._logger && this._logger.version;
              }
            }, {
              key: "sessionURL",
              get: function get() {
                return this._logger && this._logger.recordingURL;
              }
            }, {
              key: "recordingURL",
              get: function get() {
                return this._logger && this._logger.recordingURL;
              }
            }, {
              key: "recordingID",
              get: function get() {
                return this._logger && this._logger.recordingID;
              }
            }, {
              key: "threadID",
              get: function get() {
                return this._logger && this._logger.threadID;
              }
            }, {
              key: "tabID",
              get: function get() {
                return this._logger && this._logger.tabID;
              }
            }, {
              key: "reduxEnhancer",
              value: function reduxEnhancer() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return (0, _redux.createEnhancer)(this, options);
              }
            }, {
              key: "reduxMiddleware",
              value: function reduxMiddleware() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return (0, _redux.createMiddleware)(this, options);
              }
            }, {
              key: "isDisabled",
              get: function get() {
                return !!(this._isDisabled || this._logger && this._logger._isDisabled);
              }
            }]);
            return LogRocket3;
          }();

          exports2["default"] = LogRocket2;
        },
        "./packages/logrocket/src/makeLogRocket.js": function packagesLogrocketSrcMakeLogRocketJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = makeLogRocket;

          var _LogRocket = _interopRequireDefault(__webpack_require__2("./packages/logrocket/src/LogRocket.js"));

          var REACT_NATIVE_NOTICE = "LogRocket does not yet support React Native.";

          var makeNoopPolyfill = function makeNoopPolyfill2() {
            return {
              init: function init() {},
              uninstall: function uninstall() {},
              log: function log() {},
              info: function info() {},
              warn: function warn() {},
              error: function error() {},
              debug: function debug() {},
              addEvent: function addEvent() {},
              identify: function identify() {},
              start: function start() {},

              get threadID() {
                return null;
              },

              get recordingID() {
                return null;
              },

              get recordingURL() {
                return null;
              },

              reduxEnhancer: function reduxEnhancer() {
                return function (store) {
                  return function () {
                    return store.apply(void 0, arguments);
                  };
                };
              },
              reduxMiddleware: function reduxMiddleware() {
                return function () {
                  return function (next) {
                    return function (action) {
                      return next(action);
                    };
                  };
                };
              },
              track: function track() {},
              getSessionURL: function getSessionURL() {},
              getVersion: function getVersion() {},
              startNewSession: function startNewSession() {},
              onLogger: function onLogger() {},
              setClock: function setClock() {},
              captureMessage: function captureMessage() {},
              captureException: function captureException() {}
            };
          };

          function makeLogRocket() {
            var getLogger = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function () {};

            if (typeof navigator !== "undefined" && navigator.product === "ReactNative") {
              throw new Error(REACT_NATIVE_NOTICE);
            }

            if (typeof window !== "undefined") {
              if (window._disableLogRocket) {
                return makeNoopPolyfill();
              }

              if (window.MutationObserver && window.WeakMap) {
                window._lrMutationObserver = window.MutationObserver;
                var instance = new _LogRocket.default();
                getLogger(instance);
                return instance;
              }
            }

            return makeNoopPolyfill();
          }
        },
        "./packages/logrocket/src/setup.js": function packagesLogrocketSrcSetupJs(__unused_webpack_module, exports2, __webpack_require__2) {
          var _interopRequireDefault = __webpack_require__2("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2["default"] = setup;

          var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__2("./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));

          var _makeLogRocket = _interopRequireDefault(__webpack_require__2("./packages/logrocket/src/makeLogRocket.js"));

          var CDN_SERVER_MAP = {
            "cdn.logrocket.io": "https://r.logrocket.io",
            "cdn.lr-ingest.io": "https://r.lr-ingest.io",
            "cdn.lr-in.com": "https://r.lr-in.com",
            "cdn.lr-in-prod.com": "https://r.lr-in-prod.com",
            "cdn.lr-ingest.com": "https://r.lr-ingest.com",
            "cdn-staging.logrocket.io": "https://staging-i.logrocket.io",
            "cdn-staging.lr-ingest.io": "https://staging-i.lr-ingest.io",
            "cdn-staging.lr-in.com": "https://staging-i.lr-in.com",
            "cdn-staging.lr-in-prod.com": "https://staging-i.lr-in-prod.com",
            "cdn-staging.lr-ingest.com": "https://staging-i.lr-ingest.com"
          };

          function setup() {
            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                enterpriseServer = _ref.enterpriseServer,
                _ref$sdkVersion = _ref.sdkVersion,
                sdkVersion = _ref$sdkVersion === void 0 ? "4.0.2" : _ref$sdkVersion,
                opts = (0, _objectWithoutProperties2.default)(_ref, ["enterpriseServer", "sdkVersion"]);

            var scriptOrigin = "https://cdn.logrocket.io";
            var scriptIngest;

            if (sdkVersion === "script") {
              try {
                var scriptTag = document.currentScript;
                var matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
                var scriptHostname = matches && matches[2];

                if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) {
                  scriptOrigin = matches && matches[1];
                  scriptIngest = CDN_SERVER_MAP[scriptHostname];
                }
              } catch (_) {}
            } else {
              scriptOrigin = "https://cdn.lr-ingest.com";
              scriptIngest = "https://r.lr-ingest.com";
            }

            var sdkServer = opts.sdkServer || enterpriseServer;
            var ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
            var instance = (0, _makeLogRocket.default)(function () {
              var script = document.createElement("script");

              if (ingestServer) {
                if (typeof window.__SDKCONFIG__ === "undefined") {
                  window.__SDKCONFIG__ = {};
                }

                window.__SDKCONFIG__.serverURL = "".concat(ingestServer, "/i");
                window.__SDKCONFIG__.statsURL = "".concat(ingestServer, "/s");
              }

              if (sdkServer) {
                script.src = "".concat(sdkServer, "/logger.min.js");
              } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
                script.src = window.__SDKCONFIG__.loggerURL;
              } else if (window._lrAsyncScript) {
                script.src = window._lrAsyncScript;
              } else {
                script.src = "".concat(scriptOrigin, "/logger-1.min.js");
              }

              script.async = true;
              document.head.appendChild(script);

              script.onload = function () {
                if (typeof window._LRLogger === "function") {
                  instance.onLogger(new window._LRLogger({
                    sdkVersion
                  }));
                } else {
                  console.warn("LogRocket: script execution has been blocked by a product or service.");
                  instance.uninstall();
                }
              };

              script.onerror = function () {
                console.warn("LogRocket: script could not load. Check that you have a valid network connection.");
                instance.uninstall();
              };
            });
            return instance;
          }
        },
        "./packages/@logrocket/utils/node_modules/lodash/_DataView.js": function packagesLogrocketUtilsNode_modulesLodash_DataViewJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getNative = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getNative.js"),
              root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var DataView = getNative(root, "DataView");
          module2.exports = DataView;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_Hash.js": function packagesLogrocketUtilsNode_modulesLodash_HashJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var hashClear = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_hashClear.js"),
              hashDelete = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_hashDelete.js"),
              hashGet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_hashGet.js"),
              hashHas = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_hashHas.js"),
              hashSet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_hashSet.js");

          function Hash(entries) {
            var index = -1,
                length = entries == null ? 0 : entries.length;
            this.clear();

            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }

          Hash.prototype.clear = hashClear;
          Hash.prototype["delete"] = hashDelete;
          Hash.prototype.get = hashGet;
          Hash.prototype.has = hashHas;
          Hash.prototype.set = hashSet;
          module2.exports = Hash;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_ListCache.js": function packagesLogrocketUtilsNode_modulesLodash_ListCacheJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var listCacheClear = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_listCacheClear.js"),
              listCacheDelete = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_listCacheDelete.js"),
              listCacheGet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_listCacheGet.js"),
              listCacheHas = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_listCacheHas.js"),
              listCacheSet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_listCacheSet.js");

          function ListCache(entries) {
            var index = -1,
                length = entries == null ? 0 : entries.length;
            this.clear();

            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }

          ListCache.prototype.clear = listCacheClear;
          ListCache.prototype["delete"] = listCacheDelete;
          ListCache.prototype.get = listCacheGet;
          ListCache.prototype.has = listCacheHas;
          ListCache.prototype.set = listCacheSet;
          module2.exports = ListCache;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_Map.js": function packagesLogrocketUtilsNode_modulesLodash_MapJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getNative = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getNative.js"),
              root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var Map2 = getNative(root, "Map");
          module2.exports = Map2;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_MapCache.js": function packagesLogrocketUtilsNode_modulesLodash_MapCacheJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var mapCacheClear = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_mapCacheClear.js"),
              mapCacheDelete = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_mapCacheDelete.js"),
              mapCacheGet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_mapCacheGet.js"),
              mapCacheHas = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_mapCacheHas.js"),
              mapCacheSet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_mapCacheSet.js");

          function MapCache(entries) {
            var index = -1,
                length = entries == null ? 0 : entries.length;
            this.clear();

            while (++index < length) {
              var entry = entries[index];
              this.set(entry[0], entry[1]);
            }
          }

          MapCache.prototype.clear = mapCacheClear;
          MapCache.prototype["delete"] = mapCacheDelete;
          MapCache.prototype.get = mapCacheGet;
          MapCache.prototype.has = mapCacheHas;
          MapCache.prototype.set = mapCacheSet;
          module2.exports = MapCache;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_Promise.js": function packagesLogrocketUtilsNode_modulesLodash_PromiseJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getNative = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getNative.js"),
              root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var Promise2 = getNative(root, "Promise");
          module2.exports = Promise2;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_Set.js": function packagesLogrocketUtilsNode_modulesLodash_SetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getNative = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getNative.js"),
              root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var Set2 = getNative(root, "Set");
          module2.exports = Set2;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_SetCache.js": function packagesLogrocketUtilsNode_modulesLodash_SetCacheJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var MapCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_MapCache.js"),
              setCacheAdd = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_setCacheAdd.js"),
              setCacheHas = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_setCacheHas.js");

          function SetCache(values) {
            var index = -1,
                length = values == null ? 0 : values.length;
            this.__data__ = new MapCache();

            while (++index < length) {
              this.add(values[index]);
            }
          }

          SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
          SetCache.prototype.has = setCacheHas;
          module2.exports = SetCache;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_Stack.js": function packagesLogrocketUtilsNode_modulesLodash_StackJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var ListCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_ListCache.js"),
              stackClear = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_stackClear.js"),
              stackDelete = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_stackDelete.js"),
              stackGet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_stackGet.js"),
              stackHas = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_stackHas.js"),
              stackSet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_stackSet.js");

          function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
          }

          Stack.prototype.clear = stackClear;
          Stack.prototype["delete"] = stackDelete;
          Stack.prototype.get = stackGet;
          Stack.prototype.has = stackHas;
          Stack.prototype.set = stackSet;
          module2.exports = Stack;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_Symbol.js": function packagesLogrocketUtilsNode_modulesLodash_SymbolJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var Symbol2 = root.Symbol;
          module2.exports = Symbol2;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_Uint8Array.js": function packagesLogrocketUtilsNode_modulesLodash_Uint8ArrayJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var Uint8Array = root.Uint8Array;
          module2.exports = Uint8Array;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_WeakMap.js": function packagesLogrocketUtilsNode_modulesLodash_WeakMapJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getNative = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getNative.js"),
              root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var WeakMap2 = getNative(root, "WeakMap");
          module2.exports = WeakMap2;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_arrayFilter.js": function packagesLogrocketUtilsNode_modulesLodash_arrayFilterJs(module2) {
          function arrayFilter(array, predicate) {
            var index = -1,
                length = array == null ? 0 : array.length,
                resIndex = 0,
                result = [];

            while (++index < length) {
              var value = array[index];

              if (predicate(value, index, array)) {
                result[resIndex++] = value;
              }
            }

            return result;
          }

          module2.exports = arrayFilter;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_arrayLikeKeys.js": function packagesLogrocketUtilsNode_modulesLodash_arrayLikeKeysJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseTimes = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseTimes.js"),
              isArguments = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArguments.js"),
              isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js"),
              isBuffer = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isBuffer.js"),
              isIndex = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isIndex.js"),
              isTypedArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isTypedArray.js");

          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;

          function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value),
                isArg = !isArr && isArguments(value),
                isBuff = !isArr && !isArg && isBuffer(value),
                isType = !isArr && !isArg && !isBuff && isTypedArray(value),
                skipIndexes = isArr || isArg || isBuff || isType,
                result = skipIndexes ? baseTimes(value.length, String) : [],
                length = result.length;

            for (var key in value) {
              if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
                result.push(key);
              }
            }

            return result;
          }

          module2.exports = arrayLikeKeys;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_arrayMap.js": function packagesLogrocketUtilsNode_modulesLodash_arrayMapJs(module2) {
          function arrayMap(array, iteratee) {
            var index = -1,
                length = array == null ? 0 : array.length,
                result = Array(length);

            while (++index < length) {
              result[index] = iteratee(array[index], index, array);
            }

            return result;
          }

          module2.exports = arrayMap;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_arrayPush.js": function packagesLogrocketUtilsNode_modulesLodash_arrayPushJs(module2) {
          function arrayPush(array, values) {
            var index = -1,
                length = values.length,
                offset = array.length;

            while (++index < length) {
              array[offset + index] = values[index];
            }

            return array;
          }

          module2.exports = arrayPush;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_arraySome.js": function packagesLogrocketUtilsNode_modulesLodash_arraySomeJs(module2) {
          function arraySome(array, predicate) {
            var index = -1,
                length = array == null ? 0 : array.length;

            while (++index < length) {
              if (predicate(array[index], index, array)) {
                return true;
              }
            }

            return false;
          }

          module2.exports = arraySome;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_assocIndexOf.js": function packagesLogrocketUtilsNode_modulesLodash_assocIndexOfJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var eq = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/eq.js");

          function assocIndexOf(array, key) {
            var length = array.length;

            while (length--) {
              if (eq(array[length][0], key)) {
                return length;
              }
            }

            return -1;
          }

          module2.exports = assocIndexOf;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseGet.js": function packagesLogrocketUtilsNode_modulesLodash_baseGetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var castPath = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_castPath.js"),
              toKey = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_toKey.js");

          function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0,
                length = path.length;

            while (object != null && index < length) {
              object = object[toKey(path[index++])];
            }

            return index && index == length ? object : void 0;
          }

          module2.exports = baseGet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseGetAllKeys.js": function packagesLogrocketUtilsNode_modulesLodash_baseGetAllKeysJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var arrayPush = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_arrayPush.js"),
              isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js");

          function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
          }

          module2.exports = baseGetAllKeys;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseGetTag.js": function packagesLogrocketUtilsNode_modulesLodash_baseGetTagJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var Symbol2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Symbol.js"),
              getRawTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getRawTag.js"),
              objectToString = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_objectToString.js");

          var nullTag = "[object Null]",
              undefinedTag = "[object Undefined]";
          var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;

          function baseGetTag(value) {
            if (value == null) {
              return value === void 0 ? undefinedTag : nullTag;
            }

            return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
          }

          module2.exports = baseGetTag;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseHasIn.js": function packagesLogrocketUtilsNode_modulesLodash_baseHasInJs(module2) {
          function baseHasIn(object, key) {
            return object != null && key in Object(object);
          }

          module2.exports = baseHasIn;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseIsArguments.js": function packagesLogrocketUtilsNode_modulesLodash_baseIsArgumentsJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseGetTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGetTag.js"),
              isObjectLike = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObjectLike.js");

          var argsTag = "[object Arguments]";

          function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
          }

          module2.exports = baseIsArguments;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseIsEqual.js": function packagesLogrocketUtilsNode_modulesLodash_baseIsEqualJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseIsEqualDeep = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIsEqualDeep.js"),
              isObjectLike = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObjectLike.js");

          function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) {
              return true;
            }

            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
              return value !== value && other !== other;
            }

            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
          }

          module2.exports = baseIsEqual;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseIsEqualDeep.js": function packagesLogrocketUtilsNode_modulesLodash_baseIsEqualDeepJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var Stack = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Stack.js"),
              equalArrays = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_equalArrays.js"),
              equalByTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_equalByTag.js"),
              equalObjects = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_equalObjects.js"),
              getTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getTag.js"),
              isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js"),
              isBuffer = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isBuffer.js"),
              isTypedArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isTypedArray.js");

          var COMPARE_PARTIAL_FLAG = 1;
          var argsTag = "[object Arguments]",
              arrayTag = "[object Array]",
              objectTag = "[object Object]";
          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;

          function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object),
                othIsArr = isArray(other),
                objTag = objIsArr ? arrayTag : getTag(object),
                othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag,
                othIsObj = othTag == objectTag,
                isSameTag = objTag == othTag;

            if (isSameTag && isBuffer(object)) {
              if (!isBuffer(other)) {
                return false;
              }

              objIsArr = true;
              objIsObj = false;
            }

            if (isSameTag && !objIsObj) {
              stack || (stack = new Stack());
              return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }

            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
              var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"),
                  othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");

              if (objIsWrapped || othIsWrapped) {
                var objUnwrapped = objIsWrapped ? object.value() : object,
                    othUnwrapped = othIsWrapped ? other.value() : other;
                stack || (stack = new Stack());
                return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
              }
            }

            if (!isSameTag) {
              return false;
            }

            stack || (stack = new Stack());
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
          }

          module2.exports = baseIsEqualDeep;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseIsMatch.js": function packagesLogrocketUtilsNode_modulesLodash_baseIsMatchJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var Stack = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Stack.js"),
              baseIsEqual = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIsEqual.js");

          var COMPARE_PARTIAL_FLAG = 1,
              COMPARE_UNORDERED_FLAG = 2;

          function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length,
                length = index,
                noCustomizer = !customizer;

            if (object == null) {
              return !length;
            }

            object = Object(object);

            while (index--) {
              var data = matchData[index];

              if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                return false;
              }
            }

            while (++index < length) {
              data = matchData[index];
              var key = data[0],
                  objValue = object[key],
                  srcValue = data[1];

              if (noCustomizer && data[2]) {
                if (objValue === void 0 && !(key in object)) {
                  return false;
                }
              } else {
                var stack = new Stack();

                if (customizer) {
                  var result = customizer(objValue, srcValue, key, object, source, stack);
                }

                if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
                  return false;
                }
              }
            }

            return true;
          }

          module2.exports = baseIsMatch;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseIsNative.js": function packagesLogrocketUtilsNode_modulesLodash_baseIsNativeJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isFunction = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isFunction.js"),
              isMasked = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isMasked.js"),
              isObject = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObject.js"),
              toSource = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_toSource.js");

          var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
          var reIsHostCtor = /^\[object .+?Constructor\]$/;
          var funcProto = Function.prototype,
              objectProto = Object.prototype;
          var funcToString = funcProto.toString;
          var hasOwnProperty2 = objectProto.hasOwnProperty;
          var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

          function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) {
              return false;
            }

            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
          }

          module2.exports = baseIsNative;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseIsTypedArray.js": function packagesLogrocketUtilsNode_modulesLodash_baseIsTypedArrayJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseGetTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGetTag.js"),
              isLength = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isLength.js"),
              isObjectLike = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObjectLike.js");

          var argsTag = "[object Arguments]",
              arrayTag = "[object Array]",
              boolTag = "[object Boolean]",
              dateTag = "[object Date]",
              errorTag = "[object Error]",
              funcTag = "[object Function]",
              mapTag = "[object Map]",
              numberTag = "[object Number]",
              objectTag = "[object Object]",
              regexpTag = "[object RegExp]",
              setTag = "[object Set]",
              stringTag = "[object String]",
              weakMapTag = "[object WeakMap]";
          var arrayBufferTag = "[object ArrayBuffer]",
              dataViewTag = "[object DataView]",
              float32Tag = "[object Float32Array]",
              float64Tag = "[object Float64Array]",
              int8Tag = "[object Int8Array]",
              int16Tag = "[object Int16Array]",
              int32Tag = "[object Int32Array]",
              uint8Tag = "[object Uint8Array]",
              uint8ClampedTag = "[object Uint8ClampedArray]",
              uint16Tag = "[object Uint16Array]",
              uint32Tag = "[object Uint32Array]";
          var typedArrayTags = {};
          typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
          typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

          function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
          }

          module2.exports = baseIsTypedArray;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseIteratee.js": function packagesLogrocketUtilsNode_modulesLodash_baseIterateeJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseMatches = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseMatches.js"),
              baseMatchesProperty = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseMatchesProperty.js"),
              identity = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/identity.js"),
              isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js"),
              property = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/property.js");

          function baseIteratee(value) {
            if (typeof value == "function") {
              return value;
            }

            if (value == null) {
              return identity;
            }

            if (typeof value == "object") {
              return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            }

            return property(value);
          }

          module2.exports = baseIteratee;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseKeys.js": function packagesLogrocketUtilsNode_modulesLodash_baseKeysJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isPrototype = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isPrototype.js"),
              nativeKeys = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_nativeKeys.js");

          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;

          function baseKeys(object) {
            if (!isPrototype(object)) {
              return nativeKeys(object);
            }

            var result = [];

            for (var key in Object(object)) {
              if (hasOwnProperty2.call(object, key) && key != "constructor") {
                result.push(key);
              }
            }

            return result;
          }

          module2.exports = baseKeys;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseMatches.js": function packagesLogrocketUtilsNode_modulesLodash_baseMatchesJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseIsMatch = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIsMatch.js"),
              getMatchData = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getMatchData.js"),
              matchesStrictComparable = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_matchesStrictComparable.js");

          function baseMatches(source) {
            var matchData = getMatchData(source);

            if (matchData.length == 1 && matchData[0][2]) {
              return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            }

            return function (object) {
              return object === source || baseIsMatch(object, source, matchData);
            };
          }

          module2.exports = baseMatches;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseMatchesProperty.js": function packagesLogrocketUtilsNode_modulesLodash_baseMatchesPropertyJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseIsEqual = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIsEqual.js"),
              get = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/get.js"),
              hasIn = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/hasIn.js"),
              isKey = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isKey.js"),
              isStrictComparable = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isStrictComparable.js"),
              matchesStrictComparable = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_matchesStrictComparable.js"),
              toKey = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_toKey.js");

          var COMPARE_PARTIAL_FLAG = 1,
              COMPARE_UNORDERED_FLAG = 2;

          function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) {
              return matchesStrictComparable(toKey(path), srcValue);
            }

            return function (object) {
              var objValue = get(object, path);
              return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
          }

          module2.exports = baseMatchesProperty;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseProperty.js": function packagesLogrocketUtilsNode_modulesLodash_basePropertyJs(module2) {
          function baseProperty(key) {
            return function (object) {
              return object == null ? void 0 : object[key];
            };
          }

          module2.exports = baseProperty;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_basePropertyDeep.js": function packagesLogrocketUtilsNode_modulesLodash_basePropertyDeepJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseGet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGet.js");

          function basePropertyDeep(path) {
            return function (object) {
              return baseGet(object, path);
            };
          }

          module2.exports = basePropertyDeep;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseSortedIndexBy.js": function packagesLogrocketUtilsNode_modulesLodash_baseSortedIndexByJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isSymbol = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isSymbol.js");

          var MAX_ARRAY_LENGTH = 4294967295,
              MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;
          var nativeFloor = Math.floor,
              nativeMin = Math.min;

          function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0,
                high = array == null ? 0 : array.length;

            if (high === 0) {
              return 0;
            }

            value = iteratee(value);
            var valIsNaN = value !== value,
                valIsNull = value === null,
                valIsSymbol = isSymbol(value),
                valIsUndefined = value === void 0;

            while (low < high) {
              var mid = nativeFloor((low + high) / 2),
                  computed = iteratee(array[mid]),
                  othIsDefined = computed !== void 0,
                  othIsNull = computed === null,
                  othIsReflexive = computed === computed,
                  othIsSymbol = isSymbol(computed);

              if (valIsNaN) {
                var setLow = retHighest || othIsReflexive;
              } else if (valIsUndefined) {
                setLow = othIsReflexive && (retHighest || othIsDefined);
              } else if (valIsNull) {
                setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
              } else if (valIsSymbol) {
                setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
              } else if (othIsNull || othIsSymbol) {
                setLow = false;
              } else {
                setLow = retHighest ? computed <= value : computed < value;
              }

              if (setLow) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }

            return nativeMin(high, MAX_ARRAY_INDEX);
          }

          module2.exports = baseSortedIndexBy;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseTimes.js": function packagesLogrocketUtilsNode_modulesLodash_baseTimesJs(module2) {
          function baseTimes(n2, iteratee) {
            var index = -1,
                result = Array(n2);

            while (++index < n2) {
              result[index] = iteratee(index);
            }

            return result;
          }

          module2.exports = baseTimes;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseToString.js": function packagesLogrocketUtilsNode_modulesLodash_baseToStringJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var Symbol2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Symbol.js"),
              arrayMap = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_arrayMap.js"),
              isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js"),
              isSymbol = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isSymbol.js");

          var INFINITY = 1 / 0;
          var symbolProto = Symbol2 ? Symbol2.prototype : void 0,
              symbolToString = symbolProto ? symbolProto.toString : void 0;

          function baseToString(value) {
            if (typeof value == "string") {
              return value;
            }

            if (isArray(value)) {
              return arrayMap(value, baseToString) + "";
            }

            if (isSymbol(value)) {
              return symbolToString ? symbolToString.call(value) : "";
            }

            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
          }

          module2.exports = baseToString;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_baseUnary.js": function packagesLogrocketUtilsNode_modulesLodash_baseUnaryJs(module2) {
          function baseUnary(func) {
            return function (value) {
              return func(value);
            };
          }

          module2.exports = baseUnary;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_cacheHas.js": function packagesLogrocketUtilsNode_modulesLodash_cacheHasJs(module2) {
          function cacheHas(cache, key) {
            return cache.has(key);
          }

          module2.exports = cacheHas;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_castPath.js": function packagesLogrocketUtilsNode_modulesLodash_castPathJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js"),
              isKey = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isKey.js"),
              stringToPath = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_stringToPath.js"),
              toString = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/toString.js");

          function castPath(value, object) {
            if (isArray(value)) {
              return value;
            }

            return isKey(value, object) ? [value] : stringToPath(toString(value));
          }

          module2.exports = castPath;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_coreJsData.js": function packagesLogrocketUtilsNode_modulesLodash_coreJsDataJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js");

          var coreJsData = root["__core-js_shared__"];
          module2.exports = coreJsData;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_equalArrays.js": function packagesLogrocketUtilsNode_modulesLodash_equalArraysJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var SetCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_SetCache.js"),
              arraySome = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_arraySome.js"),
              cacheHas = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_cacheHas.js");

          var COMPARE_PARTIAL_FLAG = 1,
              COMPARE_UNORDERED_FLAG = 2;

          function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                arrLength = array.length,
                othLength = other.length;

            if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
              return false;
            }

            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);

            if (arrStacked && othStacked) {
              return arrStacked == other && othStacked == array;
            }

            var index = -1,
                result = true,
                seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
            stack.set(array, other);
            stack.set(other, array);

            while (++index < arrLength) {
              var arrValue = array[index],
                  othValue = other[index];

              if (customizer) {
                var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
              }

              if (compared !== void 0) {
                if (compared) {
                  continue;
                }

                result = false;
                break;
              }

              if (seen) {
                if (!arraySome(other, function (othValue2, othIndex) {
                  if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                    return seen.push(othIndex);
                  }
                })) {
                  result = false;
                  break;
                }
              } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                result = false;
                break;
              }
            }

            stack["delete"](array);
            stack["delete"](other);
            return result;
          }

          module2.exports = equalArrays;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_equalByTag.js": function packagesLogrocketUtilsNode_modulesLodash_equalByTagJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var Symbol2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Symbol.js"),
              Uint8Array = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Uint8Array.js"),
              eq = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/eq.js"),
              equalArrays = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_equalArrays.js"),
              mapToArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_mapToArray.js"),
              setToArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_setToArray.js");

          var COMPARE_PARTIAL_FLAG = 1,
              COMPARE_UNORDERED_FLAG = 2;
          var boolTag = "[object Boolean]",
              dateTag = "[object Date]",
              errorTag = "[object Error]",
              mapTag = "[object Map]",
              numberTag = "[object Number]",
              regexpTag = "[object RegExp]",
              setTag = "[object Set]",
              stringTag = "[object String]",
              symbolTag = "[object Symbol]";
          var arrayBufferTag = "[object ArrayBuffer]",
              dataViewTag = "[object DataView]";
          var symbolProto = Symbol2 ? Symbol2.prototype : void 0,
              symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;

          function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch (tag) {
              case dataViewTag:
                if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                  return false;
                }

                object = object.buffer;
                other = other.buffer;

              case arrayBufferTag:
                if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                  return false;
                }

                return true;

              case boolTag:
              case dateTag:
              case numberTag:
                return eq(+object, +other);

              case errorTag:
                return object.name == other.name && object.message == other.message;

              case regexpTag:
              case stringTag:
                return object == other + "";

              case mapTag:
                var convert = mapToArray;

              case setTag:
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                convert || (convert = setToArray);

                if (object.size != other.size && !isPartial) {
                  return false;
                }

                var stacked = stack.get(object);

                if (stacked) {
                  return stacked == other;
                }

                bitmask |= COMPARE_UNORDERED_FLAG;
                stack.set(object, other);
                var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                stack["delete"](object);
                return result;

              case symbolTag:
                if (symbolValueOf) {
                  return symbolValueOf.call(object) == symbolValueOf.call(other);
                }

            }

            return false;
          }

          module2.exports = equalByTag;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_equalObjects.js": function packagesLogrocketUtilsNode_modulesLodash_equalObjectsJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getAllKeys = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getAllKeys.js");

          var COMPARE_PARTIAL_FLAG = 1;
          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;

          function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
                objProps = getAllKeys(object),
                objLength = objProps.length,
                othProps = getAllKeys(other),
                othLength = othProps.length;

            if (objLength != othLength && !isPartial) {
              return false;
            }

            var index = objLength;

            while (index--) {
              var key = objProps[index];

              if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
                return false;
              }
            }

            var objStacked = stack.get(object);
            var othStacked = stack.get(other);

            if (objStacked && othStacked) {
              return objStacked == other && othStacked == object;
            }

            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;

            while (++index < objLength) {
              key = objProps[index];
              var objValue = object[key],
                  othValue = other[key];

              if (customizer) {
                var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
              }

              if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                result = false;
                break;
              }

              skipCtor || (skipCtor = key == "constructor");
            }

            if (result && !skipCtor) {
              var objCtor = object.constructor,
                  othCtor = other.constructor;

              if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
                result = false;
              }
            }

            stack["delete"](object);
            stack["delete"](other);
            return result;
          }

          module2.exports = equalObjects;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_freeGlobal.js": function packagesLogrocketUtilsNode_modulesLodash_freeGlobalJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var freeGlobal = typeof __webpack_require__2.g == "object" && __webpack_require__2.g && __webpack_require__2.g.Object === Object && __webpack_require__2.g;
          module2.exports = freeGlobal;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getAllKeys.js": function packagesLogrocketUtilsNode_modulesLodash_getAllKeysJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseGetAllKeys = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGetAllKeys.js"),
              getSymbols = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getSymbols.js"),
              keys = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/keys.js");

          function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
          }

          module2.exports = getAllKeys;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getMapData.js": function packagesLogrocketUtilsNode_modulesLodash_getMapDataJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isKeyable = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isKeyable.js");

          function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
          }

          module2.exports = getMapData;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getMatchData.js": function packagesLogrocketUtilsNode_modulesLodash_getMatchDataJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isStrictComparable = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isStrictComparable.js"),
              keys = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/keys.js");

          function getMatchData(object) {
            var result = keys(object),
                length = result.length;

            while (length--) {
              var key = result[length],
                  value = object[key];
              result[length] = [key, value, isStrictComparable(value)];
            }

            return result;
          }

          module2.exports = getMatchData;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getNative.js": function packagesLogrocketUtilsNode_modulesLodash_getNativeJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseIsNative = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIsNative.js"),
              getValue = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getValue.js");

          function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : void 0;
          }

          module2.exports = getNative;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getRawTag.js": function packagesLogrocketUtilsNode_modulesLodash_getRawTagJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var Symbol2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Symbol.js");

          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;
          var nativeObjectToString = objectProto.toString;
          var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;

          function getRawTag(value) {
            var isOwn = hasOwnProperty2.call(value, symToStringTag),
                tag = value[symToStringTag];

            try {
              value[symToStringTag] = void 0;
              var unmasked = true;
            } catch (e) {}

            var result = nativeObjectToString.call(value);

            if (unmasked) {
              if (isOwn) {
                value[symToStringTag] = tag;
              } else {
                delete value[symToStringTag];
              }
            }

            return result;
          }

          module2.exports = getRawTag;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getSymbols.js": function packagesLogrocketUtilsNode_modulesLodash_getSymbolsJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var arrayFilter = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_arrayFilter.js"),
              stubArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/stubArray.js");

          var objectProto = Object.prototype;
          var propertyIsEnumerable = objectProto.propertyIsEnumerable;
          var nativeGetSymbols = Object.getOwnPropertySymbols;
          var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
            if (object == null) {
              return [];
            }

            object = Object(object);
            return arrayFilter(nativeGetSymbols(object), function (symbol) {
              return propertyIsEnumerable.call(object, symbol);
            });
          };
          module2.exports = getSymbols;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getTag.js": function packagesLogrocketUtilsNode_modulesLodash_getTagJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var DataView = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_DataView.js"),
              Map2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Map.js"),
              Promise2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Promise.js"),
              Set2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Set.js"),
              WeakMap2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_WeakMap.js"),
              baseGetTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGetTag.js"),
              toSource = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_toSource.js");

          var mapTag = "[object Map]",
              objectTag = "[object Object]",
              promiseTag = "[object Promise]",
              setTag = "[object Set]",
              weakMapTag = "[object WeakMap]";
          var dataViewTag = "[object DataView]";
          var dataViewCtorString = toSource(DataView),
              mapCtorString = toSource(Map2),
              promiseCtorString = toSource(Promise2),
              setCtorString = toSource(Set2),
              weakMapCtorString = toSource(WeakMap2);
          var getTag = baseGetTag;

          if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
            getTag = function getTag(value) {
              var result = baseGetTag(value),
                  Ctor = result == objectTag ? value.constructor : void 0,
                  ctorString = Ctor ? toSource(Ctor) : "";

              if (ctorString) {
                switch (ctorString) {
                  case dataViewCtorString:
                    return dataViewTag;

                  case mapCtorString:
                    return mapTag;

                  case promiseCtorString:
                    return promiseTag;

                  case setCtorString:
                    return setTag;

                  case weakMapCtorString:
                    return weakMapTag;
                }
              }

              return result;
            };
          }

          module2.exports = getTag;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_getValue.js": function packagesLogrocketUtilsNode_modulesLodash_getValueJs(module2) {
          function getValue(object, key) {
            return object == null ? void 0 : object[key];
          }

          module2.exports = getValue;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_hasPath.js": function packagesLogrocketUtilsNode_modulesLodash_hasPathJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var castPath = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_castPath.js"),
              isArguments = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArguments.js"),
              isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js"),
              isIndex = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isIndex.js"),
              isLength = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isLength.js"),
              toKey = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_toKey.js");

          function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1,
                length = path.length,
                result = false;

            while (++index < length) {
              var key = toKey(path[index]);

              if (!(result = object != null && hasFunc(object, key))) {
                break;
              }

              object = object[key];
            }

            if (result || ++index != length) {
              return result;
            }

            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
          }

          module2.exports = hasPath;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_hashClear.js": function packagesLogrocketUtilsNode_modulesLodash_hashClearJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var nativeCreate = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_nativeCreate.js");

          function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
          }

          module2.exports = hashClear;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_hashDelete.js": function packagesLogrocketUtilsNode_modulesLodash_hashDeleteJs(module2) {
          function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
          }

          module2.exports = hashDelete;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_hashGet.js": function packagesLogrocketUtilsNode_modulesLodash_hashGetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var nativeCreate = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_nativeCreate.js");

          var HASH_UNDEFINED = "__lodash_hash_undefined__";
          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;

          function hashGet(key) {
            var data = this.__data__;

            if (nativeCreate) {
              var result = data[key];
              return result === HASH_UNDEFINED ? void 0 : result;
            }

            return hasOwnProperty2.call(data, key) ? data[key] : void 0;
          }

          module2.exports = hashGet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_hashHas.js": function packagesLogrocketUtilsNode_modulesLodash_hashHasJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var nativeCreate = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_nativeCreate.js");

          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;

          function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
          }

          module2.exports = hashHas;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_hashSet.js": function packagesLogrocketUtilsNode_modulesLodash_hashSetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var nativeCreate = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_nativeCreate.js");

          var HASH_UNDEFINED = "__lodash_hash_undefined__";

          function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
            return this;
          }

          module2.exports = hashSet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_isIndex.js": function packagesLogrocketUtilsNode_modulesLodash_isIndexJs(module2) {
          var MAX_SAFE_INTEGER = 9007199254740991;
          var reIsUint = /^(?:0|[1-9]\d*)$/;

          function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
          }

          module2.exports = isIndex;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_isKey.js": function packagesLogrocketUtilsNode_modulesLodash_isKeyJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArray.js"),
              isSymbol = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isSymbol.js");

          var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
              reIsPlainProp = /^\w*$/;

          function isKey(value, object) {
            if (isArray(value)) {
              return false;
            }

            var type = typeof value;

            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
              return true;
            }

            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
          }

          module2.exports = isKey;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_isKeyable.js": function packagesLogrocketUtilsNode_modulesLodash_isKeyableJs(module2) {
          function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
          }

          module2.exports = isKeyable;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_isMasked.js": function packagesLogrocketUtilsNode_modulesLodash_isMaskedJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var coreJsData = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_coreJsData.js");

          var maskSrcKey = function () {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
          }();

          function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
          }

          module2.exports = isMasked;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_isPrototype.js": function packagesLogrocketUtilsNode_modulesLodash_isPrototypeJs(module2) {
          var objectProto = Object.prototype;

          function isPrototype(value) {
            var Ctor = value && value.constructor,
                proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
          }

          module2.exports = isPrototype;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_isStrictComparable.js": function packagesLogrocketUtilsNode_modulesLodash_isStrictComparableJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isObject = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObject.js");

          function isStrictComparable(value) {
            return value === value && !isObject(value);
          }

          module2.exports = isStrictComparable;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_listCacheClear.js": function packagesLogrocketUtilsNode_modulesLodash_listCacheClearJs(module2) {
          function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
          }

          module2.exports = listCacheClear;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_listCacheDelete.js": function packagesLogrocketUtilsNode_modulesLodash_listCacheDeleteJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var assocIndexOf = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_assocIndexOf.js");

          var arrayProto = Array.prototype;
          var splice = arrayProto.splice;

          function listCacheDelete(key) {
            var data = this.__data__,
                index = assocIndexOf(data, key);

            if (index < 0) {
              return false;
            }

            var lastIndex = data.length - 1;

            if (index == lastIndex) {
              data.pop();
            } else {
              splice.call(data, index, 1);
            }

            --this.size;
            return true;
          }

          module2.exports = listCacheDelete;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_listCacheGet.js": function packagesLogrocketUtilsNode_modulesLodash_listCacheGetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var assocIndexOf = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_assocIndexOf.js");

          function listCacheGet(key) {
            var data = this.__data__,
                index = assocIndexOf(data, key);
            return index < 0 ? void 0 : data[index][1];
          }

          module2.exports = listCacheGet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_listCacheHas.js": function packagesLogrocketUtilsNode_modulesLodash_listCacheHasJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var assocIndexOf = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_assocIndexOf.js");

          function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
          }

          module2.exports = listCacheHas;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_listCacheSet.js": function packagesLogrocketUtilsNode_modulesLodash_listCacheSetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var assocIndexOf = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_assocIndexOf.js");

          function listCacheSet(key, value) {
            var data = this.__data__,
                index = assocIndexOf(data, key);

            if (index < 0) {
              ++this.size;
              data.push([key, value]);
            } else {
              data[index][1] = value;
            }

            return this;
          }

          module2.exports = listCacheSet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_mapCacheClear.js": function packagesLogrocketUtilsNode_modulesLodash_mapCacheClearJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var Hash = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Hash.js"),
              ListCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_ListCache.js"),
              Map2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Map.js");

          function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
              "hash": new Hash(),
              "map": new (Map2 || ListCache)(),
              "string": new Hash()
            };
          }

          module2.exports = mapCacheClear;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_mapCacheDelete.js": function packagesLogrocketUtilsNode_modulesLodash_mapCacheDeleteJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getMapData = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getMapData.js");

          function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
          }

          module2.exports = mapCacheDelete;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_mapCacheGet.js": function packagesLogrocketUtilsNode_modulesLodash_mapCacheGetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getMapData = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getMapData.js");

          function mapCacheGet(key) {
            return getMapData(this, key).get(key);
          }

          module2.exports = mapCacheGet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_mapCacheHas.js": function packagesLogrocketUtilsNode_modulesLodash_mapCacheHasJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getMapData = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getMapData.js");

          function mapCacheHas(key) {
            return getMapData(this, key).has(key);
          }

          module2.exports = mapCacheHas;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_mapCacheSet.js": function packagesLogrocketUtilsNode_modulesLodash_mapCacheSetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getMapData = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getMapData.js");

          function mapCacheSet(key, value) {
            var data = getMapData(this, key),
                size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
          }

          module2.exports = mapCacheSet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_mapToArray.js": function packagesLogrocketUtilsNode_modulesLodash_mapToArrayJs(module2) {
          function mapToArray(map) {
            var index = -1,
                result = Array(map.size);
            map.forEach(function (value, key) {
              result[++index] = [key, value];
            });
            return result;
          }

          module2.exports = mapToArray;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_matchesStrictComparable.js": function packagesLogrocketUtilsNode_modulesLodash_matchesStrictComparableJs(module2) {
          function matchesStrictComparable(key, srcValue) {
            return function (object) {
              if (object == null) {
                return false;
              }

              return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
            };
          }

          module2.exports = matchesStrictComparable;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_memoizeCapped.js": function packagesLogrocketUtilsNode_modulesLodash_memoizeCappedJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var memoize = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/memoize.js");

          var MAX_MEMOIZE_SIZE = 500;

          function memoizeCapped(func) {
            var result = memoize(func, function (key) {
              if (cache.size === MAX_MEMOIZE_SIZE) {
                cache.clear();
              }

              return key;
            });
            var cache = result.cache;
            return result;
          }

          module2.exports = memoizeCapped;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_nativeCreate.js": function packagesLogrocketUtilsNode_modulesLodash_nativeCreateJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var getNative = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_getNative.js");

          var nativeCreate = getNative(Object, "create");
          module2.exports = nativeCreate;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_nativeKeys.js": function packagesLogrocketUtilsNode_modulesLodash_nativeKeysJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var overArg = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_overArg.js");

          var nativeKeys = overArg(Object.keys, Object);
          module2.exports = nativeKeys;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_nodeUtil.js": function packagesLogrocketUtilsNode_modulesLodash_nodeUtilJs(module2, exports2, __webpack_require__2) {
          module2 = __webpack_require__2.nmd(module2);

          var freeGlobal = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_freeGlobal.js");

          var freeExports = exports2 && !exports2.nodeType && exports2;
          var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
          var moduleExports = freeModule && freeModule.exports === freeExports;
          var freeProcess = moduleExports && freeGlobal.process;

          var nodeUtil = function () {
            try {
              var types = freeModule && freeModule.require && freeModule.require("util").types;

              if (types) {
                return types;
              }

              return freeProcess && freeProcess.binding && freeProcess.binding("util");
            } catch (e) {}
          }();

          module2.exports = nodeUtil;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_objectToString.js": function packagesLogrocketUtilsNode_modulesLodash_objectToStringJs(module2) {
          var objectProto = Object.prototype;
          var nativeObjectToString = objectProto.toString;

          function objectToString(value) {
            return nativeObjectToString.call(value);
          }

          module2.exports = objectToString;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_overArg.js": function packagesLogrocketUtilsNode_modulesLodash_overArgJs(module2) {
          function overArg(func, transform) {
            return function (arg) {
              return func(transform(arg));
            };
          }

          module2.exports = overArg;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_root.js": function packagesLogrocketUtilsNode_modulesLodash_rootJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var freeGlobal = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_freeGlobal.js");

          var freeSelf = typeof self == "object" && self && self.Object === Object && self;
          var root = freeGlobal || freeSelf || Function("return this")();
          module2.exports = root;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_setCacheAdd.js": function packagesLogrocketUtilsNode_modulesLodash_setCacheAddJs(module2) {
          var HASH_UNDEFINED = "__lodash_hash_undefined__";

          function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);

            return this;
          }

          module2.exports = setCacheAdd;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_setCacheHas.js": function packagesLogrocketUtilsNode_modulesLodash_setCacheHasJs(module2) {
          function setCacheHas(value) {
            return this.__data__.has(value);
          }

          module2.exports = setCacheHas;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_setToArray.js": function packagesLogrocketUtilsNode_modulesLodash_setToArrayJs(module2) {
          function setToArray(set) {
            var index = -1,
                result = Array(set.size);
            set.forEach(function (value) {
              result[++index] = value;
            });
            return result;
          }

          module2.exports = setToArray;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_stackClear.js": function packagesLogrocketUtilsNode_modulesLodash_stackClearJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var ListCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_ListCache.js");

          function stackClear() {
            this.__data__ = new ListCache();
            this.size = 0;
          }

          module2.exports = stackClear;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_stackDelete.js": function packagesLogrocketUtilsNode_modulesLodash_stackDeleteJs(module2) {
          function stackDelete(key) {
            var data = this.__data__,
                result = data["delete"](key);
            this.size = data.size;
            return result;
          }

          module2.exports = stackDelete;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_stackGet.js": function packagesLogrocketUtilsNode_modulesLodash_stackGetJs(module2) {
          function stackGet(key) {
            return this.__data__.get(key);
          }

          module2.exports = stackGet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_stackHas.js": function packagesLogrocketUtilsNode_modulesLodash_stackHasJs(module2) {
          function stackHas(key) {
            return this.__data__.has(key);
          }

          module2.exports = stackHas;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_stackSet.js": function packagesLogrocketUtilsNode_modulesLodash_stackSetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var ListCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_ListCache.js"),
              Map2 = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_Map.js"),
              MapCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_MapCache.js");

          var LARGE_ARRAY_SIZE = 200;

          function stackSet(key, value) {
            var data = this.__data__;

            if (data instanceof ListCache) {
              var pairs = data.__data__;

              if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
                pairs.push([key, value]);
                this.size = ++data.size;
                return this;
              }

              data = this.__data__ = new MapCache(pairs);
            }

            data.set(key, value);
            this.size = data.size;
            return this;
          }

          module2.exports = stackSet;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_stringToPath.js": function packagesLogrocketUtilsNode_modulesLodash_stringToPathJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var memoizeCapped = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_memoizeCapped.js");

          var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
          var reEscapeChar = /\\(\\)?/g;
          var stringToPath = memoizeCapped(function (string) {
            var result = [];

            if (string.charCodeAt(0) === 46) {
              result.push("");
            }

            string.replace(rePropName, function (match, number, quote, subString) {
              result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
          });
          module2.exports = stringToPath;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_toKey.js": function packagesLogrocketUtilsNode_modulesLodash_toKeyJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isSymbol = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isSymbol.js");

          var INFINITY = 1 / 0;

          function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) {
              return value;
            }

            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
          }

          module2.exports = toKey;
        },
        "./packages/@logrocket/utils/node_modules/lodash/_toSource.js": function packagesLogrocketUtilsNode_modulesLodash_toSourceJs(module2) {
          var funcProto = Function.prototype;
          var funcToString = funcProto.toString;

          function toSource(func) {
            if (func != null) {
              try {
                return funcToString.call(func);
              } catch (e) {}

              try {
                return func + "";
              } catch (e) {}
            }

            return "";
          }

          module2.exports = toSource;
        },
        "./packages/@logrocket/utils/node_modules/lodash/eq.js": function packagesLogrocketUtilsNode_modulesLodashEqJs(module2) {
          function eq(value, other) {
            return value === other || value !== value && other !== other;
          }

          module2.exports = eq;
        },
        "./packages/@logrocket/utils/node_modules/lodash/get.js": function packagesLogrocketUtilsNode_modulesLodashGetJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseGet = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGet.js");

          function get(object, path, defaultValue) {
            var result = object == null ? void 0 : baseGet(object, path);
            return result === void 0 ? defaultValue : result;
          }

          module2.exports = get;
        },
        "./packages/@logrocket/utils/node_modules/lodash/hasIn.js": function packagesLogrocketUtilsNode_modulesLodashHasInJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseHasIn = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseHasIn.js"),
              hasPath = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_hasPath.js");

          function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
          }

          module2.exports = hasIn;
        },
        "./packages/@logrocket/utils/node_modules/lodash/identity.js": function packagesLogrocketUtilsNode_modulesLodashIdentityJs(module2) {
          function identity(value) {
            return value;
          }

          module2.exports = identity;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isArguments.js": function packagesLogrocketUtilsNode_modulesLodashIsArgumentsJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseIsArguments = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIsArguments.js"),
              isObjectLike = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObjectLike.js");

          var objectProto = Object.prototype;
          var hasOwnProperty2 = objectProto.hasOwnProperty;
          var propertyIsEnumerable = objectProto.propertyIsEnumerable;
          var isArguments = baseIsArguments(function () {
            return arguments;
          }()) ? baseIsArguments : function (value) {
            return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
          };
          module2.exports = isArguments;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isArray.js": function packagesLogrocketUtilsNode_modulesLodashIsArrayJs(module2) {
          var isArray = Array.isArray;
          module2.exports = isArray;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isArrayLike.js": function packagesLogrocketUtilsNode_modulesLodashIsArrayLikeJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var isFunction = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isFunction.js"),
              isLength = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isLength.js");

          function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
          }

          module2.exports = isArrayLike;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isBuffer.js": function packagesLogrocketUtilsNode_modulesLodashIsBufferJs(module2, exports2, __webpack_require__2) {
          module2 = __webpack_require__2.nmd(module2);

          var root = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_root.js"),
              stubFalse = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/stubFalse.js");

          var freeExports = exports2 && !exports2.nodeType && exports2;
          var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
          var moduleExports = freeModule && freeModule.exports === freeExports;
          var Buffer2 = moduleExports ? root.Buffer : void 0;
          var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
          var isBuffer = nativeIsBuffer || stubFalse;
          module2.exports = isBuffer;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isFunction.js": function packagesLogrocketUtilsNode_modulesLodashIsFunctionJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseGetTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGetTag.js"),
              isObject = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObject.js");

          var asyncTag = "[object AsyncFunction]",
              funcTag = "[object Function]",
              genTag = "[object GeneratorFunction]",
              proxyTag = "[object Proxy]";

          function isFunction(value) {
            if (!isObject(value)) {
              return false;
            }

            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
          }

          module2.exports = isFunction;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isLength.js": function packagesLogrocketUtilsNode_modulesLodashIsLengthJs(module2) {
          var MAX_SAFE_INTEGER = 9007199254740991;

          function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
          }

          module2.exports = isLength;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isObject.js": function packagesLogrocketUtilsNode_modulesLodashIsObjectJs(module2) {
          function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
          }

          module2.exports = isObject;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isObjectLike.js": function packagesLogrocketUtilsNode_modulesLodashIsObjectLikeJs(module2) {
          function isObjectLike(value) {
            return value != null && typeof value == "object";
          }

          module2.exports = isObjectLike;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isSymbol.js": function packagesLogrocketUtilsNode_modulesLodashIsSymbolJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseGetTag = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseGetTag.js"),
              isObjectLike = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isObjectLike.js");

          var symbolTag = "[object Symbol]";

          function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
          }

          module2.exports = isSymbol;
        },
        "./packages/@logrocket/utils/node_modules/lodash/isTypedArray.js": function packagesLogrocketUtilsNode_modulesLodashIsTypedArrayJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseIsTypedArray = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIsTypedArray.js"),
              baseUnary = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseUnary.js"),
              nodeUtil = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_nodeUtil.js");

          var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
          var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
          module2.exports = isTypedArray;
        },
        "./packages/@logrocket/utils/node_modules/lodash/keys.js": function packagesLogrocketUtilsNode_modulesLodashKeysJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var arrayLikeKeys = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_arrayLikeKeys.js"),
              baseKeys = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseKeys.js"),
              isArrayLike = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/isArrayLike.js");

          function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
          }

          module2.exports = keys;
        },
        "./packages/@logrocket/utils/node_modules/lodash/memoize.js": function packagesLogrocketUtilsNode_modulesLodashMemoizeJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var MapCache = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_MapCache.js");

          var FUNC_ERROR_TEXT = "Expected a function";

          function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") {
              throw new TypeError(FUNC_ERROR_TEXT);
            }

            var memoized = function memoized() {
              var args = arguments,
                  key = resolver ? resolver.apply(this, args) : args[0],
                  cache = memoized.cache;

              if (cache.has(key)) {
                return cache.get(key);
              }

              var result = func.apply(this, args);
              memoized.cache = cache.set(key, result) || cache;
              return result;
            };

            memoized.cache = new (memoize.Cache || MapCache)();
            return memoized;
          }

          memoize.Cache = MapCache;
          module2.exports = memoize;
        },
        "./packages/@logrocket/utils/node_modules/lodash/property.js": function packagesLogrocketUtilsNode_modulesLodashPropertyJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseProperty = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseProperty.js"),
              basePropertyDeep = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_basePropertyDeep.js"),
              isKey = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_isKey.js"),
              toKey = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_toKey.js");

          function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
          }

          module2.exports = property;
        },
        "./packages/@logrocket/utils/node_modules/lodash/sortedLastIndexBy.js": function packagesLogrocketUtilsNode_modulesLodashSortedLastIndexByJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseIteratee = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseIteratee.js"),
              baseSortedIndexBy = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseSortedIndexBy.js");

          function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, baseIteratee(iteratee, 2), true);
          }

          module2.exports = sortedLastIndexBy;
        },
        "./packages/@logrocket/utils/node_modules/lodash/stubArray.js": function packagesLogrocketUtilsNode_modulesLodashStubArrayJs(module2) {
          function stubArray() {
            return [];
          }

          module2.exports = stubArray;
        },
        "./packages/@logrocket/utils/node_modules/lodash/stubFalse.js": function packagesLogrocketUtilsNode_modulesLodashStubFalseJs(module2) {
          function stubFalse() {
            return false;
          }

          module2.exports = stubFalse;
        },
        "./packages/@logrocket/utils/node_modules/lodash/toString.js": function packagesLogrocketUtilsNode_modulesLodashToStringJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var baseToString = __webpack_require__2("./packages/@logrocket/utils/node_modules/lodash/_baseToString.js");

          function toString(value) {
            return value == null ? "" : baseToString(value);
          }

          module2.exports = toString;
        },
        "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js": function node_modulesBabelRuntimeHelpersArrayLikeToArrayJs(module2) {
          function _arrayLikeToArray(arr, len) {
            if (len == null || len > arr.length) len = arr.length;

            for (var i = 0, arr2 = new Array(len); i < len; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }

          module2.exports = _arrayLikeToArray, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/arrayWithHoles.js": function node_modulesBabelRuntimeHelpersArrayWithHolesJs(module2) {
          function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) return arr;
          }

          module2.exports = _arrayWithHoles, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js": function node_modulesBabelRuntimeHelpersArrayWithoutHolesJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var arrayLikeToArray = __webpack_require__2("./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

          function _arrayWithoutHoles(arr) {
            if (Array.isArray(arr)) return arrayLikeToArray(arr);
          }

          module2.exports = _arrayWithoutHoles, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/classCallCheck.js": function node_modulesBabelRuntimeHelpersClassCallCheckJs(module2) {
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }

          module2.exports = _classCallCheck, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/createClass.js": function node_modulesBabelRuntimeHelpersCreateClassJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var toPropertyKey = __webpack_require__2("./node_modules/@babel/runtime/helpers/toPropertyKey.js");

          function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
            }
          }

          function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            Object.defineProperty(Constructor, "prototype", {
              writable: false
            });
            return Constructor;
          }

          module2.exports = _createClass, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/defineProperty.js": function node_modulesBabelRuntimeHelpersDefinePropertyJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var toPropertyKey = __webpack_require__2("./node_modules/@babel/runtime/helpers/toPropertyKey.js");

          function _defineProperty(obj, key, value) {
            key = toPropertyKey(key);

            if (key in obj) {
              Object.defineProperty(obj, key, {
                value,
                enumerable: true,
                configurable: true,
                writable: true
              });
            } else {
              obj[key] = value;
            }

            return obj;
          }

          module2.exports = _defineProperty, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/interopRequireDefault.js": function node_modulesBabelRuntimeHelpersInteropRequireDefaultJs(module2) {
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
              "default": obj
            };
          }

          module2.exports = _interopRequireDefault, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/iterableToArray.js": function node_modulesBabelRuntimeHelpersIterableToArrayJs(module2) {
          function _iterableToArray(iter) {
            if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
          }

          module2.exports = _iterableToArray, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js": function node_modulesBabelRuntimeHelpersIterableToArrayLimitJs(module2) {
          function _iterableToArrayLimit(arr, i) {
            var _i = arr == null ? null : typeof Symbol != "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

            if (_i != null) {
              var _s,
                  _e,
                  _x,
                  _r,
                  _arr = [],
                  _n = true,
                  _d = false;

              try {
                if (_x = (_i = _i.call(arr)).next, i === 0) {
                  if (Object(_i) !== _i) return;
                  _n = false;
                } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = true) {
                  ;
                }
              } catch (err) {
                _d = true, _e = err;
              } finally {
                try {
                  if (!_n && _i["return"] != null && (_r = _i["return"](), Object(_r) !== _r)) return;
                } finally {
                  if (_d) throw _e;
                }
              }

              return _arr;
            }
          }

          module2.exports = _iterableToArrayLimit, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/nonIterableRest.js": function node_modulesBabelRuntimeHelpersNonIterableRestJs(module2) {
          function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          module2.exports = _nonIterableRest, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/nonIterableSpread.js": function node_modulesBabelRuntimeHelpersNonIterableSpreadJs(module2) {
          function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          module2.exports = _nonIterableSpread, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js": function node_modulesBabelRuntimeHelpersObjectWithoutPropertiesJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var objectWithoutPropertiesLoose = __webpack_require__2("./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");

          function _objectWithoutProperties(source, excluded) {
            if (source == null) return {};
            var target = objectWithoutPropertiesLoose(source, excluded);
            var key, i;

            if (Object.getOwnPropertySymbols) {
              var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

              for (i = 0; i < sourceSymbolKeys.length; i++) {
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
              }
            }

            return target;
          }

          module2.exports = _objectWithoutProperties, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js": function node_modulesBabelRuntimeHelpersObjectWithoutPropertiesLooseJs(module2) {
          function _objectWithoutPropertiesLoose(source, excluded) {
            if (source == null) return {};
            var target = {};
            var sourceKeys = Object.keys(source);
            var key, i;

            for (i = 0; i < sourceKeys.length; i++) {
              key = sourceKeys[i];
              if (excluded.indexOf(key) >= 0) continue;
              target[key] = source[key];
            }

            return target;
          }

          module2.exports = _objectWithoutPropertiesLoose, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/slicedToArray.js": function node_modulesBabelRuntimeHelpersSlicedToArrayJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var arrayWithHoles = __webpack_require__2("./node_modules/@babel/runtime/helpers/arrayWithHoles.js");

          var iterableToArrayLimit = __webpack_require__2("./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js");

          var unsupportedIterableToArray = __webpack_require__2("./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");

          var nonIterableRest = __webpack_require__2("./node_modules/@babel/runtime/helpers/nonIterableRest.js");

          function _slicedToArray(arr, i) {
            return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
          }

          module2.exports = _slicedToArray, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js": function node_modulesBabelRuntimeHelpersToConsumableArrayJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var arrayWithoutHoles = __webpack_require__2("./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

          var iterableToArray = __webpack_require__2("./node_modules/@babel/runtime/helpers/iterableToArray.js");

          var unsupportedIterableToArray = __webpack_require__2("./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");

          var nonIterableSpread = __webpack_require__2("./node_modules/@babel/runtime/helpers/nonIterableSpread.js");

          function _toConsumableArray(arr) {
            return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
          }

          module2.exports = _toConsumableArray, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/toPrimitive.js": function node_modulesBabelRuntimeHelpersToPrimitiveJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var _typeof = __webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js")["default"];

          function _toPrimitive(input, hint) {
            if (_typeof(input) !== "object" || input === null) return input;
            var prim = input[Symbol.toPrimitive];

            if (prim !== void 0) {
              var res = prim.call(input, hint || "default");
              if (_typeof(res) !== "object") return res;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }

            return (hint === "string" ? String : Number)(input);
          }

          module2.exports = _toPrimitive, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/toPropertyKey.js": function node_modulesBabelRuntimeHelpersToPropertyKeyJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var _typeof = __webpack_require__2("./node_modules/@babel/runtime/helpers/typeof.js")["default"];

          var toPrimitive = __webpack_require__2("./node_modules/@babel/runtime/helpers/toPrimitive.js");

          function _toPropertyKey(arg) {
            var key = toPrimitive(arg, "string");
            return _typeof(key) === "symbol" ? key : String(key);
          }

          module2.exports = _toPropertyKey, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/typeof.js": function node_modulesBabelRuntimeHelpersTypeofJs(module2) {
          function _typeof(obj) {
            "@babel/helpers - typeof";

            return module2.exports = _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (obj2) {
              return typeof obj2;
            } : function (obj2) {
              return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
            }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof(obj);
          }

          module2.exports = _typeof, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        },
        "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js": function node_modulesBabelRuntimeHelpersUnsupportedIterableToArrayJs(module2, __unused_webpack_exports, __webpack_require__2) {
          var arrayLikeToArray = __webpack_require__2("./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

          function _unsupportedIterableToArray(o, minLen) {
            if (!o) return;
            if (typeof o === "string") return arrayLikeToArray(o, minLen);
            var n2 = Object.prototype.toString.call(o).slice(8, -1);
            if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
            if (n2 === "Map" || n2 === "Set") return Array.from(o);
            if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return arrayLikeToArray(o, minLen);
          }

          module2.exports = _unsupportedIterableToArray, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
        }
      };
      var __webpack_module_cache__ = {};

      function __webpack_require__(moduleId) {
        var cachedModule = __webpack_module_cache__[moduleId];

        if (cachedModule !== void 0) {
          return cachedModule.exports;
        }

        var module2 = __webpack_module_cache__[moduleId] = {
          id: moduleId,
          loaded: false,
          exports: {}
        };

        __webpack_modules__[moduleId](module2, module2.exports, __webpack_require__);

        module2.loaded = true;
        return module2.exports;
      }

      !function () {
        __webpack_require__.g = function () {
          if (typeof globalThis === "object") return globalThis;

          try {
            return this || new Function("return this")();
          } catch (e) {
            if (typeof window === "object") return window;
          }
        }();
      }();
      !function () {
        __webpack_require__.nmd = function (module2) {
          module2.paths = [];
          if (!module2.children) module2.children = [];
          return module2;
        };
      }();
      var __webpack_exports__ = {};
      !function () {
        var exports2 = __webpack_exports__;
        /*!**********************************************!*\
          !*** ./packages/logrocket/src/module-npm.js ***!
          \**********************************************/

        var _interopRequireDefault = __webpack_require__("./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

        Object.defineProperty(exports2, "__esModule", {
          value: true
        });
        exports2["default"] = void 0;

        var _setup = _interopRequireDefault(__webpack_require__("./packages/logrocket/src/setup.js"));

        var instance = (0, _setup.default)();
        var _default = instance;
        exports2["default"] = _default;
      }();
      __webpack_exports__ = __webpack_exports__["default"];
      return __webpack_exports__;
    }();
  });
})(build_umd);

var LogRocket = /* @__PURE__ */getDefaultExportFromCjs(build_umd.exports);
var dist = {
  exports: {}
};

(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = setupReact;
  var _reactDom = require$$0;
  var getInstanceFromNode = void 0;
  var secret = _reactDom.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

  if (secret && secret.Events && secret.Events[0]) {
    getInstanceFromNode = secret.Events[0];
  } else {
    console.warn("logrocket-react does not work with this version of React");
  }

  function setupReact() {
    var listener = function listener2(event) {
      try {
        var fiberNode = getInstanceFromNode(event.target);
        var names = [];
        var currentElement = fiberNode;

        while (currentElement) {
          var name = typeof currentElement.elementType === "function" && currentElement.elementType.displayName;

          if (name) {
            names.push(name);
          }

          currentElement = currentElement.return;
        }

        event.__lrName = names;
      } catch (err) {
        console.error("logrocket-react caught an error while hooking into React. Please make sure you are using the correct version of logrocket-react for your version of react-dom.");
      }
    };

    document.body.addEventListener("click", listener, {
      capture: true,
      passive: true
    });
  }

  module.exports = exports["default"];
})(dist, dist.exports);

var setupLogrocketReact = /* @__PURE__ */getDefaultExportFromCjs(dist.exports);

class LogrocketFuzzySearch {
  constructor(privateFields, privateHeaders) {
    this.fields = [];
    this.omittedHeaders = [];
    this.fields = privateFields;
    this.omittedHeaders = privateHeaders || [];
  }

  static setup(fields, omittedHeaders) {
    var instance = new LogrocketFuzzySearch(fields, omittedHeaders);
    return {
      requestSanitizer: instance.requestSanitizer.bind(instance),
      responseSanitizer: instance.responseSanitizer.bind(instance)
    };
  }

  requestSanitizer(request) {
    if (this._isExternalDomainNetworkRequest(request)) {
      return null;
    }

    if (request.method === "GET") {
      return request;
    }

    return this._networkHandler(request);
  }

  responseSanitizer(reponse) {
    return this._networkHandler(reponse);
  }

  _networkHandler(networkRequestReponse) {
    var body = networkRequestReponse.body,
        headers = networkRequestReponse.headers;
    var requestContentType = headers && (headers["Content-Type"] || "");
    var isUrlEncodedRequest = requestContentType.includes("form-urlencoded");
    var parsedBody;
    var parsedHeaders;

    try {
      if (body) {
        parsedBody = isUrlEncodedRequest ? this._deparameterize(body) : JSON.parse(body);

        this._searchBody(parsedBody);
      }

      parsedHeaders = this._searchHeaders(headers);
    } catch (error) {
      return networkRequestReponse;
    }

    networkRequestReponse.body = parsedBody;
    networkRequestReponse.headers = parsedHeaders;
    return networkRequestReponse;
  }

  _isExternalDomainNetworkRequest(request) {
    return !request.url.includes("drift.com") && !request.url.includes("driftqa.com") && !request.url.includes("localhost");
  }

  _searchHeaders(headers) {
    var resultHeaders = _objectSpread2({}, headers);

    this.omittedHeaders.forEach(headerToOmit => {
      if (Object.prototype.hasOwnProperty.call(resultHeaders, headerToOmit)) {
        resultHeaders[headerToOmit] = "*";
      }
    });
    return resultHeaders;
  }

  _searchBody(body = {}) {
    if (body.constructor === Array) {
      body.forEach(item => this._searchBody(item));
    } else {
      for (var key in body) {
        if (Object.prototype.hasOwnProperty.call(body, key)) {
          var keyName = body[key];
          var isTypeValuePair = key === "type" && "value" in body;

          if (typeof keyName === "object") {
            if (!isTypeValuePair) {
              this._searchBody(keyName);
            }
          }

          if (isTypeValuePair) {
            this._mask(body, body.type, "value");
          } else {
            this._mask(body, key);
          }
        }
      }
    }
  }

  _mask(body, searchKeyName, maskKeyName) {
    maskKeyName = maskKeyName || searchKeyName;

    var isSensitiveFieldName = this._match(searchKeyName);

    if (isSensitiveFieldName) {
      body[maskKeyName] = "*";
    }
  }

  _match(keyName = "") {
    var fields = this.fields;
    var normalizedKeyName = keyName.toLowerCase();
    return fields.some(field => normalizedKeyName.indexOf(field.toLowerCase()) > -1);
  }

  _deparameterize(urlEncodedString) {
    var paramsArray = urlEncodedString.split("&");
    var paramsObject = {};
    paramsArray.forEach(paramString => {
      var _paramString$split = paramString.split("="),
          _paramString$split2 = _slicedToArray3(_paramString$split, 2),
          key = _paramString$split2[0],
          value = _paramString$split2[1];

      paramsObject[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    return paramsObject;
  }

}

var DRIFT_DDS_PREFIX = "drift-dds";

var handleRequestAnimationFrame = () => {
  var elements = document.querySelectorAll("head style");

  if (!elements.length) {
    return "";
  }

  return Array.from(elements).reduce((previousValue, element) => {
    if (element.dataset.logrocketSync) {
      return previousValue;
    }

    if (!element.sheet) {
      return previousValue;
    }

    var rulesString = Array.from(element.sheet.cssRules).reduce((previousRuleValue, rule) => {
      if (!rule.cssText.includes(DRIFT_DDS_PREFIX)) {
        return previousRuleValue;
      }

      return previousRuleValue.concat(rule.cssText);
    }, []).join(" ");
    return previousValue.concat(rulesString);
  }, []).join(" ");
};

var detectDDSStyles = () => {
  if (typeof window === "undefined") {
    return;
  }

  var syncStyles = document.createElement("style");
  syncStyles.dataset.logrocketSync = "true";
  syncStyles.type = "text/css";
  document.head.insertBefore(syncStyles, document.head.children[0]);
  var intervalID = window.setInterval(() => {
    var isLogrocketLoaded = window == null ? void 0 : window._lr_loaded;

    if (!isLogrocketLoaded) {
      return;
    }

    window.clearInterval(intervalID);
    var lastStyles;
    window.setInterval(() => {
      window.requestAnimationFrame(() => {
        var styles = handleRequestAnimationFrame();

        if (styles === lastStyles) {
          return;
        }

        syncStyles.textContent = styles;
        lastStyles = styles;
      });
    }, 500);
  }, 50);
};

var identifiedUserId = "";
var REDACTED_NETWORK_FIELDS = ["email", "emailAddress", "phone", "socialProfile", "firstName", "lastName", "name", "phoneNumber", "access_token"];
var REDACTED_HEADERS = ["Authorization"];
var DEFAULT_OPTIONS = {
  domRecordingEnabled: true,
  networkTrackingEnabled: true
};
var LogrocketProvider = {
  initialize: (options = DEFAULT_OPTIONS) => {
    var _LogrocketFuzzySearch = LogrocketFuzzySearch.setup(REDACTED_NETWORK_FIELDS, REDACTED_HEADERS),
        requestSanitizer = _LogrocketFuzzySearch.requestSanitizer,
        responseSanitizer = _LogrocketFuzzySearch.responseSanitizer;

    LogRocket.init("".concat(config.LOGROCKET_KEY, "/").concat(options.projectId || config.LOGROCKET_APP_PROJECT), {
      release: options.release || window.___DRIFT_RELEASE,
      dom: {
        isEnabled: options.domRecordingEnabled
      },
      network: {
        isEnabled: options.networkTrackingEnabled,
        requestSanitizer,
        responseSanitizer
      },
      browser: {
        urlSanitizer: url => {
          var sanitizedUrl = url;
          sanitizedUrl = sanitizedUrl.replace(/token=([^&]*)/, "impersonation_token=REDACTED");
          return sanitizedUrl;
        }
      }
    });
    setupLogrocketReact(LogRocket);
    detectDDSStyles();
  },
  track: (eventName, metadata = {}) => {
    LogRocket.track(eventName, metadata);
  },
  identify: (userId, metadata = {}) => {
    identifiedUserId = userId;
    LogRocket.identify(userId, metadata);
  },
  setUserAttributes: userAttributes => {
    if (identifiedUserId === "") {
      console.warn("LogRocket.setUserAttributes called before LogRocket.identify");
      return;
    }

    LogRocket.identify(identifiedUserId, userAttributes);
  },
  captureException: (error, extra) => {
    typeof error === "string" ? LogRocket.captureMessage(error, extra) : LogRocket.captureException(error, extra);
  },
  isInitialized: (window == null ? void 0 : window._lr_loaded) || false
};
var SegmentProvider = {
  track: (eventName, metadata = {}, user) => {
    if (!window.analytics) {
      return;
    }

    var metadataWithUserInfo = Object.assign({}, metadata, {
      email: user.email,
      orgId: user.orgId
    });
    window.analytics.track(eventName, metadataWithUserInfo);
  },
  isInitialized: !!(window == null ? void 0 : window.analytics) || false
};

var toJoinedStringObject = obj => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      acc[key] = value.join(",");
    } else {
      acc[key] = value;
    }

    return acc;
  }, {});
};

function _isPlaceholder(a) {
  return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}

function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;

      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });

      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

var pick = /* @__PURE__ */_curry2(function pick2(names, obj) {
  var result = {};
  var idx = 0;

  while (idx < names.length) {
    if (names[idx] in obj) {
      result[names[idx]] = obj[names[idx]];
    }

    idx += 1;
  }

  return result;
});

var pick$1 = pick;

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function") ref(value);else if (ref !== null && ref !== void 0) ref.current = value;
}

function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return node => refs.forEach(ref => $6ed0406888f73fc4$var$setRef(ref, node));
}

var $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var children = props.children,
      slotProps = _objectWithoutProperties3(props, ["children"]);

  var childrenArray = Children.toArray(children);
  var slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);

  if (slottable) {
    var newElement = slottable.props.children;
    var newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }

  return /* @__PURE__ */createElement($5e63c961fc1ce211$var$SlotClone, _extends({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
var $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var children = props.children,
      slotProps = _objectWithoutProperties3(props, ["children"]);

  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, _objectSpread2(_objectSpread2({}, $5e63c961fc1ce211$var$mergeProps(slotProps, children.props)), {}, {
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref)
  }));
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";

var $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({
  children
}) => {
  return /* @__PURE__ */createElement(Fragment, null, children);
};

function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}

function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  var overrideProps = _objectSpread2({}, childProps);

  var _loop3 = function _loop3(propName) {
    var slotPropValue = slotProps[propName];
    var childPropValue = childProps[propName];
    var isHandler = /^on[A-Z]/.test(propName);

    if (isHandler) {
      if (slotPropValue && childPropValue) overrideProps[propName] = (...args) => {
        childPropValue(...args);
        slotPropValue(...args);
      };else if (slotPropValue) overrideProps[propName] = slotPropValue;
    } else if (propName === "style") overrideProps[propName] = _objectSpread2(_objectSpread2({}, slotPropValue), childPropValue);else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  };

  for (var propName in childProps) {
    _loop3(propName);
  }

  return _objectSpread2(_objectSpread2({}, slotProps), overrideProps);
}

var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    var test1 = new String("abc");
    test1[5] = "de";

    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }

    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n2) {
      return test2[n2];
    });

    if (order2.join("") !== "0123456789") {
      return false;
    }

    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }

    return true;
  } catch (err) {
    return false;
  }
}

shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f = require$$0$1,
    g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;

if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}

var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    n = Object.prototype.hasOwnProperty,
    p = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

function q(c, a, k) {
  var b,
      d = {},
      e = null,
      l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);

  for (b in a) {
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  }

  if (c && c.defaultProps) for (b in a = c.defaultProps, a) {
    d[b] === void 0 && (d[b] = a[b]);
  }
  return {
    $$typeof: g,
    type: c,
    key: e,
    ref: l,
    props: d,
    _owner: m.current
  };
}

reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
var jsx = jsxRuntime.exports.jsx;

var ExcludeFromRecording = ({
  children
}) => /* @__PURE__ */jsx($5e63c961fc1ce211$export$8c6ed5c666ac1360, {
  "data-private": true,
  children
});

var USER_ATTRIBUTES = ["email", "name", "id", "bot", "scopes", "roles", "orgId"];
var environment = window.__ENV__ === "PRODUCTION" ? "production" : "qa";
var driftUser = null;
var DriftAnalytics = {
  initialize: ({
    user,
    options = {
      logrocket: DEFAULT_OPTIONS
    }
  }) => {
    driftUser = user;
    LogrocketProvider.initialize(options.logrocket);
    LogrocketProvider.identify(user.id.toString(), _objectSpread2({
      environment
    }, toJoinedStringObject(pick$1(USER_ATTRIBUTES, user))));
  },
  track: (event, properties = {}) => {
    LogrocketProvider.track(event, properties);

    if (driftUser) {
      SegmentProvider.track(event, properties, driftUser);
    }
  },
  setUserAttributes: attributes => {
    LogrocketProvider.setUserAttributes(attributes);
  },
  captureException: (exception, extra) => {
    LogrocketProvider.captureException(exception, extra);
  }
};
export { DriftAnalytics, ExcludeFromRecording };